(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4235,6792],{

/***/ "./node_modules/@everipedia/web3-signer/dist/src/index.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = true;
exports.T = exports.Xx = void 0;
var sign_1 = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/lib/sign.js");
exports.Xx = sign_1.sign;
var verify_1 = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/lib/verify.js");
exports.T = verify_1.verify;
var Web3Sign = {
    sign: sign_1.sign,
    verify: verify_1.verify
};
__webpack_unused_export__ = Web3Sign;


/***/ }),

/***/ "./node_modules/@everipedia/web3-signer/dist/src/lib/decrypter.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("./node_modules/buffer/index.js")["lW"];

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.decrypt = void 0;
var base_64_1 = __importDefault(__webpack_require__("./node_modules/base-64/base64.js"));
var utils_1 = __webpack_require__("./node_modules/@everipedia/web3-signer/node_modules/viem/dist/utils/index.mjs");
/**
 * Retrieves the version number from the body of a token.
 *
 * @param body - The body of the token.
 * @returns The version number.
 * @throws An error if the token is malformed or the version number is missing.
 */
var getVersion = function (body) {
    var match = body.match(/Web3[\s-]+Token[\s-]+Version: \d/);
    if (!match || !match.length) {
        throw new Error('Token malformed (missing version)');
    }
    return Number(match[0].replace(' ', '').split(':')[1]);
};
/**
 * Decrypts a token and returns the result.
 *
 * @param token - The token to decrypt.
 * @returns The result of the decryption.
 * @throws An error if the token is empty, not base64 encoded, unparsable JSON, or malformed in some other way.
 */
var decrypt = function (token) {
    var _a;
    if (!token || !token.length) {
        throw new Error('Token required.');
    }
    var base64_decoded = base_64_1["default"].decode(token);
    if (!base64_decoded || !base64_decoded.length) {
        throw new Error('Token malformed (must be base64 encoded)');
    }
    var body, signature;
    try {
        (_a = JSON.parse(base64_decoded), body = _a.body, signature = _a.signature);
    }
    catch (error) {
        throw new Error('Token malformed (unparsable JSON)');
    }
    if (!body || !body.length) {
        throw new Error('Token malformed (empty message)');
    }
    if (!signature || !signature.length) {
        throw new Error('Token malformed (empty signature)');
    }
    var signatureBuffer = Buffer.from(signature.slice(2), 'hex');
    var address = (0, utils_1.recoverMessageAddress)({
        message: body,
        signature: signatureBuffer
    });
    var version = getVersion(body);
    return {
        version: version,
        address: address.toLowerCase(),
        body: body,
        signature: signature
    };
};
exports.decrypt = decrypt;


/***/ }),

/***/ "./node_modules/@everipedia/web3-signer/dist/src/lib/sign.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sign = void 0;
var base_64_1 = __importDefault(__webpack_require__("./node_modules/base-64/base64.js"));
var timespan_1 = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/lib/timespan.js");
var utils_1 = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/lib/utils.js");
/**
 * Sign a token
 * @param signer - A function that returns a signature string (Promise<string>)
 * @param opts - Options to sign the token
 * @returns A signed token
 * @example
 * ```ts
 * import { sign } from 'web3-signer';
 *
 * const token = await sign(signer, {
 *  domain: 'example.com',
 *  expires_in: '1d',
 * });
 * ```
 *
 * More examples refer to [README.md](https://github.com/EveripediaNetwork/web3-signer/blob/master/README.md)
 **/
var sign = function (signer, opts) {
    if (opts === void 0) { opts = '1d'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var params, body, msg, signature, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = typeof opts === 'string' ? { expires_in: opts } : opts;
                    validateParams(params);
                    body = processParams(params);
                    msg = buildMessage(body);
                    return [4 /*yield*/, signer(msg)];
                case 1:
                    signature = _a.sent();
                    if (typeof signature !== 'string') {
                        throw new Error('"signer" argument should be a function that returns a signature string (Promise<string>)');
                    }
                    token = base_64_1["default"].encode(JSON.stringify({ signature: signature, body: msg }));
                    return [2 /*return*/, token];
            }
        });
    });
};
exports.sign = sign;
/**
 * Validate params
 * @param params - Params to validate
 * @returns void
 * @throws Error if params are invalid
 **/
var validateParams = function (params) {
    for (var key in params) {
        var value = params[key];
        if (typeof value === 'string' && /\n/.test(value)) {
            throw new Error("\"".concat(key, "\" option cannot have LF (\\n)"));
        }
    }
    if (params.domain !== undefined) {
        var domain = params.domain;
        if (!(0, utils_1.isValidString)(domain) || !(0, utils_1.isValidDomain)(domain)) {
            throw new Error('Invalid domain format (must be example.com)');
        }
    }
    if (params.uri !== undefined) {
        var uri = params.uri;
        if (!(0, utils_1.isValidString)(uri) || !(0, utils_1.isURL)(uri)) {
            throw new Error('Invalid uri format (must be https://example.com/login)');
        }
    }
    if (params.chain_id !== undefined) {
        var chainId = params.chain_id;
        if (!(0, utils_1.isNumber)(chainId)) {
            throw new Error('chain_id must be an int');
        }
    }
    if (params.expiration_time !== undefined) {
        var expirationTime = params.expiration_time;
        if (!(0, utils_1.isDate)(expirationTime)) {
            throw new Error('expiration_time must be an instance of Date');
        }
    }
    if (params.not_before !== undefined) {
        var notBefore = params.not_before;
        if (!(0, utils_1.isDate)(notBefore)) {
            throw new Error('not_before must be an instance of Date');
        }
    }
};
/**
 * Process params
 * @param params - Params to process
 * @returns Processed params
 **/
var processParams = function (params) {
    var _a;
    var body = {
        web3_token_version: '2',
        issued_at: new Date(),
        expiration_time: params.expiration_time
            ? new Date(params.expiration_time)
            : params.expires_in
                ? (0, timespan_1.timeSpan)(params.expires_in)
                : (0, timespan_1.timeSpan)('1d'),
        not_before: params.not_before ? new Date(params.not_before) : undefined,
        chain_id: params.chain_id ? parseInt(String(params.chain_id)) : undefined,
        uri: params.uri ||
            (typeof window !== 'undefined' && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.href)) ||
            undefined,
        nonce: params.nonce
            ? parseInt(String(Math.random() * 99999999))
            : undefined,
        request_id: params.request_id,
        domain: params.domain,
        statement: params.statement
    };
    return body;
};
/**
 * Build message
 * @param params - Params to build message
 * @returns Message
 **/
var buildMessage = function (params) {
    var message = [];
    if (params.domain) {
        message.push("".concat(params.domain, " wants you to sign in with your Ethereum account."));
        message.push('');
    }
    if (params.statement) {
        message.push(params.statement);
        message.push('');
    }
    var paramLabels = {
        URI: params.uri,
        'Web3 Token Version': params.web3_token_version,
        'Chain ID': params.chain_id,
        Nonce: params.nonce,
        'Issued At': params.issued_at.toISOString(),
        'Expiration Time': params.expiration_time.toISOString(),
        'Not Before': params.not_before
            ? params.not_before.toISOString()
            : undefined,
        'Request ID': params.request_id
    };
    for (var label in paramLabels) {
        var value = paramLabels[label];
        if (value !== undefined) {
            message.push("".concat(label, ": ").concat(value));
        }
    }
    return message.join('\n');
};


/***/ }),

/***/ "./node_modules/@everipedia/web3-signer/dist/src/lib/timespan.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.timeSpan = void 0;
var ms_1 = __importDefault(__webpack_require__("./node_modules/ms/index.js"));
var timeSpan = function (val) {
    var err_str = '"expires_in" argument should be a number of milliseconds or a string representing a timespan eg: "1d", "20h", 60';
    if (typeof val === 'string') {
        var milliseconds = (0, ms_1["default"])(val);
        if (typeof milliseconds === 'undefined') {
            throw new Error(err_str);
        }
        return new Date(Date.now() + milliseconds);
    }
    else if (typeof val === 'number') {
        return new Date(Date.now() + val);
    }
    else {
        throw new Error(err_str);
    }
};
exports.timeSpan = timeSpan;


/***/ }),

/***/ "./node_modules/@everipedia/web3-signer/dist/src/lib/utils.js":
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.isDate = exports.isNumber = exports.isURL = exports.isValidDomain = exports.isValidString = void 0;
var isValidString = function (value) {
    return typeof value === 'string' && value.trim().length > 0;
};
exports.isValidString = isValidString;
var isValidDomain = function (value) {
    var domainRegex = /^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,}$/i;
    return domainRegex.test(value);
};
exports.isValidDomain = isValidDomain;
var isURL = function (value) {
    try {
        new URL(value);
        return true;
    }
    catch (err) {
        return false;
    }
};
exports.isURL = isURL;
var isNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
exports.isNumber = isNumber;
var isDate = function (value) {
    return value instanceof Date;
};
exports.isDate = isDate;


/***/ }),

/***/ "./node_modules/@everipedia/web3-signer/dist/src/lib/verify.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.verify = void 0;
var parse_headers_1 = __importDefault(__webpack_require__("./node_modules/parse-headers/parse-headers.js"));
var decrypter_1 = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/lib/decrypter.js");
/**
 * Parses the lines of a message into an array of message sections.
 * @param lines - The lines of the message.
 * @returns An array of message sections.
 */
function splitSections(lines) {
    var sections = [[]];
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var line = lines_1[_i];
        if (line === '') {
            sections.push([]);
        }
        else {
            sections[sections.length - 1].push(line);
        }
    }
    return sections;
}
/**
 * Extracts the domain from an array of message sections.
 * @param sections - An array of message sections.
 * @returns The domain, or `null` if it cannot be extracted.
 */
function extractTokenDomain(sections) {
    var lastLine = sections[0][sections[0].length - 1];
    if (lastLine.endsWith(' wants you to sign in with your Ethereum account.')) {
        return lastLine
            .replace(' wants you to sign in with your Ethereum account.', '')
            .trim();
    }
    return null;
}
/**
 * Extracts the statement from an array of message sections.
 * @param sections - An array of message sections.
 * @returns The statement, or `null` if it cannot be extracted.
 */
function extractTokenStatement(sections) {
    if (sections.length === 2 && !extractTokenDomain(sections)) {
        return sections[0][0];
    }
    if (sections.length === 3) {
        return sections[1][0];
    }
    return null;
}
/**
 * Parses the decrypted body of a token.
 * @param lines - The lines of the decrypted body.
 * @returns The parsed decrypted body.
 * @throws An error if the decrypted body is damaged.
 */
var parseBody = function (lines) {
    var bodySections = splitSections(lines);
    var mainBodySection = bodySections[bodySections.length - 1].join('\n');
    var parsedHeaders = (0, parse_headers_1["default"])(mainBodySection);
    for (var key in parsedHeaders) {
        var hyphenatedKey = key.replace(/ /g, '-');
        parsedHeaders[hyphenatedKey] =
            parsedHeaders[key];
        if (hyphenatedKey !== key) {
            delete parsedHeaders[key];
        }
    }
    var tokenDomain = extractTokenDomain(bodySections);
    var tokenStatement = extractTokenStatement(bodySections);
    if (typeof parsedHeaders['issued-at'] === 'undefined' ||
        typeof parsedHeaders['expiration-time'] === 'undefined' ||
        typeof parsedHeaders['web3-token-version'] === 'undefined') {
        throw new Error('Decrypted body is damaged');
    }
    return __assign(__assign({}, parsedHeaders), { domain: tokenDomain || undefined, statement: tokenStatement || undefined });
};
/**
 * Verifies a token.
 * @param token - The token to verify.
 * @param opts - The options for verifying the token.
 * @returns The verified token.
 * @throws An error if the token is expired, not yet valid, has an inappropriate domain, or is version 1.
 */
var verify = function (token, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = (0, decrypter_1.decrypt)(token), version = _a.version, address = _a.address, body = _a.body;
    if (version === 1) {
        throw new Error('Tokens version 1 are not supported by the current version of module');
    }
    var lines = body.split('\n');
    var parsed_body = parseBody(lines);
    if (new Date(parsed_body['expiration-time']) < new Date()) {
        throw new Error('Token expired');
    }
    if (parsed_body['not-before'] &&
        new Date(parsed_body['not-before']) > new Date()) {
        throw new Error("It's not yet time to use the token");
    }
    if (opts.domain && opts.domain !== parsed_body.domain) {
        throw new Error('Inappropriate token domain');
    }
    return { address: address, body: parsed_body };
};
exports.verify = verify;


/***/ }),

/***/ "./node_modules/base-64/base64.js":
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '1.0.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return base64;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ }),

/***/ "./node_modules/isomorphic-ws/browser.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js

var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof __webpack_require__.g !== 'undefined') {
  ws = __webpack_require__.g.WebSocket || __webpack_require__.g.MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
} else if (typeof self !== 'undefined') {
  ws = self.WebSocket || self.MozWebSocket
}

/* harmony default export */ __webpack_exports__["default"] = (ws);


/***/ }),

/***/ "./node_modules/ms/index.js":
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ "./node_modules/parse-headers/parse-headers.js":
/***/ (function(module) {

var trim = function(string) {
  return string.replace(/^\s+|\s+$/g, '');
}
  , isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    }

module.exports = function (headers) {
  if (!headers)
    return {}

  var result = {}

  var headersArr = trim(headers).split('\n')

  for (var i = 0; i < headersArr.length; i++) {
    var row = headersArr[i]
    var index = row.indexOf(':')
    , key = trim(row.slice(0, index)).toLowerCase()
    , value = trim(row.slice(index + 1))

    if (typeof(result[key]) === 'undefined') {
      result[key] = value
    } else if (isArray(result[key])) {
      result[key].push(value)
    } else {
      result[key] = [ result[key], value ]
    }
  }

  return result
}


/***/ }),

/***/ "./node_modules/@everipedia/web3-signer/node_modules/viem/dist/utils/index.mjs":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "arrayRegex": function() { return /* reexport */ arrayRegex; },
  "assertRequest": function() { return /* reexport */ assertRequest; },
  "boolToBytes": function() { return /* reexport */ boolToBytes; },
  "boolToHex": function() { return /* reexport */ boolToHex; },
  "buildRequest": function() { return /* reexport */ buildRequest; },
  "bytesRegex": function() { return /* reexport */ bytesRegex; },
  "bytesToBigint": function() { return /* reexport */ bytesToBigint; },
  "bytesToBool": function() { return /* reexport */ bytesToBool; },
  "bytesToHex": function() { return /* reexport */ chunk_JG6MI5ZV_bytesToHex; },
  "bytesToNumber": function() { return /* reexport */ chunk_JG6MI5ZV_bytesToNumber; },
  "bytesToString": function() { return /* reexport */ bytesToString; },
  "concat": function() { return /* reexport */ concat; },
  "concatBytes": function() { return /* reexport */ chunk_JG6MI5ZV_concatBytes; },
  "concatHex": function() { return /* reexport */ concatHex; },
  "containsNodeError": function() { return /* reexport */ containsNodeError; },
  "decodeAbiParameters": function() { return /* reexport */ decodeAbiParameters; },
  "decodeErrorResult": function() { return /* reexport */ decodeErrorResult; },
  "decodeEventLog": function() { return /* reexport */ decodeEventLog; },
  "decodeFunctionData": function() { return /* reexport */ decodeFunctionData; },
  "decodeFunctionResult": function() { return /* reexport */ decodeFunctionResult; },
  "defineBlock": function() { return /* reexport */ defineBlock; },
  "defineChain": function() { return /* reexport */ defineChain; },
  "defineFormatter": function() { return /* reexport */ defineFormatter; },
  "defineTransaction": function() { return /* reexport */ defineTransaction; },
  "defineTransactionReceipt": function() { return /* reexport */ defineTransactionReceipt; },
  "defineTransactionRequest": function() { return /* reexport */ defineTransactionRequest; },
  "encodeAbiParameters": function() { return /* reexport */ encodeAbiParameters; },
  "encodeDeployData": function() { return /* reexport */ encodeDeployData; },
  "encodeErrorResult": function() { return /* reexport */ encodeErrorResult; },
  "encodeEventTopics": function() { return /* reexport */ encodeEventTopics; },
  "encodeFunctionData": function() { return /* reexport */ encodeFunctionData; },
  "encodeFunctionResult": function() { return /* reexport */ encodeFunctionResult; },
  "encodePacked": function() { return /* reexport */ encodePacked; },
  "extract": function() { return /* reexport */ extract; },
  "extractFunctionName": function() { return /* reexport */ extractFunctionName; },
  "extractFunctionParams": function() { return /* reexport */ extractFunctionParams; },
  "extractFunctionParts": function() { return /* reexport */ extractFunctionParts; },
  "extractFunctionType": function() { return /* reexport */ extractFunctionType; },
  "format": function() { return /* reexport */ format3; },
  "formatAbiItem": function() { return /* reexport */ formatAbiItem; },
  "formatAbiItemWithArgs": function() { return /* reexport */ formatAbiItemWithArgs; },
  "formatBlock": function() { return /* reexport */ formatBlock; },
  "formatEther": function() { return /* reexport */ formatEther; },
  "formatGwei": function() { return /* reexport */ formatGwei; },
  "formatTransaction": function() { return /* reexport */ formatTransaction; },
  "formatTransactionRequest": function() { return /* reexport */ formatTransactionRequest; },
  "formatUnits": function() { return /* reexport */ formatUnits; },
  "fromBytes": function() { return /* reexport */ fromBytes; },
  "fromHex": function() { return /* reexport */ fromHex; },
  "fromRlp": function() { return /* reexport */ fromRlp; },
  "getAbiItem": function() { return /* reexport */ getAbiItem; },
  "getAccount": function() { return /* reexport */ getAccount; },
  "getAddress": function() { return /* reexport */ getAddress; },
  "getCallError": function() { return /* reexport */ getCallError; },
  "getChainContractAddress": function() { return /* reexport */ getChainContractAddress; },
  "getContractAddress": function() { return /* reexport */ getContractAddress2; },
  "getContractError": function() { return /* reexport */ getContractError; },
  "getCreate2Address": function() { return /* reexport */ getCreate2Address; },
  "getCreateAddress": function() { return /* reexport */ getCreateAddress; },
  "getEstimateGasError": function() { return /* reexport */ getEstimateGasError; },
  "getEventSelector": function() { return /* reexport */ getEventSelector; },
  "getFunctionSelector": function() { return /* reexport */ getFunctionSelector; },
  "getNodeError": function() { return /* reexport */ getNodeError; },
  "getSocket": function() { return /* reexport */ getSocket; },
  "getTransactionError": function() { return /* reexport */ getTransactionError; },
  "hashMessage": function() { return /* reexport */ hashMessage; },
  "hexToBigInt": function() { return /* reexport */ hexToBigInt; },
  "hexToBool": function() { return /* reexport */ hexToBool; },
  "hexToBytes": function() { return /* reexport */ chunk_JG6MI5ZV_hexToBytes; },
  "hexToNumber": function() { return /* reexport */ chunk_JG6MI5ZV_hexToNumber; },
  "hexToString": function() { return /* reexport */ hexToString; },
  "integerRegex": function() { return /* reexport */ integerRegex; },
  "isAddress": function() { return /* reexport */ isAddress; },
  "isAddressEqual": function() { return /* reexport */ isAddressEqual; },
  "isBytes": function() { return /* reexport */ isBytes; },
  "isHex": function() { return /* reexport */ isHex; },
  "keccak256": function() { return /* reexport */ keccak256; },
  "numberToBytes": function() { return /* reexport */ numberToBytes; },
  "numberToHex": function() { return /* reexport */ numberToHex; },
  "pad": function() { return /* reexport */ pad; },
  "padBytes": function() { return /* reexport */ padBytes; },
  "padHex": function() { return /* reexport */ padHex; },
  "parseAbi": function() { return /* reexport */ parseAbi; },
  "parseAbiItem": function() { return /* reexport */ parseAbiItem; },
  "parseAbiParameter": function() { return /* reexport */ parseAbiParameter2; },
  "parseAbiParameters": function() { return /* reexport */ parseAbiParameters; },
  "parseEther": function() { return /* reexport */ parseEther; },
  "parseGwei": function() { return /* reexport */ parseGwei; },
  "parseUnits": function() { return /* reexport */ parseUnits; },
  "prepareRequest": function() { return /* reexport */ prepareRequest; },
  "recoverAddress": function() { return /* reexport */ recoverAddress; },
  "recoverMessageAddress": function() { return /* reexport */ recoverMessageAddress; },
  "rpc": function() { return /* reexport */ rpc; },
  "size": function() { return /* reexport */ size; },
  "slice": function() { return /* reexport */ slice; },
  "sliceBytes": function() { return /* reexport */ sliceBytes; },
  "sliceHex": function() { return /* reexport */ sliceHex; },
  "stringToBytes": function() { return /* reexport */ stringToBytes; },
  "stringToHex": function() { return /* reexport */ stringToHex; },
  "stringify": function() { return /* reexport */ stringify; },
  "toBytes": function() { return /* reexport */ toBytes; },
  "toHex": function() { return /* reexport */ toHex; },
  "toRlp": function() { return /* reexport */ toRlp; },
  "transactionType": function() { return /* reexport */ transactionType; },
  "trim": function() { return /* reexport */ trim; },
  "verifyMessage": function() { return /* reexport */ verifyMessage; }
});

// EXTERNAL MODULE: ./node_modules/@noble/hashes/esm/sha3.js + 1 modules
var sha3 = __webpack_require__("./node_modules/@noble/hashes/esm/sha3.js");
// EXTERNAL MODULE: ./node_modules/isomorphic-ws/browser.js
var browser = __webpack_require__("./node_modules/isomorphic-ws/browser.js");
// EXTERNAL MODULE: crypto (ignored)
var crypto_ignored_ = __webpack_require__("?d36c");
var crypto_ignored_namespaceObject = /*#__PURE__*/__webpack_require__.t(crypto_ignored_, 2);
;// CONCATENATED MODULE: ./node_modules/@noble/secp256k1/lib/esm/index.js
/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */

const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
const _3n = BigInt(3);
const _8n = BigInt(8);
const CURVE = Object.freeze({
    a: _0n,
    b: BigInt(7),
    P: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: _1n,
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
});
const divNearest = (a, b) => (a + b / _2n) / b;
const endo = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    splitScalar(k) {
        const { n } = CURVE;
        const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
        const b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
        const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
        const b2 = a1;
        const POW_2_128 = BigInt('0x100000000000000000000000000000000');
        const c1 = divNearest(b2 * k, n);
        const c2 = divNearest(-b1 * k, n);
        let k1 = mod(k - c1 * a1 - c2 * a2, n);
        let k2 = mod(-c1 * b1 - c2 * b2, n);
        const k1neg = k1 > POW_2_128;
        const k2neg = k2 > POW_2_128;
        if (k1neg)
            k1 = n - k1;
        if (k2neg)
            k2 = n - k2;
        if (k1 > POW_2_128 || k2 > POW_2_128) {
            throw new Error('splitScalarEndo: Endomorphism failed, k=' + k);
        }
        return { k1neg, k1, k2neg, k2 };
    },
};
const fieldLen = 32;
const groupLen = 32;
const hashLen = 32;
const compressedLen = fieldLen + 1;
const uncompressedLen = 2 * fieldLen + 1;

function weierstrass(x) {
    const { a, b } = CURVE;
    const x2 = mod(x * x);
    const x3 = mod(x2 * x);
    return mod(x3 + a * x + b);
}
const USE_ENDOMORPHISM = CURVE.a === _0n;
class ShaError extends Error {
    constructor(message) {
        super(message);
    }
}
function assertJacPoint(other) {
    if (!(other instanceof JacobianPoint))
        throw new TypeError('JacobianPoint expected');
}
class JacobianPoint {
    constructor(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static fromAffine(p) {
        if (!(p instanceof Point)) {
            throw new TypeError('JacobianPoint#fromAffine: expected Point');
        }
        if (p.equals(Point.ZERO))
            return JacobianPoint.ZERO;
        return new JacobianPoint(p.x, p.y, _1n);
    }
    static toAffineBatch(points) {
        const toInv = invertBatch(points.map((p) => p.z));
        return points.map((p, i) => p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return JacobianPoint.toAffineBatch(points).map(JacobianPoint.fromAffine);
    }
    equals(other) {
        assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        const Z1Z1 = mod(Z1 * Z1);
        const Z2Z2 = mod(Z2 * Z2);
        const U1 = mod(X1 * Z2Z2);
        const U2 = mod(X2 * Z1Z1);
        const S1 = mod(mod(Y1 * Z2) * Z2Z2);
        const S2 = mod(mod(Y2 * Z1) * Z1Z1);
        return U1 === U2 && S1 === S2;
    }
    negate() {
        return new JacobianPoint(this.x, mod(-this.y), this.z);
    }
    double() {
        const { x: X1, y: Y1, z: Z1 } = this;
        const A = mod(X1 * X1);
        const B = mod(Y1 * Y1);
        const C = mod(B * B);
        const x1b = X1 + B;
        const D = mod(_2n * (mod(x1b * x1b) - A - C));
        const E = mod(_3n * A);
        const F = mod(E * E);
        const X3 = mod(F - _2n * D);
        const Y3 = mod(E * (D - X3) - _8n * C);
        const Z3 = mod(_2n * Y1 * Z1);
        return new JacobianPoint(X3, Y3, Z3);
    }
    add(other) {
        assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        if (X2 === _0n || Y2 === _0n)
            return this;
        if (X1 === _0n || Y1 === _0n)
            return other;
        const Z1Z1 = mod(Z1 * Z1);
        const Z2Z2 = mod(Z2 * Z2);
        const U1 = mod(X1 * Z2Z2);
        const U2 = mod(X2 * Z1Z1);
        const S1 = mod(mod(Y1 * Z2) * Z2Z2);
        const S2 = mod(mod(Y2 * Z1) * Z1Z1);
        const H = mod(U2 - U1);
        const r = mod(S2 - S1);
        if (H === _0n) {
            if (r === _0n) {
                return this.double();
            }
            else {
                return JacobianPoint.ZERO;
            }
        }
        const HH = mod(H * H);
        const HHH = mod(H * HH);
        const V = mod(U1 * HH);
        const X3 = mod(r * r - HHH - _2n * V);
        const Y3 = mod(r * (V - X3) - S1 * HHH);
        const Z3 = mod(Z1 * Z2 * H);
        return new JacobianPoint(X3, Y3, Z3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiplyUnsafe(scalar) {
        const P0 = JacobianPoint.ZERO;
        if (typeof scalar === 'bigint' && scalar === _0n)
            return P0;
        let n = normalizeScalar(scalar);
        if (n === _1n)
            return this;
        if (!USE_ENDOMORPHISM) {
            let p = P0;
            let d = this;
            while (n > _0n) {
                if (n & _1n)
                    p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        }
        let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
        let k1p = P0;
        let k2p = P0;
        let d = this;
        while (k1 > _0n || k2 > _0n) {
            if (k1 & _1n)
                k1p = k1p.add(d);
            if (k2 & _1n)
                k2p = k2p.add(d);
            d = d.double();
            k1 >>= _1n;
            k2 >>= _1n;
        }
        if (k1neg)
            k1p = k1p.negate();
        if (k2neg)
            k2p = k2p.negate();
        k2p = new JacobianPoint(mod(k2p.x * endo.beta), k2p.y, k2p.z);
        return k1p.add(k2p);
    }
    precomputeWindow(W) {
        const windows = USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
        const points = [];
        let p = this;
        let base = p;
        for (let window = 0; window < windows; window++) {
            base = p;
            points.push(base);
            for (let i = 1; i < 2 ** (W - 1); i++) {
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals(JacobianPoint.BASE))
            affinePoint = Point.BASE;
        const W = (affinePoint && affinePoint._WINDOW_SIZE) || 1;
        if (256 % W) {
            throw new Error('Point#wNAF: Invalid precomputation window, must be power of 2');
        }
        let precomputes = affinePoint && pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = JacobianPoint.normalizeZ(precomputes);
                pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = JacobianPoint.ZERO;
        let f = JacobianPoint.BASE;
        const windows = 1 + (USE_ENDOMORPHISM ? 128 / W : 256 / W);
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for (let window = 0; window < windows; window++) {
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += _1n;
            }
            const offset1 = offset;
            const offset2 = offset + Math.abs(wbits) - 1;
            const cond1 = window % 2 !== 0;
            const cond2 = wbits < 0;
            if (wbits === 0) {
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
            }
            else {
                p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
        }
        return { p, f };
    }
    multiply(scalar, affinePoint) {
        let n = normalizeScalar(scalar);
        let point;
        let fake;
        if (USE_ENDOMORPHISM) {
            const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
            let { p: k1p, f: f1p } = this.wNAF(k1, affinePoint);
            let { p: k2p, f: f2p } = this.wNAF(k2, affinePoint);
            k1p = constTimeNegate(k1neg, k1p);
            k2p = constTimeNegate(k2neg, k2p);
            k2p = new JacobianPoint(mod(k2p.x * endo.beta), k2p.y, k2p.z);
            point = k1p.add(k2p);
            fake = f1p.add(f2p);
        }
        else {
            const { p, f } = this.wNAF(n, affinePoint);
            point = p;
            fake = f;
        }
        return JacobianPoint.normalizeZ([point, fake])[0];
    }
    toAffine(invZ) {
        const { x, y, z } = this;
        const is0 = this.equals(JacobianPoint.ZERO);
        if (invZ == null)
            invZ = is0 ? _8n : invert(z);
        const iz1 = invZ;
        const iz2 = mod(iz1 * iz1);
        const iz3 = mod(iz2 * iz1);
        const ax = mod(x * iz2);
        const ay = mod(y * iz3);
        const zz = mod(z * iz1);
        if (is0)
            return Point.ZERO;
        if (zz !== _1n)
            throw new Error('invZ was invalid');
        return new Point(ax, ay);
    }
}
JacobianPoint.BASE = new JacobianPoint(CURVE.Gx, CURVE.Gy, _1n);
JacobianPoint.ZERO = new JacobianPoint(_0n, _1n, _0n);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
const pointPrecomputes = new WeakMap();
class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        pointPrecomputes.delete(this);
    }
    hasEvenY() {
        return this.y % _2n === _0n;
    }
    static fromCompressedHex(bytes) {
        const isShort = bytes.length === 32;
        const x = bytesToNumber(isShort ? bytes : bytes.subarray(1));
        if (!isValidFieldElement(x))
            throw new Error('Point is not on curve');
        const y2 = weierstrass(x);
        let y = sqrtMod(y2);
        const isYOdd = (y & _1n) === _1n;
        if (isShort) {
            if (isYOdd)
                y = mod(-y);
        }
        else {
            const isFirstByteOdd = (bytes[0] & 1) === 1;
            if (isFirstByteOdd !== isYOdd)
                y = mod(-y);
        }
        const point = new Point(x, y);
        point.assertValidity();
        return point;
    }
    static fromUncompressedHex(bytes) {
        const x = bytesToNumber(bytes.subarray(1, fieldLen + 1));
        const y = bytesToNumber(bytes.subarray(fieldLen + 1, fieldLen * 2 + 1));
        const point = new Point(x, y);
        point.assertValidity();
        return point;
    }
    static fromHex(hex) {
        const bytes = ensureBytes(hex);
        const len = bytes.length;
        const header = bytes[0];
        if (len === fieldLen)
            return this.fromCompressedHex(bytes);
        if (len === compressedLen && (header === 0x02 || header === 0x03)) {
            return this.fromCompressedHex(bytes);
        }
        if (len === uncompressedLen && header === 0x04)
            return this.fromUncompressedHex(bytes);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes, not ${len}`);
    }
    static fromPrivateKey(privateKey) {
        return Point.BASE.multiply(normalizePrivateKey(privateKey));
    }
    static fromSignature(msgHash, signature, recovery) {
        const { r, s } = normalizeSignature(signature);
        if (![0, 1, 2, 3].includes(recovery))
            throw new Error('Cannot recover: invalid recovery bit');
        const h = truncateHash(ensureBytes(msgHash));
        const { n } = CURVE;
        const radj = recovery === 2 || recovery === 3 ? r + n : r;
        const rinv = invert(radj, n);
        const u1 = mod(-h * rinv, n);
        const u2 = mod(s * rinv, n);
        const prefix = recovery & 1 ? '03' : '02';
        const R = Point.fromHex(prefix + numTo32bStr(radj));
        const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2);
        if (!Q)
            throw new Error('Cannot recover signature: point at infinify');
        Q.assertValidity();
        return Q;
    }
    toRawBytes(isCompressed = false) {
        return hexToBytes(this.toHex(isCompressed));
    }
    toHex(isCompressed = false) {
        const x = numTo32bStr(this.x);
        if (isCompressed) {
            const prefix = this.hasEvenY() ? '02' : '03';
            return `${prefix}${x}`;
        }
        else {
            return `04${x}${numTo32bStr(this.y)}`;
        }
    }
    toHexX() {
        return this.toHex(true).slice(2);
    }
    toRawX() {
        return this.toRawBytes(true).slice(1);
    }
    assertValidity() {
        const msg = 'Point is not on elliptic curve';
        const { x, y } = this;
        if (!isValidFieldElement(x) || !isValidFieldElement(y))
            throw new Error(msg);
        const left = mod(y * y);
        const right = weierstrass(x);
        if (mod(left - right) !== _0n)
            throw new Error(msg);
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new Point(this.x, mod(-this.y));
    }
    double() {
        return JacobianPoint.fromAffine(this).double().toAffine();
    }
    add(other) {
        return JacobianPoint.fromAffine(this).add(JacobianPoint.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return JacobianPoint.fromAffine(this).multiply(scalar, this).toAffine();
    }
    multiplyAndAddUnsafe(Q, a, b) {
        const P = JacobianPoint.fromAffine(this);
        const aP = a === _0n || a === _1n || this !== Point.BASE ? P.multiplyUnsafe(a) : P.multiply(a);
        const bQ = JacobianPoint.fromAffine(Q).multiplyUnsafe(b);
        const sum = aP.add(bQ);
        return sum.equals(JacobianPoint.ZERO) ? undefined : sum.toAffine();
    }
}
Point.BASE = new Point(CURVE.Gx, CURVE.Gy);
Point.ZERO = new Point(_0n, _0n);
function sliceDER(s) {
    return Number.parseInt(s[0], 16) >= 8 ? '00' + s : s;
}
function parseDERInt(data) {
    if (data.length < 2 || data[0] !== 0x02) {
        throw new Error(`Invalid signature integer tag: ${bytesToHex(data)}`);
    }
    const len = data[1];
    const res = data.subarray(2, len + 2);
    if (!len || res.length !== len) {
        throw new Error(`Invalid signature integer: wrong length`);
    }
    if (res[0] === 0x00 && res[1] <= 0x7f) {
        throw new Error('Invalid signature integer: trailing length');
    }
    return { data: bytesToNumber(res), left: data.subarray(len + 2) };
}
function parseDERSignature(data) {
    if (data.length < 2 || data[0] != 0x30) {
        throw new Error(`Invalid signature tag: ${bytesToHex(data)}`);
    }
    if (data[1] !== data.length - 2) {
        throw new Error('Invalid signature: incorrect length');
    }
    const { data: r, left: sBytes } = parseDERInt(data.subarray(2));
    const { data: s, left: rBytesLeft } = parseDERInt(sBytes);
    if (rBytesLeft.length) {
        throw new Error(`Invalid signature: left bytes after parsing: ${bytesToHex(rBytesLeft)}`);
    }
    return { r, s };
}
class Signature {
    constructor(r, s) {
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromCompact(hex) {
        const arr = hex instanceof Uint8Array;
        const name = 'Signature.fromCompact';
        if (typeof hex !== 'string' && !arr)
            throw new TypeError(`${name}: Expected string or Uint8Array`);
        const str = arr ? bytesToHex(hex) : hex;
        if (str.length !== 128)
            throw new Error(`${name}: Expected 64-byte hex`);
        return new Signature(hexToNumber(str.slice(0, 64)), hexToNumber(str.slice(64, 128)));
    }
    static fromDER(hex) {
        const arr = hex instanceof Uint8Array;
        if (typeof hex !== 'string' && !arr)
            throw new TypeError(`Signature.fromDER: Expected string or Uint8Array`);
        const { r, s } = parseDERSignature(arr ? hex : hexToBytes(hex));
        return new Signature(r, s);
    }
    static fromHex(hex) {
        return this.fromDER(hex);
    }
    assertValidity() {
        const { r, s } = this;
        if (!isWithinCurveOrder(r))
            throw new Error('Invalid Signature: r must be 0 < r < n');
        if (!isWithinCurveOrder(s))
            throw new Error('Invalid Signature: s must be 0 < s < n');
    }
    hasHighS() {
        const HALF = CURVE.n >> _1n;
        return this.s > HALF;
    }
    normalizeS() {
        return this.hasHighS() ? new Signature(this.r, mod(-this.s, CURVE.n)) : this;
    }
    toDERRawBytes() {
        return hexToBytes(this.toDERHex());
    }
    toDERHex() {
        const sHex = sliceDER(numberToHexUnpadded(this.s));
        const rHex = sliceDER(numberToHexUnpadded(this.r));
        const sHexL = sHex.length / 2;
        const rHexL = rHex.length / 2;
        const sLen = numberToHexUnpadded(sHexL);
        const rLen = numberToHexUnpadded(rHexL);
        const length = numberToHexUnpadded(rHexL + sHexL + 4);
        return `30${length}02${rLen}${rHex}02${sLen}${sHex}`;
    }
    toRawBytes() {
        return this.toDERRawBytes();
    }
    toHex() {
        return this.toDERHex();
    }
    toCompactRawBytes() {
        return hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
        return numTo32bStr(this.r) + numTo32bStr(this.s);
    }
}
function concatBytes(...arrays) {
    if (!arrays.every((b) => b instanceof Uint8Array))
        throw new Error('Uint8Array list expected');
    if (arrays.length === 1)
        return arrays[0];
    const length = arrays.reduce((a, arr) => a + arr.length, 0);
    const result = new Uint8Array(length);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
const hexes = Array.from({ length: 256 }, (v, i) => i.toString(16).padStart(2, '0'));
function bytesToHex(uint8a) {
    if (!(uint8a instanceof Uint8Array))
        throw new Error('Expected Uint8Array');
    let hex = '';
    for (let i = 0; i < uint8a.length; i++) {
        hex += hexes[uint8a[i]];
    }
    return hex;
}
const POW_2_256 = BigInt('0x10000000000000000000000000000000000000000000000000000000000000000');
function numTo32bStr(num) {
    if (typeof num !== 'bigint')
        throw new Error('Expected bigint');
    if (!(_0n <= num && num < POW_2_256))
        throw new Error('Expected number 0 <= n < 2^256');
    return num.toString(16).padStart(64, '0');
}
function numTo32b(num) {
    const b = hexToBytes(numTo32bStr(num));
    if (b.length !== 32)
        throw new Error('Error: expected 32 bytes');
    return b;
}
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== 'string') {
        throw new TypeError('hexToNumber: expected string, got ' + typeof hex);
    }
    return BigInt(`0x${hex}`);
}
function hexToBytes(hex) {
    if (typeof hex !== 'string') {
        throw new TypeError('hexToBytes: expected string, got ' + typeof hex);
    }
    if (hex.length % 2)
        throw new Error('hexToBytes: received invalid unpadded hex' + hex.length);
    const array = new Uint8Array(hex.length / 2);
    for (let i = 0; i < array.length; i++) {
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0)
            throw new Error('Invalid byte sequence');
        array[i] = byte;
    }
    return array;
}
function bytesToNumber(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
function ensureBytes(hex) {
    return hex instanceof Uint8Array ? Uint8Array.from(hex) : hexToBytes(hex);
}
function normalizeScalar(num) {
    if (typeof num === 'number' && Number.isSafeInteger(num) && num > 0)
        return BigInt(num);
    if (typeof num === 'bigint' && isWithinCurveOrder(num))
        return num;
    throw new TypeError('Expected valid private scalar: 0 < scalar < curve.n');
}
function mod(a, b = CURVE.P) {
    const result = a % b;
    return result >= _0n ? result : b + result;
}
function pow2(x, power) {
    const { P } = CURVE;
    let res = x;
    while (power-- > _0n) {
        res *= res;
        res %= P;
    }
    return res;
}
function sqrtMod(x) {
    const { P } = CURVE;
    const _6n = BigInt(6);
    const _11n = BigInt(11);
    const _22n = BigInt(22);
    const _23n = BigInt(23);
    const _44n = BigInt(44);
    const _88n = BigInt(88);
    const b2 = (x * x * x) % P;
    const b3 = (b2 * b2 * x) % P;
    const b6 = (pow2(b3, _3n) * b3) % P;
    const b9 = (pow2(b6, _3n) * b3) % P;
    const b11 = (pow2(b9, _2n) * b2) % P;
    const b22 = (pow2(b11, _11n) * b11) % P;
    const b44 = (pow2(b22, _22n) * b22) % P;
    const b88 = (pow2(b44, _44n) * b44) % P;
    const b176 = (pow2(b88, _88n) * b88) % P;
    const b220 = (pow2(b176, _44n) * b44) % P;
    const b223 = (pow2(b220, _3n) * b3) % P;
    const t1 = (pow2(b223, _23n) * b22) % P;
    const t2 = (pow2(t1, _6n) * b2) % P;
    const rt = pow2(t2, _2n);
    const xc = (rt * rt) % P;
    if (xc !== x)
        throw new Error('Cannot find square root');
    return rt;
}
function invert(number, modulo = CURVE.P) {
    if (number === _0n || modulo <= _0n) {
        throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    }
    let a = mod(number, modulo);
    let b = modulo;
    let x = _0n, y = _1n, u = _1n, v = _0n;
    while (a !== _0n) {
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
function invertBatch(nums, p = CURVE.P) {
    const scratch = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i) => {
        if (num === _0n)
            return acc;
        scratch[i] = acc;
        return mod(acc * num, p);
    }, _1n);
    const inverted = invert(lastMultiplied, p);
    nums.reduceRight((acc, num, i) => {
        if (num === _0n)
            return acc;
        scratch[i] = mod(acc * scratch[i], p);
        return mod(acc * num, p);
    }, inverted);
    return scratch;
}
function bits2int_2(bytes) {
    const delta = bytes.length * 8 - groupLen * 8;
    const num = bytesToNumber(bytes);
    return delta > 0 ? num >> BigInt(delta) : num;
}
function truncateHash(hash, truncateOnly = false) {
    const h = bits2int_2(hash);
    if (truncateOnly)
        return h;
    const { n } = CURVE;
    return h >= n ? h - n : h;
}
let _sha256Sync;
let _hmacSha256Sync;
class HmacDrbg {
    constructor(hashLen, qByteLen) {
        this.hashLen = hashLen;
        this.qByteLen = qByteLen;
        if (typeof hashLen !== 'number' || hashLen < 2)
            throw new Error('hashLen must be a number');
        if (typeof qByteLen !== 'number' || qByteLen < 2)
            throw new Error('qByteLen must be a number');
        this.v = new Uint8Array(hashLen).fill(1);
        this.k = new Uint8Array(hashLen).fill(0);
        this.counter = 0;
    }
    hmac(...values) {
        return utils.hmacSha256(this.k, ...values);
    }
    hmacSync(...values) {
        return _hmacSha256Sync(this.k, ...values);
    }
    checkSync() {
        if (typeof _hmacSha256Sync !== 'function')
            throw new ShaError('hmacSha256Sync needs to be set');
    }
    incr() {
        if (this.counter >= 1000)
            throw new Error('Tried 1,000 k values for sign(), all were invalid');
        this.counter += 1;
    }
    async reseed(seed = new Uint8Array()) {
        this.k = await this.hmac(this.v, Uint8Array.from([0x00]), seed);
        this.v = await this.hmac(this.v);
        if (seed.length === 0)
            return;
        this.k = await this.hmac(this.v, Uint8Array.from([0x01]), seed);
        this.v = await this.hmac(this.v);
    }
    reseedSync(seed = new Uint8Array()) {
        this.checkSync();
        this.k = this.hmacSync(this.v, Uint8Array.from([0x00]), seed);
        this.v = this.hmacSync(this.v);
        if (seed.length === 0)
            return;
        this.k = this.hmacSync(this.v, Uint8Array.from([0x01]), seed);
        this.v = this.hmacSync(this.v);
    }
    async generate() {
        this.incr();
        let len = 0;
        const out = [];
        while (len < this.qByteLen) {
            this.v = await this.hmac(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return concatBytes(...out);
    }
    generateSync() {
        this.checkSync();
        this.incr();
        let len = 0;
        const out = [];
        while (len < this.qByteLen) {
            this.v = this.hmacSync(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return concatBytes(...out);
    }
}
function isWithinCurveOrder(num) {
    return _0n < num && num < CURVE.n;
}
function isValidFieldElement(num) {
    return _0n < num && num < CURVE.P;
}
function kmdToSig(kBytes, m, d, lowS = true) {
    const { n } = CURVE;
    const k = truncateHash(kBytes, true);
    if (!isWithinCurveOrder(k))
        return;
    const kinv = invert(k, n);
    const q = Point.BASE.multiply(k);
    const r = mod(q.x, n);
    if (r === _0n)
        return;
    const s = mod(kinv * mod(m + d * r, n), n);
    if (s === _0n)
        return;
    let sig = new Signature(r, s);
    let recovery = (q.x === sig.r ? 0 : 2) | Number(q.y & _1n);
    if (lowS && sig.hasHighS()) {
        sig = sig.normalizeS();
        recovery ^= 1;
    }
    return { sig, recovery };
}
function normalizePrivateKey(key) {
    let num;
    if (typeof key === 'bigint') {
        num = key;
    }
    else if (typeof key === 'number' && Number.isSafeInteger(key) && key > 0) {
        num = BigInt(key);
    }
    else if (typeof key === 'string') {
        if (key.length !== 2 * groupLen)
            throw new Error('Expected 32 bytes of private key');
        num = hexToNumber(key);
    }
    else if (key instanceof Uint8Array) {
        if (key.length !== groupLen)
            throw new Error('Expected 32 bytes of private key');
        num = bytesToNumber(key);
    }
    else {
        throw new TypeError('Expected valid private key');
    }
    if (!isWithinCurveOrder(num))
        throw new Error('Expected private key: 0 < key < n');
    return num;
}
function normalizePublicKey(publicKey) {
    if (publicKey instanceof Point) {
        publicKey.assertValidity();
        return publicKey;
    }
    else {
        return Point.fromHex(publicKey);
    }
}
function normalizeSignature(signature) {
    if (signature instanceof Signature) {
        signature.assertValidity();
        return signature;
    }
    try {
        return Signature.fromDER(signature);
    }
    catch (error) {
        return Signature.fromCompact(signature);
    }
}
function getPublicKey(privateKey, isCompressed = false) {
    return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
}
function recoverPublicKey(msgHash, signature, recovery, isCompressed = false) {
    return Point.fromSignature(msgHash, signature, recovery).toRawBytes(isCompressed);
}
function isProbPub(item) {
    const arr = item instanceof Uint8Array;
    const str = typeof item === 'string';
    const len = (arr || str) && item.length;
    if (arr)
        return len === compressedLen || len === uncompressedLen;
    if (str)
        return len === compressedLen * 2 || len === uncompressedLen * 2;
    if (item instanceof Point)
        return true;
    return false;
}
function getSharedSecret(privateA, publicB, isCompressed = false) {
    if (isProbPub(privateA))
        throw new TypeError('getSharedSecret: first arg must be private key');
    if (!isProbPub(publicB))
        throw new TypeError('getSharedSecret: second arg must be public key');
    const b = normalizePublicKey(publicB);
    b.assertValidity();
    return b.multiply(normalizePrivateKey(privateA)).toRawBytes(isCompressed);
}
function bits2int(bytes) {
    const slice = bytes.length > fieldLen ? bytes.slice(0, fieldLen) : bytes;
    return bytesToNumber(slice);
}
function bits2octets(bytes) {
    const z1 = bits2int(bytes);
    const z2 = mod(z1, CURVE.n);
    return int2octets(z2 < _0n ? z1 : z2);
}
function int2octets(num) {
    return numTo32b(num);
}
function initSigArgs(msgHash, privateKey, extraEntropy) {
    if (msgHash == null)
        throw new Error(`sign: expected valid message hash, not "${msgHash}"`);
    const h1 = ensureBytes(msgHash);
    const d = normalizePrivateKey(privateKey);
    const seedArgs = [int2octets(d), bits2octets(h1)];
    if (extraEntropy != null) {
        if (extraEntropy === true)
            extraEntropy = utils.randomBytes(fieldLen);
        const e = ensureBytes(extraEntropy);
        if (e.length !== fieldLen)
            throw new Error(`sign: Expected ${fieldLen} bytes of extra data`);
        seedArgs.push(e);
    }
    const seed = concatBytes(...seedArgs);
    const m = bits2int(h1);
    return { seed, m, d };
}
function finalizeSig(recSig, opts) {
    const { sig, recovery } = recSig;
    const { der, recovered } = Object.assign({ canonical: true, der: true }, opts);
    const hashed = der ? sig.toDERRawBytes() : sig.toCompactRawBytes();
    return recovered ? [hashed, recovery] : hashed;
}
async function sign(msgHash, privKey, opts = {}) {
    const { seed, m, d } = initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new HmacDrbg(hashLen, groupLen);
    await drbg.reseed(seed);
    let sig;
    while (!(sig = kmdToSig(await drbg.generate(), m, d, opts.canonical)))
        await drbg.reseed();
    return finalizeSig(sig, opts);
}
function signSync(msgHash, privKey, opts = {}) {
    const { seed, m, d } = initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new HmacDrbg(hashLen, groupLen);
    drbg.reseedSync(seed);
    let sig;
    while (!(sig = kmdToSig(drbg.generateSync(), m, d, opts.canonical)))
        drbg.reseedSync();
    return finalizeSig(sig, opts);
}

const vopts = { strict: true };
function verify(signature, msgHash, publicKey, opts = vopts) {
    let sig;
    try {
        sig = normalizeSignature(signature);
        msgHash = ensureBytes(msgHash);
    }
    catch (error) {
        return false;
    }
    const { r, s } = sig;
    if (opts.strict && sig.hasHighS())
        return false;
    const h = truncateHash(msgHash);
    let P;
    try {
        P = normalizePublicKey(publicKey);
    }
    catch (error) {
        return false;
    }
    const { n } = CURVE;
    const sinv = invert(s, n);
    const u1 = mod(h * sinv, n);
    const u2 = mod(r * sinv, n);
    const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2);
    if (!R)
        return false;
    const v = mod(R.x, n);
    return v === r;
}
function schnorrChallengeFinalize(ch) {
    return mod(bytesToNumber(ch), CURVE.n);
}
class SchnorrSignature {
    constructor(r, s) {
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromHex(hex) {
        const bytes = ensureBytes(hex);
        if (bytes.length !== 64)
            throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${bytes.length}`);
        const r = bytesToNumber(bytes.subarray(0, 32));
        const s = bytesToNumber(bytes.subarray(32, 64));
        return new SchnorrSignature(r, s);
    }
    assertValidity() {
        const { r, s } = this;
        if (!isValidFieldElement(r) || !isWithinCurveOrder(s))
            throw new Error('Invalid signature');
    }
    toHex() {
        return numTo32bStr(this.r) + numTo32bStr(this.s);
    }
    toRawBytes() {
        return hexToBytes(this.toHex());
    }
}
function schnorrGetPublicKey(privateKey) {
    return Point.fromPrivateKey(privateKey).toRawX();
}
class InternalSchnorrSignature {
    constructor(message, privateKey, auxRand = utils.randomBytes()) {
        if (message == null)
            throw new TypeError(`sign: Expected valid message, not "${message}"`);
        this.m = ensureBytes(message);
        const { x, scalar } = this.getScalar(normalizePrivateKey(privateKey));
        this.px = x;
        this.d = scalar;
        this.rand = ensureBytes(auxRand);
        if (this.rand.length !== 32)
            throw new TypeError('sign: Expected 32 bytes of aux randomness');
    }
    getScalar(priv) {
        const point = Point.fromPrivateKey(priv);
        const scalar = point.hasEvenY() ? priv : CURVE.n - priv;
        return { point, scalar, x: point.toRawX() };
    }
    initNonce(d, t0h) {
        return numTo32b(d ^ bytesToNumber(t0h));
    }
    finalizeNonce(k0h) {
        const k0 = mod(bytesToNumber(k0h), CURVE.n);
        if (k0 === _0n)
            throw new Error('sign: Creation of signature failed. k is zero');
        const { point: R, x: rx, scalar: k } = this.getScalar(k0);
        return { R, rx, k };
    }
    finalizeSig(R, k, e, d) {
        return new SchnorrSignature(R.x, mod(k + e * d, CURVE.n)).toRawBytes();
    }
    error() {
        throw new Error('sign: Invalid signature produced');
    }
    async calc() {
        const { m, d, px, rand } = this;
        const tag = utils.taggedHash;
        const t = this.initNonce(d, await tag(TAGS.aux, rand));
        const { R, rx, k } = this.finalizeNonce(await tag(TAGS.nonce, t, px, m));
        const e = schnorrChallengeFinalize(await tag(TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!(await schnorrVerify(sig, m, px)))
            this.error();
        return sig;
    }
    calcSync() {
        const { m, d, px, rand } = this;
        const tag = utils.taggedHashSync;
        const t = this.initNonce(d, tag(TAGS.aux, rand));
        const { R, rx, k } = this.finalizeNonce(tag(TAGS.nonce, t, px, m));
        const e = schnorrChallengeFinalize(tag(TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!schnorrVerifySync(sig, m, px))
            this.error();
        return sig;
    }
}
async function schnorrSign(msg, privKey, auxRand) {
    return new InternalSchnorrSignature(msg, privKey, auxRand).calc();
}
function schnorrSignSync(msg, privKey, auxRand) {
    return new InternalSchnorrSignature(msg, privKey, auxRand).calcSync();
}
function initSchnorrVerify(signature, message, publicKey) {
    const raw = signature instanceof SchnorrSignature;
    const sig = raw ? signature : SchnorrSignature.fromHex(signature);
    if (raw)
        sig.assertValidity();
    return {
        ...sig,
        m: ensureBytes(message),
        P: normalizePublicKey(publicKey),
    };
}
function finalizeSchnorrVerify(r, P, s, e) {
    const R = Point.BASE.multiplyAndAddUnsafe(P, normalizePrivateKey(s), mod(-e, CURVE.n));
    if (!R || !R.hasEvenY() || R.x !== r)
        return false;
    return true;
}
async function schnorrVerify(signature, message, publicKey) {
    try {
        const { r, s, m, P } = initSchnorrVerify(signature, message, publicKey);
        const e = schnorrChallengeFinalize(await utils.taggedHash(TAGS.challenge, numTo32b(r), P.toRawX(), m));
        return finalizeSchnorrVerify(r, P, s, e);
    }
    catch (error) {
        return false;
    }
}
function schnorrVerifySync(signature, message, publicKey) {
    try {
        const { r, s, m, P } = initSchnorrVerify(signature, message, publicKey);
        const e = schnorrChallengeFinalize(utils.taggedHashSync(TAGS.challenge, numTo32b(r), P.toRawX(), m));
        return finalizeSchnorrVerify(r, P, s, e);
    }
    catch (error) {
        if (error instanceof ShaError)
            throw error;
        return false;
    }
}
const schnorr = {
    Signature: SchnorrSignature,
    getPublicKey: schnorrGetPublicKey,
    sign: schnorrSign,
    verify: schnorrVerify,
    signSync: schnorrSignSync,
    verifySync: schnorrVerifySync,
};
Point.BASE._setWindowSize(8);
const esm_crypto = {
    node: crypto_ignored_namespaceObject,
    web: typeof self === 'object' && 'crypto' in self ? self.crypto : undefined,
};
const TAGS = {
    challenge: 'BIP0340/challenge',
    aux: 'BIP0340/aux',
    nonce: 'BIP0340/nonce',
};
const TAGGED_HASH_PREFIXES = {};
const utils = {
    bytesToHex,
    hexToBytes,
    concatBytes,
    mod,
    invert,
    isValidPrivateKey(privateKey) {
        try {
            normalizePrivateKey(privateKey);
            return true;
        }
        catch (error) {
            return false;
        }
    },
    _bigintTo32Bytes: numTo32b,
    _normalizePrivateKey: normalizePrivateKey,
    hashToPrivateKey: (hash) => {
        hash = ensureBytes(hash);
        const minLen = groupLen + 8;
        if (hash.length < minLen || hash.length > 1024) {
            throw new Error(`Expected valid bytes of private key as per FIPS 186`);
        }
        const num = mod(bytesToNumber(hash), CURVE.n - _1n) + _1n;
        return numTo32b(num);
    },
    randomBytes: (bytesLength = 32) => {
        if (esm_crypto.web) {
            return esm_crypto.web.getRandomValues(new Uint8Array(bytesLength));
        }
        else if (esm_crypto.node) {
            const { randomBytes } = esm_crypto.node;
            return Uint8Array.from(randomBytes(bytesLength));
        }
        else {
            throw new Error("The environment doesn't have randomBytes function");
        }
    },
    randomPrivateKey: () => utils.hashToPrivateKey(utils.randomBytes(groupLen + 8)),
    precompute(windowSize = 8, point = Point.BASE) {
        const cached = point === Point.BASE ? point : new Point(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply(_3n);
        return cached;
    },
    sha256: async (...messages) => {
        if (esm_crypto.web) {
            const buffer = await esm_crypto.web.subtle.digest('SHA-256', concatBytes(...messages));
            return new Uint8Array(buffer);
        }
        else if (esm_crypto.node) {
            const { createHash } = esm_crypto.node;
            const hash = createHash('sha256');
            messages.forEach((m) => hash.update(m));
            return Uint8Array.from(hash.digest());
        }
        else {
            throw new Error("The environment doesn't have sha256 function");
        }
    },
    hmacSha256: async (key, ...messages) => {
        if (esm_crypto.web) {
            const ckey = await esm_crypto.web.subtle.importKey('raw', key, { name: 'HMAC', hash: { name: 'SHA-256' } }, false, ['sign']);
            const message = concatBytes(...messages);
            const buffer = await esm_crypto.web.subtle.sign('HMAC', ckey, message);
            return new Uint8Array(buffer);
        }
        else if (esm_crypto.node) {
            const { createHmac } = esm_crypto.node;
            const hash = createHmac('sha256', key);
            messages.forEach((m) => hash.update(m));
            return Uint8Array.from(hash.digest());
        }
        else {
            throw new Error("The environment doesn't have hmac-sha256 function");
        }
    },
    sha256Sync: undefined,
    hmacSha256Sync: undefined,
    taggedHash: async (tag, ...messages) => {
        let tagP = TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = await utils.sha256(Uint8Array.from(tag, (c) => c.charCodeAt(0)));
            tagP = concatBytes(tagH, tagH);
            TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return utils.sha256(tagP, ...messages);
    },
    taggedHashSync: (tag, ...messages) => {
        if (typeof _sha256Sync !== 'function')
            throw new ShaError('sha256Sync is undefined, you need to set it');
        let tagP = TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = _sha256Sync(Uint8Array.from(tag, (c) => c.charCodeAt(0)));
            tagP = concatBytes(tagH, tagH);
            TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return _sha256Sync(tagP, ...messages);
    },
    _JacobianPoint: JacobianPoint,
};
Object.defineProperties(utils, {
    sha256Sync: {
        configurable: false,
        get() {
            return _sha256Sync;
        },
        set(val) {
            if (!_sha256Sync)
                _sha256Sync = val;
        },
    },
    hmacSha256Sync: {
        configurable: false,
        get() {
            return _hmacSha256Sync;
        },
        set(val) {
            if (!_hmacSha256Sync)
                _hmacSha256Sync = val;
        },
    },
});

;// CONCATENATED MODULE: ./node_modules/@everipedia/web3-signer/node_modules/viem/dist/chunk-JG6MI5ZV.mjs
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/abi/index.ts


// src/errors/utils.ts


// package.json
var package_default = {
  name: "viem",
  description: "TypeScript Interface for Ethereum",
  version: "0.1.23",
  scripts: {
    anvil: "source .env && anvil --fork-url $VITE_ANVIL_FORK_URL --fork-block-number $VITE_ANVIL_BLOCK_NUMBER --block-time $VITE_ANVIL_BLOCK_TIME",
    bench: "vitest bench --no-threads",
    "bench:ci": "CI=true vitest bench --no-threads",
    build: "tsup",
    changeset: "changeset",
    "changeset:release": "pnpm build && changeset publish",
    "changeset:version": "changeset version && pnpm install --lockfile-only",
    clean: "rimraf dist abi chains contract ens public test utils wallet window",
    "contracts:build": "wagmi generate",
    dev: "DEV=true tsup",
    "dev:docs": "pnpm -r --filter site dev",
    format: "rome format src/ --write",
    lint: "rome check .",
    "lint:fix": "pnpm lint --apply-suggested",
    playground: "pnpm --filter playground-browser dev",
    postinstall: "pnpm dev && pnpm contracts:build",
    preinstall: "npx only-allow pnpm",
    prepublishOnly: "pnpm bun scripts/prepublishOnly.ts",
    prepare: "npx simple-git-hooks",
    test: "vitest dev --no-threads",
    "test:cov": "vitest dev --coverage --no-threads",
    "test:ci": "CI=true vitest --coverage --no-threads",
    "test:typecheck": "SKIP_GLOBAL_SETUP=true vitest typecheck",
    "test:ui": "vitest dev --ui --no-threads",
    "ts-node": "bun",
    typecheck: "tsc --noEmit"
  },
  tsup: {
    entry: [
      "src/index.ts",
      "src/abi.ts",
      "src/chains.ts",
      "src/contract.ts",
      "src/ens.ts",
      "src/ethers.ts",
      "src/public.ts",
      "src/test.ts",
      "src/utils/index.ts",
      "src/wallet.ts",
      "src/window.ts"
    ]
  },
  files: [
    "/abi",
    "/dist",
    "/chains",
    "/contract",
    "/ens",
    "/ethers",
    "/public",
    "/test",
    "/utils",
    "/wallet",
    "/window"
  ],
  exports: {
    ".": {
      types: "./dist/index.d.ts",
      module: "./dist/index.mts",
      default: "./dist/index.js"
    },
    "./abi": {
      types: "./dist/abi.d.ts",
      module: "./dist/abi.mts",
      default: "./dist/abi.js"
    },
    "./chains": {
      types: "./dist/chains.d.ts",
      module: "./dist/chains.mts",
      default: "./dist/chains.js"
    },
    "./contract": {
      types: "./dist/contract.d.ts",
      module: "./dist/contract.mts",
      default: "./dist/contract.js"
    },
    "./ens": {
      types: "./dist/ens.d.ts",
      module: "./dist/ens.mts",
      default: "./dist/ens.js"
    },
    "./ethers": {
      types: "./dist/ethers.d.ts",
      module: "./dist/ethers.mts",
      default: "./dist/ethers.js"
    },
    "./public": {
      types: "./dist/public.d.ts",
      module: "./dist/public.mts",
      default: "./dist/public.js"
    },
    "./test": {
      types: "./dist/test.d.ts",
      module: "./dist/test.mts",
      default: "./dist/test.js"
    },
    "./utils": {
      types: "./dist/utils/index.d.ts",
      module: "./dist/utils/index.mts",
      default: "./dist/utils/index.js"
    },
    "./wallet": {
      types: "./dist/wallet.d.ts",
      module: "./dist/wallet.mts",
      default: "./dist/wallet.js"
    },
    "./window": {
      types: "./dist/window.d.ts",
      module: "./dist/window.mts",
      default: "./dist/window.js"
    },
    "./package.json": "./package.json"
  },
  main: "dist/index.js",
  module: "dist/index.mjs",
  types: "dist/index.d.ts",
  sideEffects: false,
  dependencies: {
    "@noble/hashes": "^1.1.2",
    "@noble/secp256k1": "^1.7.1",
    "@wagmi/chains": "~0.2.11",
    abitype: "~0.7.1",
    "idna-uts46-hx": "^4.1.2",
    "isomorphic-ws": "^5.0.0",
    ws: "^8.12.0"
  },
  devDependencies: {
    "@actions/core": "^1.10.0",
    "@actions/github": "^5.1.1",
    "@adraffy/ens-normalize": "^1.8.9",
    "@changesets/changelog-github": "^0.4.5",
    "@changesets/cli": "^2.23.2",
    "@types/dedent": "^0.7.0",
    "@types/fs-extra": "^9.0.13",
    "@types/node": "^17.0.45",
    "@types/ws": "^8.5.4",
    "@vitest/coverage-c8": "^0.29.2",
    "@vitest/ui": "^0.29.2",
    "@wagmi/cli": "^0.1.6",
    bun: "^0.5.5",
    bundlewatch: "^0.3.3",
    dedent: "^0.7.0",
    ethers: "^5.7.2",
    "ethers@6": "npm:ethers@^6.0.2",
    execa: "^6.1.0",
    "fs-extra": "^10.1.0",
    rimraf: "^4.1.2",
    rome: "^11.0.0",
    "simple-git-hooks": "^2.8.1",
    tsup: "^6.6.0",
    typescript: "^4.9.4",
    vite: "^4.1.4",
    vitest: "~0.29.2"
  },
  license: "MIT",
  repository: "wagmi-dev/viem",
  authors: [
    "awkweb.eth",
    "jxom.eth"
  ],
  keywords: [
    "eth",
    "ethereum",
    "dapps",
    "wallet",
    "web3"
  ],
  "simple-git-hooks": {
    "pre-commit": "pnpm format && pnpm lint:fix"
  },
  pnpm: {
    patchedDependencies: {
      "vitepress@1.0.0-alpha.61": "patches/vitepress@1.0.0-alpha.61.patch"
    },
    peerDependencyRules: {
      ignoreMissing: [
        "@algolia/client-search"
      ]
    }
  }
};

// src/errors/utils.ts
var getContractAddress = (address) => address;
var getUrl = (url) => url;
var getVersion = () => `${package_default.name}@${package_default.version}`;

// src/errors/base.ts
var BaseError = class extends Error {
  constructor(shortMessage, args = {}) {
    const details = args.cause instanceof BaseError ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
    const docsPath6 = args.cause instanceof BaseError ? args.cause.docsPath || args.docsPath : args.docsPath;
    const message = [
      shortMessage || "An error occurred.",
      "",
      ...args.metaMessages ? [...args.metaMessages, ""] : [],
      ...docsPath6 ? [`Docs: https://viem.sh${docsPath6}.html`] : [],
      ...details ? [`Details: ${details}`] : [],
      `Version: ${getVersion()}`
    ].join("\n");
    super(message);
    __publicField(this, "details");
    __publicField(this, "docsPath");
    __publicField(this, "metaMessages");
    __publicField(this, "shortMessage");
    __publicField(this, "name", "ViemError");
    if (args.cause)
      this.cause = args.cause;
    this.details = details;
    this.docsPath = docsPath6;
    this.metaMessages = args.metaMessages;
    this.shortMessage = shortMessage;
  }
};

// src/errors/abi.ts
var AbiConstructorNotFoundError = class extends BaseError {
  constructor({ docsPath: docsPath6 }) {
    super(
      [
        "A constructor was not found on the ABI.",
        "Make sure you are using the correct ABI and that the constructor exists on it."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiConstructorNotFoundError");
  }
};
var AbiConstructorParamsNotFoundError = class extends BaseError {
  constructor({ docsPath: docsPath6 }) {
    super(
      [
        "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
        "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiConstructorParamsNotFoundError");
  }
};
var AbiDecodingDataSizeInvalidError = class extends BaseError {
  constructor(size2) {
    super(
      [
        `Data size of ${size2} bytes is invalid.`,
        "Size must be in increments of 32 bytes (size % 32 === 0)."
      ].join("\n")
    );
    __publicField(this, "name", "AbiDecodingDataSizeInvalidError");
  }
};
var AbiDecodingZeroDataError = class extends BaseError {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.');
    __publicField(this, "name", "AbiDecodingZeroDataError");
  }
};
var AbiEncodingArrayLengthMismatchError = class extends BaseError {
  constructor({
    expectedLength,
    givenLength,
    type
  }) {
    super(
      [
        `ABI encoding array length mismatch for type ${type}.`,
        `Expected length: ${expectedLength}`,
        `Given length: ${givenLength}`
      ].join("\n")
    );
    __publicField(this, "name", "AbiEncodingArrayLengthMismatchError");
  }
};
var AbiEncodingBytesSizeMismatchError = class extends BaseError {
  constructor({ expectedSize, value }) {
    super(
      `Size of bytes "${value}" (bytes${size(
        value
      )}) does not match expected size (bytes${expectedSize}).`
    );
    __publicField(this, "name", "AbiEncodingBytesSizeMismatchError");
  }
};
var AbiEncodingLengthMismatchError = class extends BaseError {
  constructor({
    expectedLength,
    givenLength
  }) {
    super(
      [
        "ABI encoding params/values length mismatch.",
        `Expected length (params): ${expectedLength}`,
        `Given length (values): ${givenLength}`
      ].join("\n")
    );
    __publicField(this, "name", "AbiEncodingLengthMismatchError");
  }
};
var AbiErrorInputsNotFoundError = class extends BaseError {
  constructor(errorName, { docsPath: docsPath6 }) {
    super(
      [
        `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
        "Cannot encode error result without knowing what the parameter types are.",
        "Make sure you are using the correct ABI and that the inputs exist on it."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiErrorInputsNotFoundError");
  }
};
var AbiErrorNotFoundError = class extends BaseError {
  constructor(errorName, { docsPath: docsPath6 }) {
    super(
      [
        `Error "${errorName}" not found on ABI.`,
        "Make sure you are using the correct ABI and that the error exists on it."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiErrorNotFoundError");
  }
};
var AbiErrorSignatureNotFoundError = class extends BaseError {
  constructor(signature, { docsPath: docsPath6 }) {
    super(
      [
        `Encoded error signature "${signature}" not found on ABI.`,
        "Make sure you are using the correct ABI and that the error exists on it.",
        `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiErrorSignatureNotFoundError");
  }
};
var AbiEventSignatureEmptyTopicsError = class extends BaseError {
  constructor({ docsPath: docsPath6 }) {
    super("Cannot extract event signature from empty topics.", {
      docsPath: docsPath6
    });
    __publicField(this, "name", "AbiEventSignatureEmptyTopicsError");
  }
};
var AbiEventSignatureNotFoundError = class extends BaseError {
  constructor(signature, { docsPath: docsPath6 }) {
    super(
      [
        `Encoded event signature "${signature}" not found on ABI.`,
        "Make sure you are using the correct ABI and that the event exists on it.",
        `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiEventSignatureNotFoundError");
  }
};
var AbiEventNotFoundError = class extends BaseError {
  constructor(eventName, { docsPath: docsPath6 }) {
    super(
      [
        `Event "${eventName}" not found on ABI.`,
        "Make sure you are using the correct ABI and that the event exists on it."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiEventNotFoundError");
  }
};
var AbiFunctionNotFoundError = class extends BaseError {
  constructor(functionName, { docsPath: docsPath6 }) {
    super(
      [
        `Function "${functionName}" not found on ABI.`,
        "Make sure you are using the correct ABI and that the function exists on it."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiFunctionNotFoundError");
  }
};
var AbiFunctionOutputsNotFoundError = class extends BaseError {
  constructor(functionName, { docsPath: docsPath6 }) {
    super(
      [
        `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
        "Cannot decode function result without knowing what the parameter types are.",
        "Make sure you are using the correct ABI and that the function exists on it."
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiFunctionOutputsNotFoundError");
  }
};
var AbiFunctionSignatureNotFoundError = class extends BaseError {
  constructor(signature, { docsPath: docsPath6 }) {
    super(
      [
        `Encoded function signature "${signature}" not found on ABI.`,
        "Make sure you are using the correct ABI and that the function exists on it.",
        `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
      ].join("\n"),
      {
        docsPath: docsPath6
      }
    );
    __publicField(this, "name", "AbiFunctionSignatureNotFoundError");
  }
};
var BytesSizeMismatchError = class extends BaseError {
  constructor({
    expectedSize,
    givenSize
  }) {
    super(`Expected bytes${expectedSize}, got bytes${givenSize}.`);
    __publicField(this, "name", "BytesSizeMismatchError");
  }
};
var DecodeLogTopicsMismatch = class extends BaseError {
  constructor({
    abiItem,
    param
  }) {
    super(
      [
        `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${formatAbiItem(abiItem, { includeName: true })}".`
      ].join("\n")
    );
    __publicField(this, "name", "DecodeLogTopicsMismatch");
  }
};
var InvalidAbiEncodingTypeError = class extends BaseError {
  constructor(type, { docsPath: docsPath6 }) {
    super(
      [
        `Type "${type}" is not a valid encoding type.`,
        "Please provide a valid ABI type."
      ].join("\n"),
      { docsPath: docsPath6 }
    );
    __publicField(this, "name", "InvalidAbiEncodingType");
  }
};
var InvalidAbiDecodingTypeError = class extends BaseError {
  constructor(type, { docsPath: docsPath6 }) {
    super(
      [
        `Type "${type}" is not a valid decoding type.`,
        "Please provide a valid ABI type."
      ].join("\n"),
      { docsPath: docsPath6 }
    );
    __publicField(this, "name", "InvalidAbiDecodingType");
  }
};
var InvalidArrayError = class extends BaseError {
  constructor(value) {
    super([`Value "${value}" is not a valid array.`].join("\n"));
    __publicField(this, "name", "InvalidArrayError");
  }
};
var InvalidDefinitionTypeError = class extends BaseError {
  constructor(type) {
    super(
      [
        `"${type}" is not a valid definition type.`,
        'Valid types: "function", "event", "error"'
      ].join("\n")
    );
    __publicField(this, "name", "InvalidDefinitionTypeError");
  }
};
var UnsupportedPackedAbiType = class extends BaseError {
  constructor(type) {
    super(`Type "${type}" is not supported for packed encoding.`);
    __publicField(this, "name", "UnsupportedPackedAbiType");
  }
};

// src/errors/address.ts
var InvalidAddressError = class extends BaseError {
  constructor({ address }) {
    super(`Address "${address}" is invalid.`);
    __publicField(this, "name", "InvalidAddressError");
  }
};

// src/errors/block.ts
var BlockNotFoundError = class extends BaseError {
  constructor({
    blockHash,
    blockNumber
  }) {
    let identifier = "Block";
    if (blockHash)
      identifier = `Block at hash "${blockHash}"`;
    if (blockNumber)
      identifier = `Block at number "${blockNumber}"`;
    super(`${identifier} could not be found.`);
    __publicField(this, "name", "BlockNotFoundError");
  }
};

// src/errors/chain.ts
var ChainDoesNotSupportContract = class extends BaseError {
  constructor({
    blockNumber,
    chain,
    contract
  }) {
    super(
      `Chain "${chain.name}" does not support contract "${contract.name}".`,
      {
        metaMessages: [
          "This could be due to any of the following:",
          ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
            `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
          ] : [
            `- The chain does not have the contract "${contract.name}" configured.`
          ]
        ]
      }
    );
    __publicField(this, "name", "ChainDoesNotSupportContract");
  }
};
var ChainMismatchError = class extends (/* unused pure expression or super */ null && (BaseError)) {
  constructor({
    chain,
    currentChainId
  }) {
    super(
      `The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u2013 ${chain.name}).`,
      {
        metaMessages: [
          `Current Chain ID:  ${currentChainId}`,
          `Expected Chain ID: ${chain.id} \u2013 ${chain.name}`
        ]
      }
    );
    __publicField(this, "name", "ChainMismatchError");
  }
};

// src/constants/abis.ts
var multicall3Abi = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/constants/solidity.ts
var panicReasons = {
  1: "An `assert` condition failed.",
  17: "Arithmic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
};
var solidityError = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
};
var solidityPanic = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};

// src/constants/unit.ts
var etherUnits = {
  gwei: 9,
  wei: 18
};
var gweiUnits = {
  ether: -9,
  wei: 9
};
var weiUnits = {
  ether: -18,
  gwei: -9
};

// src/errors/transaction.ts
function prettyPrint(args) {
  const entries = Object.entries(args).map(([key, value]) => {
    if (value === void 0 || value === false)
      return null;
    return [key, value];
  }).filter(Boolean);
  const maxLength = entries.reduce((acc, [key]) => Math.max(acc, key.length), 0);
  return entries.map(([key, value]) => `  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
var FeeConflictError = class extends BaseError {
  constructor() {
    super(
      [
        "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
        "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
      ].join("\n")
    );
    __publicField(this, "name", "FeeConflictError");
  }
};
var TransactionExecutionError = class extends BaseError {
  constructor(cause, {
    account,
    docsPath: docsPath6,
    chain,
    data,
    gas,
    gasPrice,
    maxFeePerGas,
    maxPriorityFeePerGas,
    nonce,
    to,
    value
  }) {
    const prettyArgs = prettyPrint({
      chain: chain && `${chain?.name} (id: ${chain?.id})`,
      from: account.address,
      to,
      value: typeof value !== "undefined" && `${formatEther(value)} ${chain?.nativeCurrency.symbol || "ETH"}`,
      data,
      gas,
      gasPrice: typeof gasPrice !== "undefined" && `${formatGwei(gasPrice)} gwei`,
      maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${formatGwei(maxFeePerGas)} gwei`,
      maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${formatGwei(maxPriorityFeePerGas)} gwei`,
      nonce
    });
    super(cause.shortMessage, {
      cause,
      docsPath: docsPath6,
      metaMessages: [
        ...cause.metaMessages ? [...cause.metaMessages, " "] : [],
        "Request Arguments:",
        prettyArgs
      ].filter(Boolean)
    });
    __publicField(this, "cause");
    __publicField(this, "name", "TransactionExecutionError");
    this.cause = cause;
  }
};
var TransactionNotFoundError = class extends (/* unused pure expression or super */ null && (BaseError)) {
  constructor({
    blockHash,
    blockNumber,
    blockTag,
    hash: hash2,
    index
  }) {
    let identifier = "Transaction";
    if (blockTag && index !== void 0)
      identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
    if (blockHash && index !== void 0)
      identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
    if (blockNumber && index !== void 0)
      identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
    if (hash2)
      identifier = `Transaction with hash "${hash2}"`;
    super(`${identifier} could not be found.`);
    __publicField(this, "name", "TransactionNotFoundError");
  }
};
var TransactionReceiptNotFoundError = class extends (/* unused pure expression or super */ null && (BaseError)) {
  constructor({ hash: hash2 }) {
    super(
      `Transaction receipt with hash "${hash2}" could not be found. The Transaction may not be processed on a block yet.`
    );
    __publicField(this, "name", "TransactionReceiptNotFoundError");
  }
};
var WaitForTransactionReceiptTimeoutError = class extends (/* unused pure expression or super */ null && (BaseError)) {
  constructor({ hash: hash2 }) {
    super(
      `Timed out while waiting for transaction with hash "${hash2}" to be confirmed.`
    );
    __publicField(this, "name", "WaitForTransactionReceiptTimeoutError");
  }
};

// src/errors/contract.ts
var CallExecutionError = class extends BaseError {
  constructor(cause, {
    account,
    docsPath: docsPath6,
    chain,
    data,
    gas,
    gasPrice,
    maxFeePerGas,
    maxPriorityFeePerGas,
    nonce,
    to,
    value
  }) {
    const prettyArgs = prettyPrint({
      from: account?.address,
      to,
      value: typeof value !== "undefined" && `${formatEther(value)} ${chain?.nativeCurrency.symbol || "ETH"}`,
      data,
      gas,
      gasPrice: typeof gasPrice !== "undefined" && `${formatGwei(gasPrice)} gwei`,
      maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${formatGwei(maxFeePerGas)} gwei`,
      maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${formatGwei(maxPriorityFeePerGas)} gwei`,
      nonce
    });
    super(cause.shortMessage, {
      cause,
      docsPath: docsPath6,
      metaMessages: [
        ...cause.metaMessages ? [...cause.metaMessages, " "] : [],
        "Raw Call Arguments:",
        prettyArgs
      ].filter(Boolean)
    });
    __publicField(this, "cause");
    __publicField(this, "name", "CallExecutionError");
    this.cause = cause;
  }
};
var ContractFunctionExecutionError = class extends BaseError {
  constructor(cause, {
    abi,
    args,
    contractAddress,
    docsPath: docsPath6,
    functionName,
    sender
  }) {
    const abiItem = getAbiItem({ abi, args, name: functionName });
    const formattedArgs = abiItem ? formatAbiItemWithArgs({
      abiItem,
      args,
      includeFunctionName: false,
      includeName: false
    }) : void 0;
    const functionWithParams = abiItem ? formatAbiItem(abiItem, { includeName: true }) : void 0;
    const prettyArgs = prettyPrint({
      address: contractAddress && getContractAddress(contractAddress),
      function: functionWithParams,
      args: formattedArgs && formattedArgs !== "()" && `${[...Array(functionName?.length ?? 0).keys()].map(() => " ").join("")}${formattedArgs}`,
      sender
    });
    super(
      cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`,
      {
        cause,
        docsPath: docsPath6,
        metaMessages: [
          ...cause.metaMessages ? [...cause.metaMessages, " "] : [],
          "Contract Call:",
          prettyArgs
        ].filter(Boolean)
      }
    );
    __publicField(this, "abi");
    __publicField(this, "args");
    __publicField(this, "cause");
    __publicField(this, "contractAddress");
    __publicField(this, "formattedArgs");
    __publicField(this, "functionName");
    __publicField(this, "sender");
    __publicField(this, "name", "ContractFunctionExecutionError");
    this.abi = abi;
    this.args = args;
    this.cause = cause;
    this.contractAddress = contractAddress;
    this.functionName = functionName;
    this.sender = sender;
  }
};
var ContractFunctionRevertedError = class extends BaseError {
  constructor({
    abi,
    data,
    functionName,
    message
  }) {
    let decodedData = void 0;
    let metaMessages;
    let reason;
    if (data && data !== "0x") {
      decodedData = decodeErrorResult({ abi, data });
      const { abiItem, errorName, args: errorArgs } = decodedData;
      if (errorName === "Error") {
        reason = errorArgs[0];
      } else if (errorName === "Panic") {
        const [firstArg] = errorArgs;
        reason = panicReasons[firstArg];
      } else if (errorArgs) {
        const errorWithParams = abiItem ? formatAbiItem(abiItem, { includeName: true }) : void 0;
        const formattedArgs = abiItem ? formatAbiItemWithArgs({
          abiItem,
          args: errorArgs,
          includeFunctionName: false,
          includeName: false
        }) : void 0;
        metaMessages = [
          errorWithParams ? `Error: ${errorWithParams}` : "",
          formattedArgs && formattedArgs !== "()" ? `       ${[...Array(errorName?.length ?? 0).keys()].map(() => " ").join("")}${formattedArgs}` : ""
        ];
      }
    } else if (message)
      reason = message;
    super(
      reason ? [
        `The contract function "${functionName}" reverted with the following reason:`,
        reason
      ].join("\n") : `The contract function "${functionName}" reverted.`,
      {
        metaMessages
      }
    );
    __publicField(this, "name", "ContractFunctionRevertedError");
    __publicField(this, "data");
    __publicField(this, "reason");
    this.reason = reason;
    this.data = decodedData;
  }
};
var ContractFunctionZeroDataError = class extends BaseError {
  constructor({ functionName }) {
    super(`The contract function "${functionName}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${functionName}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ]
    });
    __publicField(this, "name", "ContractFunctionZeroDataError");
  }
};
var RawContractError = class extends BaseError {
  constructor({ data, message }) {
    super(message || "");
    __publicField(this, "code", 3);
    __publicField(this, "name", "RawContractError");
    __publicField(this, "data");
    this.data = data;
  }
};

// src/errors/data.ts
var SizeExceedsPaddingSizeError = class extends BaseError {
  constructor({
    size: size2,
    targetSize,
    type
  }) {
    super(
      `${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size2}) exceeds padding size (${targetSize}).`
    );
    __publicField(this, "name", "SizeExceedsPaddingSizeError");
  }
};

// src/errors/encoding.ts
var DataLengthTooLongError = class extends BaseError {
  constructor({ consumed, length }) {
    super(
      `Consumed bytes (${consumed}) is shorter than data length (${length - 1}).`
    );
    __publicField(this, "name", "DataLengthTooLongError");
  }
};
var DataLengthTooShortError = class extends BaseError {
  constructor({ length, dataLength }) {
    super(
      `Data length (${dataLength - 1}) is shorter than prefix length (${length - 1}).`
    );
    __publicField(this, "name", "DataLengthTooShortError");
  }
};
var IntegerOutOfRangeError = class extends BaseError {
  constructor({
    max,
    min,
    signed,
    size: size2,
    value
  }) {
    super(
      `Number "${value}" is not in safe ${size2 ? `${size2 * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`
    );
    __publicField(this, "name", "IntegerOutOfRangeError");
  }
};
var InvalidBytesBooleanError = class extends BaseError {
  constructor(bytes) {
    super(
      `Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`
    );
    __publicField(this, "name", "InvalidBytesBooleanError");
  }
};
var InvalidHexBooleanError = class extends BaseError {
  constructor(hex) {
    super(
      `Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`
    );
    __publicField(this, "name", "InvalidHexBooleanError");
  }
};
var InvalidHexValueError = class extends BaseError {
  constructor(value) {
    super(
      `Hex value "${value}" is an odd length (${value.length}). It must be an even length.`
    );
    __publicField(this, "name", "InvalidHexValueError");
  }
};
var OffsetOutOfBoundsError = class extends BaseError {
  constructor({ nextOffset, offset }) {
    super(
      `Next offset (${nextOffset}) is greater than previous offset + consumed bytes (${offset})`
    );
    __publicField(this, "name", "OffsetOutOfBoundsError");
  }
};

// src/errors/estimateGas.ts
var EstimateGasExecutionError = class extends BaseError {
  constructor(cause, {
    account,
    docsPath: docsPath6,
    chain,
    data,
    gas,
    gasPrice,
    maxFeePerGas,
    maxPriorityFeePerGas,
    nonce,
    to,
    value
  }) {
    const prettyArgs = prettyPrint({
      from: account.address,
      to,
      value: typeof value !== "undefined" && `${formatEther(value)} ${chain?.nativeCurrency.symbol || "ETH"}`,
      data,
      gas,
      gasPrice: typeof gasPrice !== "undefined" && `${formatGwei(gasPrice)} gwei`,
      maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${formatGwei(maxFeePerGas)} gwei`,
      maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${formatGwei(maxPriorityFeePerGas)} gwei`,
      nonce
    });
    super(cause.shortMessage, {
      cause,
      docsPath: docsPath6,
      metaMessages: [
        ...cause.metaMessages ? [...cause.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        prettyArgs
      ].filter(Boolean)
    });
    __publicField(this, "cause");
    __publicField(this, "name", "EstimateGasExecutionError");
    this.cause = cause;
  }
};

// src/errors/log.ts
var FilterTypeNotSupportedError = class extends BaseError {
  constructor(type) {
    super(`Filter type "${type}" is not supported.`);
    __publicField(this, "name", "FilterTypeNotSupportedError");
  }
};

// src/errors/node.ts
var ExecutionRevertedError = class extends BaseError {
  constructor({
    cause,
    message
  } = {}) {
    const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
    super(
      `Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`,
      {
        cause
      }
    );
    __publicField(this, "name", "ExecutionRevertedError");
  }
};
__publicField(ExecutionRevertedError, "code", 3);
__publicField(ExecutionRevertedError, "nodeMessage", /execution reverted/);
var FeeCapTooHighError = class extends BaseError {
  constructor({
    cause,
    maxFeePerGas
  } = {}) {
    super(
      `The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`,
      {
        cause
      }
    );
    __publicField(this, "name", "FeeCapTooHigh");
  }
};
__publicField(FeeCapTooHighError, "nodeMessage", /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/);
var FeeCapTooLowError = class extends BaseError {
  constructor({
    cause,
    maxFeePerGas
  } = {}) {
    super(
      `The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`,
      {
        cause
      }
    );
    __publicField(this, "name", "FeeCapTooLow");
  }
};
__publicField(FeeCapTooLowError, "nodeMessage", /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/);
var NonceTooHighError = class extends BaseError {
  constructor({ cause, nonce } = {}) {
    super(
      `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`,
      { cause }
    );
    __publicField(this, "name", "NonceTooHighError");
  }
};
__publicField(NonceTooHighError, "nodeMessage", /nonce too high/);
var NonceTooLowError = class extends BaseError {
  constructor({ cause, nonce } = {}) {
    super(
      [
        `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
        "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
      ].join("\n"),
      { cause }
    );
    __publicField(this, "name", "NonceTooLowError");
  }
};
__publicField(NonceTooLowError, "nodeMessage", /nonce too low|transaction already imported/);
var NonceMaxValueError = class extends BaseError {
  constructor({ cause, nonce } = {}) {
    super(
      `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`,
      { cause }
    );
    __publicField(this, "name", "NonceMaxValueError");
  }
};
__publicField(NonceMaxValueError, "nodeMessage", /nonce has max value/);
var InsufficientFundsError = class extends BaseError {
  constructor({ cause } = {}) {
    super(
      [
        "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
      ].join("\n"),
      {
        cause,
        metaMessages: [
          "This error could arise when the account does not have enough funds to:",
          " - pay for the total gas fee,",
          " - pay for the value to send.",
          " ",
          "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
          " - `gas` is the amount of gas needed for transaction to execute,",
          " - `gas fee` is the gas fee,",
          " - `value` is the amount of ether to send to the recipient."
        ]
      }
    );
    __publicField(this, "name", "InsufficientFundsError");
  }
};
__publicField(InsufficientFundsError, "nodeMessage", /insufficient funds/);
var IntrinsicGasTooHighError = class extends BaseError {
  constructor({ cause, gas } = {}) {
    super(
      `The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`,
      {
        cause
      }
    );
    __publicField(this, "name", "IntrinsicGasTooHighError");
  }
};
__publicField(IntrinsicGasTooHighError, "nodeMessage", /intrinsic gas too high|gas limit reached/);
var IntrinsicGasTooLowError = class extends BaseError {
  constructor({ cause, gas } = {}) {
    super(
      `The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`,
      {
        cause
      }
    );
    __publicField(this, "name", "IntrinsicGasTooLowError");
  }
};
__publicField(IntrinsicGasTooLowError, "nodeMessage", /intrinsic gas too low/);
var TransactionTypeNotSupportedError = class extends BaseError {
  constructor({ cause }) {
    super("The transaction type is not supported for this chain.", {
      cause
    });
    __publicField(this, "name", "TransactionTypeNotSupportedError");
  }
};
__publicField(TransactionTypeNotSupportedError, "nodeMessage", /transaction type not valid/);
var TipAboveFeeCapError = class extends BaseError {
  constructor({
    cause,
    maxPriorityFeePerGas,
    maxFeePerGas
  } = {}) {
    super(
      [
        `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${formatGwei(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ""}).`
      ].join("\n"),
      {
        cause
      }
    );
    __publicField(this, "name", "TipAboveFeeCapError");
  }
};
__publicField(TipAboveFeeCapError, "nodeMessage", /max priority fee per gas higher than max fee per gas|tip higher than fee cap/);
var UnknownNodeError = class extends BaseError {
  constructor({ cause }) {
    super(`An error occurred while executing: ${cause?.message}`, {
      cause
    });
    __publicField(this, "name", "UnknownNodeError");
  }
};

// src/errors/request.ts
var RequestError = class extends BaseError {
  constructor(err, {
    docsPath: docsPath6,
    metaMessages,
    shortMessage
  }) {
    super(shortMessage, {
      cause: err,
      docsPath: docsPath6,
      metaMessages
    });
    this.name = err.name;
  }
};
var RpcRequestError = class extends RequestError {
  constructor(err, { docsPath: docsPath6, shortMessage }) {
    super(err, { docsPath: docsPath6, metaMessages: err.metaMessages, shortMessage });
    __publicField(this, "code");
    this.code = err.code;
    this.name = err.name;
  }
};
var ParseRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    });
    __publicField(this, "name", "ParseRpcError");
    __publicField(this, "code", -32700);
  }
};
var InvalidRequestRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "JSON is not a valid request object." });
    __publicField(this, "name", "InvalidRequestRpcError");
    __publicField(this, "code", -32600);
  }
};
var MethodNotFoundRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: "The method does not exist / is not available."
    });
    __publicField(this, "name", "MethodNotFoundRpcError");
    __publicField(this, "code", -32601);
  }
};
var InvalidParamsRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join("\n")
    });
    __publicField(this, "name", "InvalidParamsRpcError");
    __publicField(this, "code", -32602);
  }
};
var InternalRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "An internal error was received." });
    __publicField(this, "name", "InternalRpcError");
    __publicField(this, "code", -32603);
  }
};
var InvalidInputRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join("\n")
    });
    __publicField(this, "name", "InvalidInputRpcError");
    __publicField(this, "code", -32e3);
  }
};
var ResourceNotFoundRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "Requested resource not found." });
    __publicField(this, "name", "ResourceNotFoundRpcError");
    __publicField(this, "code", -32001);
  }
};
var ResourceUnavailableRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "Requested resource not available." });
    __publicField(this, "name", "ResourceUnavailableRpcError");
    __publicField(this, "code", -32002);
  }
};
var TransactionRejectedRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "Transaction creation failed." });
    __publicField(this, "name", "TransactionRejectedRpcError");
    __publicField(this, "code", -32003);
  }
};
var MethodNotSupportedRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "Method is not implemented." });
    __publicField(this, "name", "MethodNotSupportedRpcError");
    __publicField(this, "code", -32004);
  }
};
var LimitExceededRpcError = class extends RpcRequestError {
  constructor(err) {
    super(err, { shortMessage: "Request exceeds defined limit." });
    __publicField(this, "name", "LimitExceededRpcError");
    __publicField(this, "code", -32005);
  }
};
var JsonRpcVersionUnsupportedError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: "Version of JSON-RPC protocol is not supported."
    });
    __publicField(this, "name", "JsonRpcVersionUnsupportedError");
    __publicField(this, "code", -32006);
  }
};
var UserRejectedRequestError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: "User rejected the request."
    });
    __publicField(this, "name", "UserRejectedRequestError");
    __publicField(this, "code", 4001);
  }
};
var SwitchChainError = class extends RpcRequestError {
  constructor(err) {
    super(err, {
      shortMessage: "An error occurred when attempting to switch chain."
    });
    __publicField(this, "name", "SwitchChainError");
    __publicField(this, "code", 4902);
  }
};
var UnknownRpcError = class extends RequestError {
  constructor(err) {
    super(err, {
      shortMessage: "An unknown RPC error occurred."
    });
    __publicField(this, "name", "UnknownRpcError");
  }
};

// src/errors/rpc.ts
var HttpRequestError = class extends BaseError {
  constructor({
    body,
    details,
    headers,
    status,
    url
  }) {
    super("HTTP request failed.", {
      details,
      metaMessages: [
        status && `Status: ${status}`,
        `URL: ${getUrl(url)}`,
        `Request body: ${stringify(body)}`
      ].filter(Boolean)
    });
    __publicField(this, "name", "HttpRequestError");
    __publicField(this, "body");
    __publicField(this, "headers");
    __publicField(this, "status");
    __publicField(this, "url");
    this.body = body;
    this.headers = headers;
    this.status = status;
    this.url = url;
  }
};
var WebSocketRequestError = class extends BaseError {
  constructor({
    body,
    details,
    url
  }) {
    super("WebSocket request failed.", {
      details,
      metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify(body)}`]
    });
    __publicField(this, "name", "WebSocketRequestError");
  }
};
var RpcError = class extends BaseError {
  constructor({
    body,
    error,
    url
  }) {
    super("RPC Request failed.", {
      cause: error,
      details: error.message,
      metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify(body)}`]
    });
    __publicField(this, "code");
    __publicField(this, "name", "RpcError");
    this.code = error.code;
  }
};
var TimeoutError = class extends BaseError {
  constructor({
    body,
    url
  }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify(body)}`]
    });
    __publicField(this, "name", "TimeoutError");
  }
};

// src/errors/transport.ts
var UrlRequiredError = class extends (/* unused pure expression or super */ null && (BaseError)) {
  constructor() {
    super(
      "No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.",
      {
        docsPath: "/docs/clients/intro"
      }
    );
  }
};

// src/utils/data/concat.ts
function concat(values) {
  if (typeof values[0] === "string")
    return concatHex(values);
  return chunk_JG6MI5ZV_concatBytes(values);
}
function chunk_JG6MI5ZV_concatBytes(values) {
  let length = 0;
  for (const arr of values) {
    length += arr.length;
  }
  const result = new Uint8Array(length);
  let offset = 0;
  for (const arr of values) {
    result.set(arr, offset);
    offset += arr.length;
  }
  return result;
}
function concatHex(values) {
  return `0x${values.reduce(
    (acc, x) => acc + x.replace("0x", ""),
    ""
  )}`;
}

// src/utils/data/isBytes.ts
function isBytes(value) {
  if (!value)
    return false;
  if (typeof value !== "object")
    return false;
  if (!("BYTES_PER_ELEMENT" in value))
    return false;
  return value.BYTES_PER_ELEMENT === 1 && value.constructor.name === "Uint8Array";
}

// src/utils/data/isHex.ts
function isHex(value) {
  if (!value)
    return false;
  if (typeof value !== "string")
    return false;
  return /^0x[0-9a-fA-F]*$/.test(value);
}

// src/utils/data/pad.ts
function pad(hexOrBytes, { dir, size: size2 = 32 } = {}) {
  if (typeof hexOrBytes === "string")
    return padHex(hexOrBytes, { dir, size: size2 });
  return padBytes(hexOrBytes, { dir, size: size2 });
}
function padHex(hex_, { dir, size: size2 = 32 } = {}) {
  if (size2 === null)
    return hex_;
  let hex = hex_.replace("0x", "");
  if (hex.length > size2 * 2)
    throw new SizeExceedsPaddingSizeError({
      size: Math.ceil(hex.length / 2),
      targetSize: size2,
      type: "hex"
    });
  return `0x${hex[dir === "right" ? "padEnd" : "padStart"](
    size2 * 2,
    "0"
  )}`;
}
function padBytes(bytes, { dir, size: size2 = 32 } = {}) {
  if (size2 === null)
    return bytes;
  if (bytes.length > size2)
    throw new SizeExceedsPaddingSizeError({
      size: bytes.length,
      targetSize: size2,
      type: "bytes"
    });
  const paddedBytes = new Uint8Array(size2);
  for (let i = 0; i < size2; i++) {
    const padEnd = dir === "right";
    paddedBytes[padEnd ? i : size2 - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
  }
  return paddedBytes;
}

// src/utils/data/trim.ts
function trim(hexOrBytes, { dir = "left" } = {}) {
  let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
  let sliceLength = 0;
  for (let i = 0; i < data.length - 1; i++) {
    if (data[dir === "left" ? i : data.length - i - 1].toString() === "0")
      sliceLength++;
    else
      break;
  }
  data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
  if (typeof hexOrBytes === "string") {
    if (data.length === 1 && dir === "right")
      data = `${data}0`;
    return `0x${data}`;
  }
  return data;
}

// src/utils/data/size.ts
function size(value) {
  if (isHex(value))
    return Math.ceil((value.length - 2) / 2);
  return value.length;
}

// src/utils/data/slice.ts
function slice(value, start, end) {
  if (isHex(value))
    return sliceHex(value, start, end);
  return sliceBytes(value, start, end);
}
function assertStartOffset(value, start) {
  if (typeof start === "number" && start > 0 && start > size(value) - 1)
    throw new Error(
      `Slice starting at offset "${start}" is out-of-bounds (size: ${size(
        value
      )}).`
    );
}
function sliceBytes(value, start, end) {
  assertStartOffset(value, start);
  return value.slice(start, end);
}
function sliceHex(value_, start, end) {
  assertStartOffset(value_, start);
  const value = value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2);
  return `0x${value}`;
}

// src/utils/encoding/toHex.ts
var chunk_JG6MI5ZV_hexes = Array.from(
  { length: 256 },
  (_v, i) => i.toString(16).padStart(2, "0")
);
function boolToHex(value) {
  return `0x${Number(value)}`;
}
function chunk_JG6MI5ZV_bytesToHex(value) {
  let hex = "";
  for (let i = 0; i < value.length; i++) {
    hex += chunk_JG6MI5ZV_hexes[value[i]];
  }
  return `0x${hex}`;
}
function toHex(value) {
  if (typeof value === "number" || typeof value === "bigint")
    return numberToHex(value);
  if (typeof value === "string") {
    return stringToHex(value);
  }
  if (typeof value === "boolean")
    return boolToHex(value);
  return chunk_JG6MI5ZV_bytesToHex(value);
}
function numberToHex(value_, opts = {}) {
  const { signed, size: size2 } = opts;
  let value = BigInt(value_);
  let maxValue;
  if (size2) {
    if (signed)
      maxValue = (1n << BigInt(size2) * 8n - 1n) - 1n;
    else
      maxValue = 2n ** (BigInt(size2) * 8n) - 1n;
  } else if (typeof value_ === "number") {
    maxValue = BigInt(Number.MAX_SAFE_INTEGER);
  }
  const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
  if (maxValue && value > maxValue || value < minValue) {
    const suffix = typeof value_ === "bigint" ? "n" : "";
    throw new IntegerOutOfRangeError({
      max: maxValue ? `${maxValue}${suffix}` : void 0,
      min: `${minValue}${suffix}`,
      signed,
      size: size2,
      value: `${value_}${suffix}`
    });
  }
  const hex = `0x${(signed && value < 0 ? (1n << BigInt(size2 * 8)) + BigInt(value) : value).toString(16)}`;
  if (size2)
    return pad(hex, { size: size2 });
  return hex;
}
var encoder = new TextEncoder();
function stringToHex(value_) {
  const value = encoder.encode(value_);
  return toHex(value);
}

// src/utils/encoding/toBytes.ts
var encoder2 = new TextEncoder();
function toBytes(value) {
  if (typeof value === "number" || typeof value === "bigint")
    return numberToBytes(value);
  if (typeof value === "boolean")
    return boolToBytes(value);
  if (value.startsWith("0x"))
    return chunk_JG6MI5ZV_hexToBytes(value);
  return stringToBytes(value);
}
function boolToBytes(value) {
  const bytes = new Uint8Array(1);
  bytes[0] = Number(value);
  return bytes;
}
function chunk_JG6MI5ZV_hexToBytes(hex_) {
  let hex = hex_.slice(2);
  if (hex.length % 2)
    hex = `0${hex}`;
  const bytes = new Uint8Array(hex.length / 2);
  for (let index = 0; index < bytes.length; index++) {
    const start = index * 2;
    const hexByte = hex.slice(start, start + 2);
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte) || byte < 0)
      throw new BaseError(`Invalid byte sequence ("${hexByte}" in "${hex}").`);
    bytes[index] = byte;
  }
  return bytes;
}
function numberToBytes(value, opts) {
  const hex = numberToHex(value, opts);
  return chunk_JG6MI5ZV_hexToBytes(hex);
}
function stringToBytes(value) {
  return encoder2.encode(value);
}

// src/utils/encoding/toRlp.ts
function toRlp(hexOrBytes, to_) {
  const to = to_ || "hex";
  return format(bytesToRlp(parse(hexOrBytes)), to);
}
function parse(hexOrBytes) {
  if (Array.isArray(hexOrBytes))
    return hexOrBytes.map(parse);
  return typeof hexOrBytes === "string" ? toBytes(hexOrBytes) : hexOrBytes;
}
function format(bytes, type = "bytes") {
  return type === "hex" ? chunk_JG6MI5ZV_bytesToHex(bytes) : bytes;
}
function bytesToRlp(bytes) {
  if (Array.isArray(bytes)) {
    const encoded = concat(bytes.map(bytesToRlp));
    return new Uint8Array([...encodeLength(encoded.length, 192), ...encoded]);
  }
  if (bytes.length === 1 && bytes[0] < 128)
    return bytes;
  return new Uint8Array([...encodeLength(bytes.length, 128), ...bytes]);
}
function encodeLength(length, offset) {
  if (length < 56)
    return [offset + length];
  return [toBytes(length).length + offset + 55, ...toBytes(length)];
}

// src/utils/encoding/fromHex.ts
function fromHex(hex, to) {
  if (to === "number")
    return chunk_JG6MI5ZV_hexToNumber(hex);
  if (to === "bigint")
    return hexToBigInt(hex);
  if (to === "string")
    return hexToString(hex);
  if (to === "boolean")
    return hexToBool(hex);
  return chunk_JG6MI5ZV_hexToBytes(hex);
}
function hexToBigInt(hex, opts = {}) {
  const { signed } = opts;
  const value = BigInt(hex);
  if (!signed)
    return value;
  const size2 = (hex.length - 2) / 2;
  const max = (1n << BigInt(size2) * 8n - 1n) - 1n;
  if (value <= max)
    return value;
  return value - BigInt(`0x${"f".padStart(size2 * 2, "f")}`) - 1n;
}
function hexToBool(hex) {
  if (trim(hex) === "0x0")
    return false;
  if (trim(hex) === "0x1")
    return true;
  throw new InvalidHexBooleanError(hex);
}
function chunk_JG6MI5ZV_hexToNumber(hex, opts = {}) {
  return Number(hexToBigInt(hex, opts));
}
function hexToString(hex) {
  const bytes = chunk_JG6MI5ZV_hexToBytes(hex);
  return new TextDecoder().decode(bytes);
}

// src/utils/encoding/fromBytes.ts
function fromBytes(bytes, to) {
  if (to === "number")
    return chunk_JG6MI5ZV_bytesToNumber(bytes);
  if (to === "bigint")
    return bytesToBigint(bytes);
  if (to === "boolean")
    return bytesToBool(bytes);
  if (to === "string")
    return bytesToString(bytes);
  return chunk_JG6MI5ZV_bytesToHex(bytes);
}
function bytesToBigint(bytes) {
  const hex = chunk_JG6MI5ZV_bytesToHex(bytes);
  return hexToBigInt(hex);
}
function bytesToBool(bytes) {
  if (bytes.length > 1 || bytes[0] > 1)
    throw new InvalidBytesBooleanError(bytes);
  return Boolean(bytes[0]);
}
function chunk_JG6MI5ZV_bytesToNumber(bytes) {
  const hex = chunk_JG6MI5ZV_bytesToHex(bytes);
  return chunk_JG6MI5ZV_hexToNumber(hex);
}
function bytesToString(bytes) {
  return new TextDecoder().decode(bytes);
}

// src/utils/encoding/fromRlp.ts
function fromRlp(value, to) {
  const bytes = parse2(value);
  const [data, consumed] = rlpToBytes(bytes);
  if (consumed < bytes.length)
    throw new DataLengthTooLongError({
      consumed,
      length: bytes.length
    });
  return format2(data, to);
}
function parse2(value) {
  if (typeof value === "string") {
    if (value.length > 3 && value.length % 2 !== 0)
      throw new InvalidHexValueError(value);
    return chunk_JG6MI5ZV_hexToBytes(value);
  }
  return value;
}
function format2(bytes, to) {
  if (Array.isArray(bytes))
    return bytes.map((b) => format2(b, to));
  return to === "hex" ? chunk_JG6MI5ZV_bytesToHex(bytes) : bytes;
}
function rlpToBytes(bytes, offset = 0) {
  if (bytes.length === 0)
    return [new Uint8Array([]), 0];
  const prefix = bytes[offset];
  if (prefix <= 127)
    return [new Uint8Array([bytes[offset]]), 1];
  if (prefix <= 183) {
    const length2 = prefix - 128;
    const offset_ = offset + 1;
    if (offset_ + length2 > bytes.length)
      throw new DataLengthTooShortError({
        length: offset_ + length2,
        dataLength: bytes.length
      });
    return [bytes.slice(offset_, offset_ + length2), 1 + length2];
  }
  if (prefix <= 191) {
    const lengthOfLength2 = prefix - 183;
    const offset_ = offset + 1;
    const length2 = chunk_JG6MI5ZV_bytesToNumber(bytes.slice(offset_, offset_ + lengthOfLength2));
    if (offset_ + lengthOfLength2 + length2 > bytes.length)
      throw new DataLengthTooShortError({
        length: lengthOfLength2 + length2,
        dataLength: bytes.length - lengthOfLength2
      });
    return [
      bytes.slice(offset_ + lengthOfLength2, offset_ + lengthOfLength2 + length2),
      1 + lengthOfLength2 + length2
    ];
  }
  let lengthOfLength = 0;
  let length = prefix - 192;
  if (prefix > 247) {
    lengthOfLength = prefix - 247;
    length = chunk_JG6MI5ZV_bytesToNumber(bytes.slice(offset + 1, offset + 1 + lengthOfLength));
  }
  let nextOffset = offset + 1 + lengthOfLength;
  if (nextOffset > bytes.length)
    throw new DataLengthTooShortError({
      length: nextOffset,
      dataLength: bytes.length
    });
  let consumed = 1 + lengthOfLength + length;
  let result = [];
  while (nextOffset < offset + consumed) {
    const decoded = rlpToBytes(bytes, nextOffset);
    result.push(decoded[0]);
    nextOffset += decoded[1];
    if (nextOffset > offset + consumed)
      throw new OffsetOutOfBoundsError({
        nextOffset,
        offset: offset + consumed
      });
  }
  return [result, consumed];
}

// src/utils/contract/extractFunctionParts.ts
var paramsRegex = /((function|event)\s)?(.*)(\((.*)\))/;
function extractFunctionParts(def) {
  const parts = def.match(paramsRegex);
  const type = parts?.[2] || void 0;
  const name = parts?.[3];
  const params = parts?.[5] || void 0;
  return { type, name, params };
}
function extractFunctionName(def) {
  return extractFunctionParts(def).name;
}
function extractFunctionParams(def) {
  const params = extractFunctionParts(def).params;
  const splitParams = params?.split(",").map((x) => x.trim().split(" "));
  return splitParams?.map((param) => ({
    type: param[0],
    name: param[1] === "indexed" ? param[2] : param[1],
    ...param[1] === "indexed" ? { indexed: true } : {}
  }));
}
function extractFunctionType(def) {
  return extractFunctionParts(def).type;
}

// src/utils/hash/keccak256.ts

function keccak256(value, to_) {
  const to = to_ || "hex";
  const bytes = (0,sha3/* keccak_256 */.fr)(isHex(value) ? toBytes(value) : value);
  if (to === "bytes")
    return bytes;
  return toHex(bytes);
}

// src/utils/hash/hashFunction.ts
var hash = (value) => keccak256(toBytes(value));
function hashFunction(def) {
  const name = extractFunctionName(def);
  const params = extractFunctionParams(def);
  if (!params || params.length === 0)
    return hash(def.replace(/ /g, ""));
  return hash(`${name}(${params.map(({ type }) => type).join(",")})`);
}

// src/utils/hash/getEventSelector.ts
var getEventSelector = (event) => hashFunction(event);

// src/utils/hash/getFunctionSelector.ts
var getFunctionSelector = (fn) => slice(hashFunction(fn), 0, 4);

// src/utils/address/isAddress.ts
var addressRegex = /^0x[a-fA-F0-9]{40}$/;
function isAddress(address) {
  return addressRegex.test(address);
}

// src/utils/address/getAddress.ts
function checksumAddress(address_) {
  const hexAddress = address_.substring(2).toLowerCase();
  const hash2 = keccak256(stringToBytes(hexAddress), "bytes");
  let address = hexAddress.split("");
  for (let i = 0; i < 40; i += 2) {
    if (hash2[i >> 1] >> 4 >= 8 && address[i]) {
      address[i] = address[i].toUpperCase();
    }
    if ((hash2[i >> 1] & 15) >= 8 && address[i + 1]) {
      address[i + 1] = address[i + 1].toUpperCase();
    }
  }
  return `0x${address.join("")}`;
}
function getAddress(address) {
  if (!isAddress(address))
    throw new InvalidAddressError({ address });
  return checksumAddress(address);
}

// src/utils/address/getContractAddress.ts
function getContractAddress2(opts) {
  if (opts.opcode === "CREATE2")
    return getCreate2Address(opts);
  return getCreateAddress(opts);
}
function getCreateAddress(opts) {
  const from = toBytes(getAddress(opts.from));
  let nonce = toBytes(opts.nonce);
  if (nonce[0] === 0)
    nonce = new Uint8Array([]);
  return getAddress(
    `0x${keccak256(toRlp([from, nonce], "bytes")).slice(26)}`
  );
}
function getCreate2Address(opts) {
  const from = toBytes(getAddress(opts.from));
  const salt = pad(isBytes(opts.salt) ? opts.salt : toBytes(opts.salt), {
    size: 32
  });
  const bytecodeHash = toBytes(
    keccak256(
      isBytes(opts.bytecode) ? opts.bytecode : toBytes(opts.bytecode)
    )
  );
  return getAddress(
    slice(keccak256(concat([toBytes("0xff"), from, salt, bytecodeHash])), 12)
  );
}

// src/utils/address/isAddressEqual.ts
function isAddressEqual(a, b) {
  if (!isAddress(a))
    throw new InvalidAddressError({ address: a });
  if (!isAddress(b))
    throw new InvalidAddressError({ address: b });
  return a.toLowerCase() === b.toLowerCase();
}

// src/utils/abi/encodeAbiParameters.ts
function encodeAbiParameters(params, values) {
  if (params.length !== values.length)
    throw new AbiEncodingLengthMismatchError({
      expectedLength: params.length,
      givenLength: values.length
    });
  const preparedParams = prepareParams({
    params,
    values
  });
  const data = encodeParams(preparedParams);
  if (data.length === 0)
    return "0x";
  return data;
}
function prepareParams({
  params,
  values
}) {
  let preparedParams = [];
  for (let i = 0; i < params.length; i++) {
    preparedParams.push(prepareParam({ param: params[i], value: values[i] }));
  }
  return preparedParams;
}
function prepareParam({
  param,
  value
}) {
  const arrayComponents = getArrayComponents(param.type);
  if (arrayComponents) {
    const [length, type] = arrayComponents;
    return encodeArray(value, { length, param: { ...param, type } });
  }
  if (param.type === "tuple") {
    return encodeTuple(value, {
      param
    });
  }
  if (param.type === "address") {
    return encodeAddress(value);
  }
  if (param.type === "bool") {
    return encodeBool(value);
  }
  if (param.type.startsWith("uint") || param.type.startsWith("int")) {
    const signed = param.type.startsWith("int");
    return encodeNumber(value, { signed });
  }
  if (param.type.startsWith("bytes")) {
    return encodeBytes(value, { param });
  }
  if (param.type === "string") {
    return encodeString(value);
  }
  throw new InvalidAbiEncodingTypeError(param.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function encodeParams(preparedParams) {
  let staticSize = 0;
  for (let i = 0; i < preparedParams.length; i++) {
    const { dynamic, encoded } = preparedParams[i];
    if (dynamic)
      staticSize += 32;
    else
      staticSize += size(encoded);
  }
  let staticParams = [];
  let dynamicParams = [];
  let dynamicSize = 0;
  for (let i = 0; i < preparedParams.length; i++) {
    const { dynamic, encoded } = preparedParams[i];
    if (dynamic) {
      staticParams.push(numberToHex(staticSize + dynamicSize, { size: 32 }));
      dynamicParams.push(encoded);
      dynamicSize += size(encoded);
    } else {
      staticParams.push(encoded);
    }
  }
  return concat([...staticParams, ...dynamicParams]);
}
function encodeAddress(value) {
  if (!isAddress(value))
    throw new InvalidAddressError({ address: value });
  return { dynamic: false, encoded: padHex(value.toLowerCase()) };
}
function encodeArray(value, {
  length,
  param
}) {
  let dynamic = length === null;
  if (!Array.isArray(value))
    throw new InvalidArrayError(value);
  if (!dynamic && value.length !== length)
    throw new AbiEncodingArrayLengthMismatchError({
      expectedLength: length,
      givenLength: value.length,
      type: `${param.type}[${length}]`
    });
  let dynamicChild = false;
  let preparedParams = [];
  for (let i = 0; i < value.length; i++) {
    const preparedParam = prepareParam({ param, value: value[i] });
    if (preparedParam.dynamic)
      dynamicChild = true;
    preparedParams.push(preparedParam);
  }
  if (dynamic || dynamicChild) {
    const data = encodeParams(preparedParams);
    if (dynamic) {
      const length2 = numberToHex(preparedParams.length, { size: 32 });
      return {
        dynamic: true,
        encoded: preparedParams.length > 0 ? concat([length2, data]) : length2
      };
    }
    if (dynamicChild)
      return { dynamic: true, encoded: data };
  }
  return {
    dynamic: false,
    encoded: concat(preparedParams.map(({ encoded }) => encoded))
  };
}
function encodeBytes(value, { param }) {
  const [_, size_] = param.type.split("bytes");
  if (!size_) {
    const partsLength = Math.ceil(size(value) / 32);
    const parts = [];
    for (let i = 0; i < partsLength; i++) {
      parts.push(
        padHex(slice(value, i * 32, (i + 1) * 32), {
          dir: "right"
        })
      );
    }
    return {
      dynamic: true,
      encoded: concat([
        padHex(numberToHex(size(value), { size: 32 })),
        ...parts
      ])
    };
  }
  if (size(value) !== parseInt(size_))
    throw new AbiEncodingBytesSizeMismatchError({
      expectedSize: parseInt(size_),
      value
    });
  return { dynamic: false, encoded: padHex(value, { dir: "right" }) };
}
function encodeBool(value) {
  return { dynamic: false, encoded: padHex(boolToHex(value)) };
}
function encodeNumber(value, { signed }) {
  return {
    dynamic: false,
    encoded: numberToHex(value, {
      size: 32,
      signed
    })
  };
}
function encodeString(value) {
  const hexValue = stringToHex(value);
  const partsLength = Math.ceil(size(hexValue) / 32);
  const parts = [];
  for (let i = 0; i < partsLength; i++) {
    parts.push(
      padHex(slice(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
      })
    );
  }
  return {
    dynamic: true,
    encoded: concat([
      padHex(numberToHex(size(hexValue), { size: 32 })),
      ...parts
    ])
  };
}
function encodeTuple(value, { param }) {
  let dynamic = false;
  let preparedParams = [];
  for (let i = 0; i < param.components.length; i++) {
    const param_ = param.components[i];
    const index = Array.isArray(value) ? i : param_.name;
    const preparedParam = prepareParam({
      param: param_,
      value: value[index]
    });
    preparedParams.push(preparedParam);
    if (preparedParam.dynamic)
      dynamic = true;
  }
  return {
    dynamic,
    encoded: dynamic ? encodeParams(preparedParams) : concat(preparedParams.map(({ encoded }) => encoded))
  };
}
function getArrayComponents(type) {
  const matches = type.match(/^(.*)\[(\d+)?\]$/);
  return matches ? (
    // Return `null` if the array is dynamic.
    [matches[2] ? Number(matches[2]) : null, matches[1]]
  ) : void 0;
}

// src/utils/abi/decodeAbiParameters.ts
function decodeAbiParameters(params, data) {
  if (data === "0x" && params.length > 0)
    throw new AbiDecodingZeroDataError();
  if (size(data) % 32 !== 0)
    throw new AbiDecodingDataSizeInvalidError(size(data));
  return decodeParams({
    data,
    params
  });
}
function decodeParams({
  data,
  params
}) {
  let decodedValues = [];
  let position = 0;
  for (let i = 0; i < params.length; i++) {
    const param = params[i];
    const { consumed, value } = decodeParam({ data, param, position });
    decodedValues.push(value);
    position += consumed;
  }
  return decodedValues;
}
function decodeParam({
  data,
  param,
  position
}) {
  const arrayComponents = getArrayComponents(param.type);
  if (arrayComponents) {
    const [length, type] = arrayComponents;
    return decodeArray(data, {
      length,
      param: { ...param, type },
      position
    });
  }
  if (param.type === "tuple") {
    return decodeTuple(data, { param, position });
  }
  if (param.type === "string") {
    return decodeString(data, { position });
  }
  if (param.type.startsWith("bytes")) {
    return decodeBytes(data, { param, position });
  }
  let value = slice(data, position, position + 32);
  if (param.type.startsWith("uint") || param.type.startsWith("int")) {
    return decodeNumber(value, { param });
  }
  if (param.type === "address") {
    return decodeAddress(value);
  }
  if (param.type === "bool") {
    return decodeBool(value);
  }
  throw new InvalidAbiDecodingTypeError(param.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
function decodeAddress(value) {
  return { consumed: 32, value: checksumAddress(slice(value, -20)) };
}
function decodeArray(data, {
  param,
  length,
  position
}) {
  if (!length) {
    const offset = chunk_JG6MI5ZV_hexToNumber(slice(data, position, position + 32));
    const length2 = chunk_JG6MI5ZV_hexToNumber(slice(data, offset, offset + 32));
    let consumed2 = 0;
    let value2 = [];
    for (let i = 0; i < length2; ++i) {
      const decodedChild = decodeParam({
        data: slice(data, offset + 32),
        param,
        position: consumed2
      });
      consumed2 += decodedChild.consumed;
      value2.push(decodedChild.value);
    }
    return { value: value2, consumed: 32 };
  }
  if (hasDynamicChild(param)) {
    const arrayComponents = getArrayComponents(param.type);
    const dynamicChild = !arrayComponents?.[0];
    let consumed2 = 0;
    let value2 = [];
    for (let i = 0; i < length; ++i) {
      const offset = chunk_JG6MI5ZV_hexToNumber(slice(data, position, position + 32));
      const decodedChild = decodeParam({
        data: slice(data, offset),
        param,
        position: dynamicChild ? consumed2 : i * 32
      });
      consumed2 += decodedChild.consumed;
      value2.push(decodedChild.value);
    }
    return { value: value2, consumed: consumed2 };
  }
  let consumed = 0;
  let value = [];
  for (let i = 0; i < length; ++i) {
    const decodedChild = decodeParam({
      data,
      param,
      position: position + consumed
    });
    consumed += decodedChild.consumed;
    value.push(decodedChild.value);
  }
  return { value, consumed };
}
function decodeBool(value) {
  return { consumed: 32, value: hexToBool(value) };
}
function decodeBytes(data, { param, position }) {
  const [_, size2] = param.type.split("bytes");
  if (!size2) {
    const offset = chunk_JG6MI5ZV_hexToNumber(slice(data, position, position + 32));
    const length = chunk_JG6MI5ZV_hexToNumber(slice(data, offset, offset + 32));
    if (length === 0)
      return { consumed: 32, value: "0x" };
    const value2 = slice(data, offset + 32, offset + 32 + length);
    return { consumed: 32, value: value2 };
  }
  const value = slice(data, position, position + parseInt(size2));
  return { consumed: 32, value };
}
function decodeNumber(value, { param }) {
  const signed = param.type.startsWith("int");
  const size2 = parseInt(param.type.split("int")[1] || "256");
  return {
    consumed: 32,
    value: size2 > 48 ? hexToBigInt(value, { signed }) : chunk_JG6MI5ZV_hexToNumber(value, { signed })
  };
}
function decodeString(data, { position }) {
  const offset = chunk_JG6MI5ZV_hexToNumber(slice(data, position, position + 32));
  const length = chunk_JG6MI5ZV_hexToNumber(slice(data, offset, offset + 32));
  if (length === 0)
    return { consumed: 32, value: "" };
  const value = hexToString(
    trim(slice(data, offset + 32, offset + 32 + length))
  );
  return { consumed: 32, value };
}
function decodeTuple(data, { param, position }) {
  const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name }) => !name);
  let value = hasUnnamedChild ? [] : {};
  let consumed = 0;
  if (hasDynamicChild(param)) {
    const offset = chunk_JG6MI5ZV_hexToNumber(slice(data, position, position + 32));
    for (let i = 0; i < param.components.length; ++i) {
      const component = param.components[i];
      const decodedChild = decodeParam({
        data: slice(data, offset),
        param: component,
        position: consumed
      });
      consumed += decodedChild.consumed;
      value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
    }
    return { consumed: 32, value };
  }
  for (let i = 0; i < param.components.length; ++i) {
    const component = param.components[i];
    const decodedChild = decodeParam({
      data,
      param: component,
      position: position + consumed
    });
    consumed += decodedChild.consumed;
    value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
  }
  return { consumed, value };
}
function hasDynamicChild(param) {
  const { type } = param;
  if (type === "string")
    return true;
  if (type === "bytes")
    return true;
  if (type.endsWith("[]"))
    return true;
  if (type === "tuple")
    return param.components?.some(hasDynamicChild);
  const arrayComponents = getArrayComponents(param.type);
  if (arrayComponents && hasDynamicChild({ ...param, type: arrayComponents[1] }))
    return true;
  return false;
}

// src/utils/abi/formatAbiItem.ts
function formatAbiItem(abiItem, { includeName = false } = {}) {
  if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error")
    throw new InvalidDefinitionTypeError(abiItem.type);
  return `${abiItem.name}(${getParams(abiItem.inputs, { includeName })})`;
}
function getParams(params, { includeName }) {
  if (!params)
    return "";
  return params.map((param) => getParam(param, { includeName })).join(includeName ? ", " : ",");
}
function getParam(param, { includeName }) {
  if (param.type.startsWith("tuple")) {
    return `(${getParams(
      param.components,
      { includeName }
    )})${param.type.slice("tuple".length)}`;
  }
  return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

// src/utils/abi/decodeErrorResult.ts
function decodeErrorResult({
  abi,
  data
}) {
  const signature = slice(data, 0, 4);
  if (signature === "0x")
    throw new AbiDecodingZeroDataError();
  const abi_ = [...abi || [], solidityError, solidityPanic];
  const abiItem = abi_.find(
    (x) => x.type === "error" && signature === getFunctionSelector(formatAbiItem(x))
  );
  if (!abiItem)
    throw new AbiErrorSignatureNotFoundError(signature, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem,
    args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? decodeAbiParameters(abiItem.inputs, slice(data, 4)) : void 0,
    errorName: abiItem.name
  };
}

// src/utils/abi/decodeEventLog.ts
var docsPath = "/docs/contract/decodeEventLog";
function decodeEventLog({
  abi,
  data,
  topics
}) {
  const [signature, ...argTopics] = topics;
  if (!signature)
    throw new AbiEventSignatureEmptyTopicsError({
      docsPath
    });
  const abiItem = abi.find(
    (x) => x.type === "event" && signature === getEventSelector(formatAbiItem(x))
  );
  if (!(abiItem && "name" in abiItem))
    throw new AbiEventSignatureNotFoundError(signature, {
      docsPath
    });
  const { name, inputs } = abiItem;
  const isUnnamed = inputs?.some((x) => !("name" in x && x.name));
  let args = isUnnamed ? [] : {};
  if (argTopics.length > 0) {
    const indexedInputs = inputs.filter((x) => "indexed" in x && x.indexed);
    for (let i = 0; i < indexedInputs.length; i++) {
      const param = indexedInputs[i];
      const topic = argTopics[i];
      if (!topic)
        throw new DecodeLogTopicsMismatch({
          abiItem,
          param
        });
      args[param.name || i] = decodeTopic({ param, value: topic });
    }
  }
  if (data && data !== "0x") {
    const params = inputs.filter((x) => !("indexed" in x && x.indexed));
    const decodedData = decodeAbiParameters(params, data);
    if (decodedData) {
      if (isUnnamed)
        args = [...args, ...decodedData];
      else {
        for (let i = 0; i < params.length; i++) {
          args[params[i].name] = decodedData[i];
        }
      }
    }
  }
  return {
    eventName: name,
    args: Object.values(args).length > 0 ? args : void 0
  };
}
function decodeTopic({ param, value }) {
  if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/))
    return value;
  const decodedArg = decodeAbiParameters([param], value) || [];
  return decodedArg[0];
}

// src/utils/abi/decodeFunctionData.ts
function decodeFunctionData({
  abi,
  data
}) {
  const signature = slice(data, 0, 4);
  const description = abi.find(
    (x) => signature === getFunctionSelector(formatAbiItem(x))
  );
  if (!description)
    throw new AbiFunctionSignatureNotFoundError(signature, {
      docsPath: "/docs/contract/decodeFunctionData"
    });
  return {
    functionName: description.name,
    args: "inputs" in description && description.inputs && description.inputs.length > 0 ? decodeAbiParameters(description.inputs, slice(data, 4)) : void 0
  };
}

// src/utils/abi/getAbiItem.ts
function getAbiItem({
  abi,
  args = [],
  name
}) {
  const abiItems = abi.filter((x) => "name" in x && x.name === name);
  if (abiItems.length === 0)
    return void 0;
  if (abiItems.length === 1)
    return abiItems[0];
  for (const abiItem of abiItems) {
    if (!("inputs" in abiItem))
      continue;
    if (!args || args.length === 0) {
      if (!abiItem.inputs || abiItem.inputs.length === 0)
        return abiItem;
      continue;
    }
    if (!abiItem.inputs)
      continue;
    if (abiItem.inputs.length === 0)
      continue;
    const matched = args.every((arg, index) => {
      const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
      if (!abiParameter)
        return false;
      return isArgOfType(arg, abiParameter);
    });
    if (matched)
      return abiItem;
  }
  return abiItems[0];
}
function isArgOfType(arg, abiParameter) {
  const argType = typeof arg;
  const abiParameterType = abiParameter.type;
  switch (abiParameterType) {
    case "address":
      return isAddress(arg);
    case "bool":
      return argType === "boolean";
    case "function":
      return argType === "string";
    case "string":
      return argType === "string";
    default: {
      if (abiParameterType === "tuple" && "components" in abiParameter)
        return Object.values(abiParameter.components).every(
          (component, index) => {
            return isArgOfType(
              Object.values(arg)[index],
              component
            );
          }
        );
      if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(
        abiParameterType
      ))
        return argType === "number" || argType === "bigint";
      if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType))
        return argType === "string" || arg instanceof Uint8Array;
      if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) {
        return Array.isArray(arg) && arg.every(
          (x) => isArgOfType(x, {
            ...abiParameter,
            // Pop off `[]` or `[M]` from end of type
            type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
          })
        );
      }
      return false;
    }
  }
}

// src/utils/abi/decodeFunctionResult.ts
var docsPath2 = "/docs/contract/decodeFunctionResult";
function decodeFunctionResult({
  abi,
  args,
  functionName,
  data
}) {
  const description = getAbiItem({
    abi,
    args,
    name: functionName
  });
  if (!description)
    throw new AbiFunctionNotFoundError(functionName, { docsPath: docsPath2 });
  if (!("outputs" in description))
    throw new AbiFunctionOutputsNotFoundError(functionName, { docsPath: docsPath2 });
  const values = decodeAbiParameters(description.outputs, data);
  if (values && values.length > 1)
    return values;
  if (values && values.length === 1)
    return values[0];
  return void 0;
}

// src/utils/abi/encodeDeployData.ts
var docsPath3 = "/docs/contract/encodeDeployData";
function encodeDeployData({
  abi,
  args,
  bytecode
}) {
  if (!args || args.length === 0)
    return bytecode;
  const description = abi.find(
    (x) => "type" in x && x.type === "constructor"
  );
  if (!description)
    throw new AbiConstructorNotFoundError({ docsPath: docsPath3 });
  if (!("inputs" in description))
    throw new AbiConstructorParamsNotFoundError({ docsPath: docsPath3 });
  if (!description.inputs || description.inputs.length === 0)
    throw new AbiConstructorParamsNotFoundError({ docsPath: docsPath3 });
  const data = encodeAbiParameters(
    description.inputs,
    args
  );
  return concatHex([bytecode, data]);
}

// src/utils/abi/encodeErrorResult.ts
var docsPath4 = "/docs/contract/encodeErrorResult";
function encodeErrorResult({ abi, errorName, args }) {
  const description = getAbiItem({
    abi,
    args,
    name: errorName
  });
  if (!description)
    throw new AbiErrorNotFoundError(errorName, { docsPath: docsPath4 });
  const definition = formatAbiItem(description);
  const signature = getFunctionSelector(definition);
  let data = "0x";
  if (args && args.length > 0) {
    if (!("inputs" in description && description.inputs))
      throw new AbiErrorInputsNotFoundError(errorName, { docsPath: docsPath4 });
    data = encodeAbiParameters(description.inputs, args);
  }
  return concatHex([signature, data]);
}

// src/utils/abi/encodeEventTopics.ts
function encodeEventTopics({ abi, eventName, args }) {
  const abiItem = getAbiItem({
    abi,
    args,
    name: eventName
  });
  if (!abiItem)
    throw new AbiEventNotFoundError(eventName, {
      docsPath: "/docs/contract/encodeEventTopics"
    });
  const definition = formatAbiItem(abiItem);
  const signature = getEventSelector(definition);
  let topics = [];
  if (args && "inputs" in abiItem) {
    const args_ = Array.isArray(args) ? args : abiItem.inputs?.map((x) => args[x.name]) ?? [];
    topics = abiItem.inputs?.filter((param) => "indexed" in param && param.indexed).map(
      (param, i) => Array.isArray(args_[i]) ? args_[i].map(
        (_, j) => encodeArg({ param, value: args_[i][j] })
      ) : args_[i] ? encodeArg({ param, value: args_[i] }) : null
    ) ?? [];
  }
  return [signature, ...topics];
}
function encodeArg({
  param,
  value
}) {
  if (param.type === "string" || param.type === "bytes")
    return keccak256(toBytes(value));
  if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/))
    throw new FilterTypeNotSupportedError(param.type);
  return encodeAbiParameters([param], [value]);
}

// src/utils/abi/encodeFunctionData.ts
function encodeFunctionData({
  abi,
  args,
  functionName
}) {
  const description = getAbiItem({
    abi,
    args,
    name: functionName
  });
  if (!description)
    throw new AbiFunctionNotFoundError(functionName, {
      docsPath: "/docs/contract/encodeFunctionData"
    });
  const definition = formatAbiItem(description);
  const signature = getFunctionSelector(definition);
  const data = "inputs" in description && description.inputs ? encodeAbiParameters(
    description.inputs,
    args ?? []
  ) : void 0;
  return concatHex([signature, data ?? "0x"]);
}

// src/utils/abi/encodeFunctionResult.ts
var docsPath5 = "/docs/contract/encodeFunctionResult";
function encodeFunctionResult({
  abi,
  functionName,
  result
}) {
  const description = abi.find(
    (x) => "name" in x && x.name === functionName
  );
  if (!description)
    throw new AbiFunctionNotFoundError(functionName, { docsPath: docsPath5 });
  if (!("outputs" in description))
    throw new AbiFunctionOutputsNotFoundError(functionName, { docsPath: docsPath5 });
  let values = Array.isArray(result) ? result : [result];
  if (description.outputs.length === 0 && !values[0])
    values = [];
  return encodeAbiParameters(description.outputs, values);
}

// src/utils/regex.ts
var arrayRegex = /^(.*)\[([0-9]*)\]$/;
var bytesRegex = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
var integerRegex = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

// src/utils/abi/encodePacked.ts
function encodePacked(types, values) {
  if (types.length !== values.length)
    throw new AbiEncodingLengthMismatchError({
      expectedLength: types.length,
      givenLength: values.length
    });
  let data = [];
  for (let i = 0; i < types.length; i++) {
    const type = types[i];
    const value = values[i];
    data.push(encode(type, value));
  }
  return concat(data);
}
function encode(type, value, isArray = false) {
  if (type === "address") {
    let address = value;
    if (!isAddress(address))
      throw new InvalidAddressError({ address });
    return pad(address.toLowerCase(), {
      size: isArray ? 32 : null
    });
  }
  if (type === "string")
    return stringToHex(value);
  if (type === "bytes")
    return value;
  if (type === "bool")
    return pad(boolToHex(value), { size: isArray ? 32 : 1 });
  const intMatch = type.match(integerRegex);
  if (intMatch) {
    const [_type, baseType, bits = "256"] = intMatch;
    const size2 = parseInt(bits) / 8;
    return numberToHex(value, {
      size: isArray ? 32 : size2,
      signed: baseType === "int"
    });
  }
  const bytesMatch = type.match(bytesRegex);
  if (bytesMatch) {
    const [_type, size2] = bytesMatch;
    if (parseInt(size2) !== (value.length - 2) / 2)
      throw new BytesSizeMismatchError({
        expectedSize: parseInt(size2),
        givenSize: (value.length - 2) / 2
      });
    return pad(value, { dir: "right", size: isArray ? 32 : null });
  }
  const arrayMatch = type.match(arrayRegex);
  if (arrayMatch && Array.isArray(value)) {
    const [_type, childType] = arrayMatch;
    let data = [];
    for (let i = 0; i < value.length; i++) {
      data.push(encode(childType, value[i], true));
    }
    return concat(data);
  }
  throw new UnsupportedPackedAbiType(type);
}

// src/utils/abi/formatAbiItemWithArgs.ts
function formatAbiItemWithArgs({
  abiItem,
  args,
  includeFunctionName = true,
  includeName = false
}) {
  if (!("name" in abiItem))
    return;
  if (!("inputs" in abiItem))
    return;
  if (!abiItem.inputs)
    return;
  return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map(
    (input, i) => `${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? stringify(args[i]) : args[i]}`
  ).join(", ")})`;
}

// src/utils/account.ts
function getAccount(account) {
  if (typeof account === "string") {
    if (!isAddress(account))
      throw new InvalidAddressError({ address: account });
    return { address: account, type: "json-rpc" };
  }
  if (!isAddress(account.address))
    throw new InvalidAddressError({ address: account.address });
  return {
    ...account,
    type: "local"
  };
}

// src/utils/promise/withCache.ts
var promiseCache = /* @__PURE__ */ new Map();
var responseCache = /* @__PURE__ */ new Map();
function getCache(cacheKey2) {
  const buildCache = (cacheKey3, cache) => ({
    clear: () => cache.delete(cacheKey3),
    get: () => cache.get(cacheKey3),
    set: (data) => cache.set(cacheKey3, data)
  });
  const promise = buildCache(cacheKey2, promiseCache);
  const response = buildCache(
    cacheKey2,
    responseCache
  );
  return {
    clear: () => {
      promise.clear();
      response.clear();
    },
    promise,
    response
  };
}
async function withCache(fn, { cacheKey: cacheKey2, maxAge = Infinity }) {
  const cache = getCache(cacheKey2);
  const response = cache.response.get();
  if (response && maxAge > 0) {
    const age = (/* @__PURE__ */ new Date()).getTime() - response.created.getTime();
    if (age < maxAge)
      return response.data;
  }
  let promise = cache.promise.get();
  if (!promise) {
    promise = fn();
    cache.promise.set(promise);
  }
  const data = await promise;
  cache.promise.clear();
  cache.response.set({ created: /* @__PURE__ */ new Date(), data });
  return data;
}

// src/utils/wait.ts
async function wait(time) {
  return new Promise((res) => setTimeout(res, time));
}

// src/utils/promise/withRetry.ts
function withRetry(fn, {
  delay: delay_ = 100,
  retryCount = 2,
  shouldRetry = () => true
} = {}) {
  return new Promise((resolve, reject) => {
    const attemptRetry = async ({ count = 0 } = {}) => {
      const retry = async ({ error }) => {
        const delay = typeof delay_ === "function" ? delay_({ count, error }) : delay_;
        if (delay)
          await wait(delay);
        attemptRetry({ count: count + 1 });
      };
      try {
        const data = await fn();
        resolve(data);
      } catch (err) {
        if (count < retryCount && await shouldRetry({ count, error: err }))
          return retry({ error: err });
        reject(err);
      }
    };
    attemptRetry();
  });
}

// src/utils/promise/withTimeout.ts
function withTimeout(fn, {
  errorInstance,
  timeout,
  signal
}) {
  return new Promise((resolve, reject) => {
    ;
    (async () => {
      let timeoutId;
      try {
        const controller = new AbortController();
        if (timeout > 0) {
          timeoutId = setTimeout(() => {
            if (signal) {
              controller.abort();
            } else {
              reject(errorInstance);
            }
          }, timeout);
        }
        resolve(await fn({ signal: controller?.signal }));
      } catch (err) {
        if (err.name === "AbortError")
          reject(errorInstance);
        reject(err);
      } finally {
        clearTimeout(timeoutId);
      }
    })();
  });
}

// src/utils/buildRequest.ts
var isDeterministicError = (error) => {
  if ("code" in error)
    return error.code !== -32603 && error.code !== -32005;
  if (error instanceof HttpRequestError && error.status)
    return error.status !== 408 && error.status !== 413 && error.status !== 429 && error.status !== 500 && error.status !== 502 && error.status !== 503 && error.status !== 504;
  return false;
};
function buildRequest(request, {
  retryDelay = 150,
  retryCount = 3
} = {}) {
  return async (args) => withRetry(
    async () => {
      try {
        return await request(args);
      } catch (err_) {
        const err = err_;
        if (err.code === -32700)
          throw new ParseRpcError(err);
        if (err.code === -32600)
          throw new InvalidRequestRpcError(err);
        if (err.code === -32601)
          throw new MethodNotFoundRpcError(err);
        if (err.code === -32602)
          throw new InvalidParamsRpcError(err);
        if (err.code === -32603)
          throw new InternalRpcError(err);
        if (err.code === -32e3)
          throw new InvalidInputRpcError(err);
        if (err.code === -32001)
          throw new ResourceNotFoundRpcError(err);
        if (err.code === -32002)
          throw new ResourceUnavailableRpcError(err);
        if (err.code === -32003)
          throw new TransactionRejectedRpcError(err);
        if (err.code === -32004)
          throw new MethodNotSupportedRpcError(err);
        if (err.code === -32005)
          throw new LimitExceededRpcError(err);
        if (err.code === -32006)
          throw new JsonRpcVersionUnsupportedError(err);
        if (err.code === 4001)
          throw new UserRejectedRequestError(err);
        if (err.code === 4902)
          throw new SwitchChainError(err);
        if (err_ instanceof BaseError)
          throw err_;
        throw new UnknownRpcError(err);
      }
    },
    {
      delay: ({ count, error }) => {
        if (error && error instanceof HttpRequestError) {
          const retryAfter = error?.headers?.get("Retry-After");
          if (retryAfter?.match(/\d/))
            return parseInt(retryAfter) * 1e3;
        }
        return ~~(1 << count) * retryDelay;
      },
      retryCount,
      shouldRetry: ({ error }) => !isDeterministicError(error)
    }
  );
}

// src/utils/chain.ts
function defineChain(chain) {
  return chain;
}
function getChainContractAddress({
  blockNumber,
  chain,
  contract: name
}) {
  const contract = chain?.contracts?.[name];
  if (!contract)
    throw new ChainDoesNotSupportContract({
      chain,
      contract: { name }
    });
  if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber)
    throw new ChainDoesNotSupportContract({
      blockNumber,
      chain,
      contract: {
        name,
        blockCreated: contract.blockCreated
      }
    });
  return contract.address;
}

// src/utils/formatters/format.ts
function format3(data, { formatter }) {
  return formatter(data);
}
function defineFormatter({
  format: format4
}) {
  return ({
    exclude,
    format: formatOverride
  }) => (data) => {
    const formatted = format4(data);
    if (exclude) {
      for (const key of exclude) {
        delete formatted[key];
      }
    }
    return {
      ...formatted,
      ...formatOverride?.(data)
    };
  };
}

// src/utils/formatters/transaction.ts
var transactionType = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559"
};
function formatTransaction(transaction) {
  const transaction_ = {
    ...transaction,
    blockHash: transaction.blockHash ? transaction.blockHash : null,
    blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
    chainId: transaction.chainId ? chunk_JG6MI5ZV_hexToNumber(transaction.chainId) : void 0,
    gas: transaction.gas ? BigInt(transaction.gas) : void 0,
    gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : void 0,
    maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : void 0,
    nonce: transaction.nonce ? chunk_JG6MI5ZV_hexToNumber(transaction.nonce) : void 0,
    to: transaction.to ? transaction.to : null,
    transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
    type: transaction.type ? transactionType[transaction.type] : void 0,
    value: transaction.value ? BigInt(transaction.value) : void 0,
    v: transaction.v ? BigInt(transaction.v) : void 0
  };
  if (transaction_.type === "legacy") {
    delete transaction_["accessList"];
    delete transaction_["maxFeePerGas"];
    delete transaction_["maxPriorityFeePerGas"];
  }
  if (transaction_.type === "eip2930") {
    delete transaction_["maxFeePerGas"];
    delete transaction_["maxPriorityFeePerGas"];
  }
  return transaction_;
}
var defineTransaction = defineFormatter({ format: formatTransaction });

// src/utils/formatters/block.ts
function formatBlock(block) {
  const transactions = block.transactions?.map((transaction) => {
    if (typeof transaction === "string")
      return transaction;
    return formatTransaction(transaction);
  });
  return {
    ...block,
    baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
    difficulty: block.difficulty ? BigInt(block.difficulty) : void 0,
    gasLimit: block.gasLimit ? BigInt(block.gasLimit) : void 0,
    gasUsed: block.gasUsed ? BigInt(block.gasUsed) : void 0,
    hash: block.hash ? block.hash : null,
    logsBloom: block.logsBloom ? block.logsBloom : null,
    nonce: block.nonce ? block.nonce : null,
    number: block.number ? BigInt(block.number) : null,
    size: block.size ? BigInt(block.size) : void 0,
    timestamp: block.timestamp ? BigInt(block.timestamp) : void 0,
    transactions,
    totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
  };
}
var defineBlock = defineFormatter({ format: formatBlock });

// src/utils/formatters/extract.ts
function extract(value, { formatter }) {
  if (!formatter)
    return {};
  const keys = Object.keys(formatter({}));
  return keys.reduce((data, key) => {
    if (value?.hasOwnProperty(key)) {
      ;
      data[key] = value[key];
    }
    return data;
  }, {});
}

// src/utils/formatters/feeHistory.ts
function formatFeeHistory(feeHistory) {
  return {
    baseFeePerGas: feeHistory.baseFeePerGas.map((value) => BigInt(value)),
    gasUsedRatio: feeHistory.gasUsedRatio,
    oldestBlock: BigInt(feeHistory.oldestBlock),
    reward: feeHistory.reward?.map(
      (reward) => reward.map((value) => BigInt(value))
    )
  };
}

// src/utils/formatters/log.ts
function formatLog(log, { args, eventName } = {}) {
  return {
    ...log,
    blockHash: log.blockHash ? log.blockHash : null,
    blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
    logIndex: log.logIndex ? BigInt(log.logIndex) : null,
    transactionHash: log.transactionHash ? log.transactionHash : null,
    transactionIndex: log.transactionIndex ? BigInt(log.transactionIndex) : null,
    ...eventName ? { args, eventName } : {}
  };
}

// src/utils/formatters/transactionReceipt.ts
var statuses = {
  "0x0": "reverted",
  "0x1": "success"
};
function formatTransactionReceipt(transactionReceipt) {
  return {
    ...transactionReceipt,
    blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
    contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
    cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
    effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
    gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
    logs: transactionReceipt.logs ? transactionReceipt.logs.map((log) => formatLog(log)) : null,
    to: transactionReceipt.to ? transactionReceipt.to : null,
    transactionIndex: transactionReceipt.transactionIndex ? chunk_JG6MI5ZV_hexToNumber(transactionReceipt.transactionIndex) : null,
    status: transactionReceipt.status ? statuses[transactionReceipt.status] : null,
    type: transactionReceipt.type ? transactionType[transactionReceipt.type] : null
  };
}
var defineTransactionReceipt = defineFormatter({
  format: formatTransactionReceipt
});

// src/utils/formatters/transactionRequest.ts
function formatTransactionRequest(transactionRequest) {
  return {
    ...transactionRequest,
    gas: typeof transactionRequest.gas !== "undefined" ? numberToHex(transactionRequest.gas) : void 0,
    gasPrice: typeof transactionRequest.gasPrice !== "undefined" ? numberToHex(transactionRequest.gasPrice) : void 0,
    maxFeePerGas: typeof transactionRequest.maxFeePerGas !== "undefined" ? numberToHex(transactionRequest.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: typeof transactionRequest.maxPriorityFeePerGas !== "undefined" ? numberToHex(transactionRequest.maxPriorityFeePerGas) : void 0,
    nonce: typeof transactionRequest.nonce !== "undefined" ? numberToHex(transactionRequest.nonce) : void 0,
    value: typeof transactionRequest.value !== "undefined" ? numberToHex(transactionRequest.value) : void 0
  };
}
var defineTransactionRequest = defineFormatter({
  format: formatTransactionRequest
});

// src/utils/errors/getNodeError.ts
function containsNodeError(err) {
  return err instanceof TransactionRejectedRpcError || err instanceof InvalidInputRpcError || err instanceof RpcError && err.code === ExecutionRevertedError.code;
}
function getNodeError(err, args) {
  const message = err.details.toLowerCase();
  if (FeeCapTooHighError.nodeMessage.test(message))
    return new FeeCapTooHighError({
      cause: err,
      maxFeePerGas: args?.maxFeePerGas
    });
  else if (FeeCapTooLowError.nodeMessage.test(message))
    return new FeeCapTooLowError({
      cause: err,
      maxFeePerGas: args?.maxFeePerGas
    });
  else if (NonceTooHighError.nodeMessage.test(message))
    return new NonceTooHighError({ cause: err, nonce: args?.nonce });
  else if (NonceTooLowError.nodeMessage.test(message))
    return new NonceTooLowError({ cause: err, nonce: args?.nonce });
  else if (NonceMaxValueError.nodeMessage.test(message))
    return new NonceMaxValueError({ cause: err, nonce: args?.nonce });
  else if (InsufficientFundsError.nodeMessage.test(message))
    return new InsufficientFundsError({ cause: err });
  else if (IntrinsicGasTooHighError.nodeMessage.test(message))
    return new IntrinsicGasTooHighError({ cause: err, gas: args?.gas });
  else if (IntrinsicGasTooLowError.nodeMessage.test(message))
    return new IntrinsicGasTooLowError({ cause: err, gas: args?.gas });
  else if (TransactionTypeNotSupportedError.nodeMessage.test(message))
    return new TransactionTypeNotSupportedError({ cause: err });
  else if (TipAboveFeeCapError.nodeMessage.test(message))
    return new TipAboveFeeCapError({
      cause: err,
      maxFeePerGas: args?.maxFeePerGas,
      maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
  else if (message.match(ExecutionRevertedError.nodeMessage) || "code" in err.cause && err.cause?.code === ExecutionRevertedError.code)
    return new ExecutionRevertedError({
      cause: err,
      message: err.cause.details
    });
  return new UnknownNodeError({
    cause: err.cause.cause
  });
}

// src/utils/errors/getCallError.ts
function getCallError(err, {
  docsPath: docsPath6,
  ...args
}) {
  let cause = err;
  if (containsNodeError(err))
    cause = getNodeError(err, args);
  return new CallExecutionError(cause, {
    docsPath: docsPath6,
    ...args
  });
}

// src/utils/errors/getContractError.ts
var EXECUTION_REVERTED_ERROR_CODE = 3;
function getContractError(err, {
  abi,
  address,
  args,
  docsPath: docsPath6,
  functionName,
  sender
}) {
  const { code, data, message } = err instanceof RawContractError ? err : err instanceof CallExecutionError || err instanceof EstimateGasExecutionError ? err.cause?.cause?.cause || {} : err.cause || {};
  let cause = err;
  if (err instanceof AbiDecodingZeroDataError) {
    cause = new ContractFunctionZeroDataError({ functionName });
  } else if (code === EXECUTION_REVERTED_ERROR_CODE && (data || message)) {
    cause = new ContractFunctionRevertedError({
      abi,
      data,
      functionName,
      message
    });
  }
  return new ContractFunctionExecutionError(cause, {
    abi,
    args,
    contractAddress: address,
    docsPath: docsPath6,
    functionName,
    sender
  });
}

// src/utils/errors/getEstimateGasError.ts
function getEstimateGasError(err, {
  docsPath: docsPath6,
  ...args
}) {
  let cause = err;
  if (containsNodeError(err))
    cause = getNodeError(err, args);
  return new EstimateGasExecutionError(cause, {
    docsPath: docsPath6,
    ...args
  });
}

// src/utils/errors/getTransactionError.ts
function getTransactionError(err, {
  docsPath: docsPath6,
  ...args
}) {
  let cause = err;
  if (containsNodeError(err))
    cause = getNodeError(err, args);
  return new TransactionExecutionError(cause, {
    docsPath: docsPath6,
    ...args
  });
}

// src/utils/rpc.ts


// src/utils/stringify.ts
var stringify = (value, replacer, space) => JSON.stringify(
  value,
  (key, value_) => {
    const value2 = typeof value_ === "bigint" ? value_.toString() : value_;
    return typeof replacer === "function" ? replacer(key, value2) : value2;
  },
  space
);

// src/utils/rpc.ts
var id = 0;
async function http(url, { body, fetchOptions = {}, timeout = 1e4 }) {
  const { headers, method, signal: signal_ } = fetchOptions;
  try {
    const response = await withTimeout(
      async ({ signal }) => {
        const response2 = await fetch(url, {
          ...fetchOptions,
          body: stringify({ jsonrpc: "2.0", id: id++, ...body }),
          headers: {
            ...headers,
            "Content-Type": "application/json"
          },
          method: method || "POST",
          signal: signal_ || (timeout > 0 ? signal : void 0)
        });
        return response2;
      },
      {
        errorInstance: new TimeoutError({ body, url }),
        timeout,
        signal: true
      }
    );
    let data;
    if (response.headers.get("Content-Type")?.startsWith("application/json")) {
      data = await response.json();
    } else {
      data = await response.text();
    }
    if (!response.ok) {
      throw new HttpRequestError({
        body,
        details: stringify(data.error) || response.statusText,
        headers: response.headers,
        status: response.status,
        url
      });
    }
    if (data.error) {
      throw new RpcError({ body, error: data.error, url });
    }
    return data;
  } catch (err) {
    if (err instanceof HttpRequestError)
      throw err;
    if (err instanceof RpcError)
      throw err;
    if (err instanceof TimeoutError)
      throw err;
    throw new HttpRequestError({
      body,
      details: err.message,
      url
    });
  }
}
var sockets = /* @__PURE__ */ new Map();
async function getSocket(url_) {
  const url = new URL(url_);
  const urlKey = url.toString();
  let socket = sockets.get(urlKey);
  if (socket)
    return socket;
  const webSocket2 = new browser["default"](url);
  const requests = /* @__PURE__ */ new Map();
  const subscriptions = /* @__PURE__ */ new Map();
  const onMessage = ({ data }) => {
    const message = JSON.parse(data);
    const isSubscription = message.method === "eth_subscription";
    const id2 = isSubscription ? message.params.subscription : message.id;
    const cache = isSubscription ? subscriptions : requests;
    const callback = cache.get(id2);
    if (callback)
      callback({ data });
    if (!isSubscription)
      cache.delete(id2);
  };
  const onClose = () => {
    sockets.delete(urlKey);
    webSocket2.removeEventListener("close", onClose);
    webSocket2.removeEventListener("message", onMessage);
  };
  webSocket2.addEventListener("close", onClose);
  webSocket2.addEventListener("message", onMessage);
  if (webSocket2.readyState === browser["default"].CONNECTING) {
    await new Promise((resolve, reject) => {
      if (!webSocket2)
        return;
      webSocket2.onopen = resolve;
      webSocket2.onerror = reject;
    });
  }
  socket = Object.assign(webSocket2, {
    requests,
    subscriptions
  });
  sockets.set(urlKey, socket);
  return socket;
}
function webSocket(socket, {
  body,
  onData,
  onError
}) {
  if (socket.readyState === socket.CLOSED || socket.readyState === socket.CLOSING)
    throw new WebSocketRequestError({
      body,
      url: socket.url,
      details: "Socket is closed."
    });
  const id_ = id++;
  const callback = ({ data }) => {
    const message = JSON.parse(data);
    if (typeof message.id === "number" && id_ !== message.id)
      return;
    if (message.error) {
      onError?.(new RpcError({ body, error: message.error, url: socket.url }));
    } else {
      onData?.(message);
    }
    if (body.method === "eth_subscribe" && typeof message.result === "string") {
      socket.subscriptions.set(message.result, callback);
    }
    if (body.method === "eth_unsubscribe") {
      socket.subscriptions.delete(body.params?.[0]);
    }
  };
  socket.requests.set(id_, callback);
  socket.send(JSON.stringify({ jsonrpc: "2.0", ...body, id: id_ }));
  return socket;
}
async function webSocketAsync(socket, {
  body,
  timeout = 1e4
}) {
  return withTimeout(
    () => new Promise(
      (onData, onError) => rpc.webSocket(socket, {
        body,
        onData,
        onError
      })
    ),
    {
      errorInstance: new TimeoutError({ body, url: socket.url }),
      timeout
    }
  );
}
var rpc = {
  http,
  webSocket,
  webSocketAsync
};

// src/utils/signature/hashMessage.ts
function hashMessage(message, to_) {
  const messageBytes = toBytes(message);
  const prefixBytes = toBytes(
    `Ethereum Signed Message:
${messageBytes.length}`
  );
  return keccak256(concat([prefixBytes, messageBytes]), to_);
}

// src/utils/signature/recoverAddress.ts

function recoverAddress({
  hash: hash2,
  signature
}) {
  const signatureHex = isHex(signature) ? signature : toHex(signature);
  const hashHex = isHex(hash2) ? hash2 : toHex(hash2);
  const v = chunk_JG6MI5ZV_hexToNumber(`0x${signatureHex.slice(130)}`);
  const publicKey = toHex(
    recoverPublicKey(
      hashHex.substring(2),
      signatureHex.substring(2, 130),
      v - 27
    )
  );
  const address = keccak256(`0x${publicKey.substring(4)}`).substring(26);
  return checksumAddress(`0x${address}`);
}

// src/utils/signature/recoverMessageAddress.ts
function recoverMessageAddress({
  message,
  signature
}) {
  return recoverAddress({ hash: hashMessage(message), signature });
}

// src/utils/signature/verifyMessage.ts
function verifyMessage({
  address,
  message,
  signature
}) {
  return isAddressEqual(
    getAddress(address),
    recoverMessageAddress({ message, signature })
  );
}

// src/utils/transaction/assertRequest.ts
function assertRequest(args) {
  const { account, gasPrice, maxFeePerGas, maxPriorityFeePerGas, to } = args;
  if (account && !isAddress(account.address))
    throw new InvalidAddressError({ address: account.address });
  if (to && !isAddress(to))
    throw new InvalidAddressError({ address: to });
  if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined"))
    throw new FeeConflictError();
  if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n)
    throw new FeeCapTooHighError({ maxFeePerGas });
  if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas)
    throw new TipAboveFeeCapError({ maxFeePerGas, maxPriorityFeePerGas });
}

// src/actions/public/call.ts
async function call(client, args) {
  const {
    account,
    blockNumber,
    blockTag = "latest",
    accessList,
    data,
    gas,
    gasPrice,
    maxFeePerGas,
    maxPriorityFeePerGas,
    nonce,
    to,
    value,
    ...rest
  } = args;
  try {
    assertRequest(args);
    const blockNumberHex = blockNumber ? numberToHex(blockNumber) : void 0;
    const formatter = client.chain?.formatters?.transactionRequest;
    const request_ = format3(
      {
        from: account?.address,
        accessList,
        data,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        nonce,
        to,
        value,
        // Pick out extra data that might exist on the chain's transaction request type.
        ...extract(rest, { formatter })
      },
      {
        formatter: formatter || formatTransactionRequest
      }
    );
    const response = await client.request({
      method: "eth_call",
      params: [request_, blockNumberHex || blockTag]
    });
    if (response === "0x")
      return { data: void 0 };
    return { data: response };
  } catch (err) {
    throw getCallError(err, {
      ...args,
      chain: client.chain
    });
  }
}

// src/actions/public/simulateContract.ts
async function simulateContract(client, {
  abi,
  address,
  args,
  functionName,
  ...callRequest
}) {
  const calldata = encodeFunctionData({
    abi,
    args,
    functionName
  });
  try {
    const { data } = await call(client, {
      data: calldata,
      to: address,
      ...callRequest
    });
    const result = decodeFunctionResult({
      abi,
      args,
      functionName,
      data: data || "0x"
    });
    return {
      result,
      request: {
        abi,
        address,
        args,
        functionName,
        ...callRequest
      }
    };
  } catch (err) {
    throw getContractError(err, {
      abi,
      address,
      args,
      docsPath: "/docs/contract/simulateContract",
      functionName,
      sender: callRequest.account?.address
    });
  }
}

// src/actions/public/createPendingTransactionFilter.ts
async function createPendingTransactionFilter(client) {
  const id2 = await client.request({
    method: "eth_newPendingTransactionFilter"
  });
  return { id: id2, type: "transaction" };
}

// src/actions/public/createBlockFilter.ts
async function createBlockFilter(client) {
  const id2 = await client.request({
    method: "eth_newBlockFilter"
  });
  return { id: id2, type: "block" };
}

// src/actions/public/createEventFilter.ts
async function createEventFilter(client, {
  address,
  args,
  event,
  fromBlock,
  toBlock
} = {}) {
  let topics = [];
  if (event)
    topics = encodeEventTopics({
      abi: [event],
      eventName: event.name,
      args
    });
  const id2 = await client.request({
    method: "eth_newFilter",
    params: [
      {
        address,
        fromBlock: typeof fromBlock === "bigint" ? numberToHex(fromBlock) : fromBlock,
        toBlock: typeof toBlock === "bigint" ? numberToHex(toBlock) : toBlock,
        ...topics.length ? { topics } : {}
      }
    ]
  });
  return {
    abi: event ? [event] : void 0,
    args,
    eventName: event ? event.name : void 0,
    id: id2,
    type: "event"
  };
}

// src/actions/public/createContractEventFilter.ts
async function createContractEventFilter(client, {
  address,
  abi,
  args,
  eventName,
  fromBlock,
  toBlock
}) {
  const topics = eventName ? encodeEventTopics({
    abi,
    args,
    eventName
  }) : void 0;
  const id2 = await client.request({
    method: "eth_newFilter",
    params: [
      {
        address,
        fromBlock: typeof fromBlock === "bigint" ? numberToHex(fromBlock) : fromBlock,
        toBlock: typeof toBlock === "bigint" ? numberToHex(toBlock) : toBlock,
        topics
      }
    ]
  });
  return {
    abi,
    args,
    eventName,
    id: id2,
    type: "event"
  };
}

// src/actions/public/estimateGas.ts
async function estimateGas(client, args) {
  try {
    const {
      account,
      accessList,
      blockNumber,
      blockTag = "latest",
      data,
      gas,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      nonce,
      to,
      value,
      ...rest
    } = args.account.type === "local" ? await prepareRequest(client, args) : args;
    const blockNumberHex = blockNumber ? numberToHex(blockNumber) : void 0;
    assertRequest(args);
    const formatter = client.chain?.formatters?.transactionRequest;
    const request = format3(
      {
        from: account.address,
        accessList,
        data,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        nonce,
        to,
        value,
        // Pick out extra data that might exist on the chain's transaction request type.
        ...extract(rest, { formatter })
      },
      {
        formatter: formatter || formatTransactionRequest
      }
    );
    const balance = await client.request({
      method: "eth_estimateGas",
      params: [request, blockNumberHex || blockTag]
    });
    return BigInt(balance);
  } catch (err) {
    throw getEstimateGasError(err, {
      ...args,
      chain: client.chain
    });
  }
}

// src/actions/public/estimateContractGas.ts
async function estimateContractGas(client, {
  abi,
  address,
  args,
  functionName,
  ...request
}) {
  const data = encodeFunctionData({
    abi,
    args,
    functionName
  });
  try {
    const gas = await estimateGas(client, {
      data,
      to: address,
      ...request
    });
    return gas;
  } catch (err) {
    throw getContractError(err, {
      abi,
      address,
      args,
      docsPath: "/docs/contract/simulateContract",
      functionName,
      sender: request.account?.address
    });
  }
}

// src/actions/public/getBalance.ts
async function getBalance(client, { address, blockNumber, blockTag = "latest" }) {
  const blockNumberHex = blockNumber ? numberToHex(blockNumber) : void 0;
  const balance = await client.request({
    method: "eth_getBalance",
    params: [address, blockNumberHex || blockTag]
  });
  return BigInt(balance);
}

// src/actions/public/getBlock.ts
async function getBlock(client, {
  blockHash,
  blockNumber,
  blockTag = "latest",
  includeTransactions = false
} = {}) {
  const blockNumberHex = blockNumber !== void 0 ? numberToHex(blockNumber) : void 0;
  let block = null;
  if (blockHash) {
    block = await client.request({
      method: "eth_getBlockByHash",
      params: [blockHash, includeTransactions]
    });
  } else {
    block = await client.request({
      method: "eth_getBlockByNumber",
      params: [blockNumberHex || blockTag, includeTransactions]
    });
  }
  if (!block)
    throw new BlockNotFoundError({ blockHash, blockNumber });
  return format3(block, {
    formatter: client.chain?.formatters?.block || formatBlock
  });
}

// src/actions/public/getBlockNumber.ts
var cacheKey = (id2) => `blockNumber.${id2}`;
function getBlockNumberCache(id2) {
  return getCache(cacheKey(id2));
}
async function getBlockNumber(client, { maxAge = client.pollingInterval } = {}) {
  const blockNumberHex = await withCache(
    () => client.request({
      method: "eth_blockNumber"
    }),
    { cacheKey: cacheKey(client.uid), maxAge }
  );
  return BigInt(blockNumberHex);
}

// src/actions/public/getBlockTransactionCount.ts
async function getBlockTransactionCount(client, {
  blockHash,
  blockNumber,
  blockTag = "latest"
} = {}) {
  const blockNumberHex = blockNumber !== void 0 ? numberToHex(blockNumber) : void 0;
  let count = null;
  if (blockHash) {
    count = await client.request({
      method: "eth_getBlockTransactionCountByHash",
      params: [blockHash]
    });
  } else {
    count = await client.request({
      method: "eth_getBlockTransactionCountByNumber",
      params: [blockNumberHex || blockTag]
    });
  }
  return chunk_JG6MI5ZV_hexToNumber(count);
}

// src/actions/public/getBytecode.ts
async function getBytecode(client, { address, blockNumber, blockTag = "latest" }) {
  const blockNumberHex = blockNumber !== void 0 ? numberToHex(blockNumber) : void 0;
  const hex = await client.request({
    method: "eth_getCode",
    params: [address, blockNumberHex || blockTag]
  });
  if (hex === "0x")
    return void 0;
  return hex;
}

// src/actions/public/getChainId.ts
async function getChainId(client) {
  const chainIdHex = await client.request({ method: "eth_chainId" });
  return chunk_JG6MI5ZV_hexToNumber(chainIdHex);
}

// src/actions/public/getFeeHistory.ts
async function getFeeHistory(client, {
  blockCount,
  blockNumber,
  blockTag = "latest",
  rewardPercentiles
}) {
  const blockNumberHex = blockNumber ? numberToHex(blockNumber) : void 0;
  const feeHistory = await client.request({
    method: "eth_feeHistory",
    params: [
      numberToHex(blockCount),
      blockNumberHex || blockTag,
      rewardPercentiles
    ]
  });
  return formatFeeHistory(feeHistory);
}

// src/actions/public/getFilterChanges.ts
async function getFilterChanges(client, {
  filter
}) {
  const logs = await client.request({
    method: "eth_getFilterChanges",
    params: [filter.id]
  });
  return logs.map((log) => {
    if (typeof log === "string")
      return log;
    const { eventName, args } = "abi" in filter && filter.abi ? decodeEventLog({
      abi: filter.abi,
      data: log.data,
      topics: log.topics
    }) : { eventName: void 0, args: void 0 };
    return formatLog(log, { args, eventName });
  });
}

// src/actions/public/getFilterLogs.ts
async function getFilterLogs(client, { filter }) {
  const logs = await client.request({
    method: "eth_getFilterLogs",
    params: [filter.id]
  });
  return logs.map((log) => {
    const { eventName, args } = "abi" in filter && filter.abi ? decodeEventLog({
      abi: filter.abi,
      data: log.data,
      topics: log.topics
    }) : { eventName: void 0, args: void 0 };
    return formatLog(log, { args, eventName });
  });
}

// src/actions/public/getGasPrice.ts
async function getGasPrice(client) {
  const gasPrice = await client.request({
    method: "eth_gasPrice"
  });
  return BigInt(gasPrice);
}

// src/actions/public/getLogs.ts
async function getLogs(client, {
  address,
  blockHash,
  fromBlock,
  toBlock,
  event,
  args
} = {}) {
  let topics = [];
  if (event)
    topics = encodeEventTopics({
      abi: [event],
      eventName: event.name,
      args
    });
  let logs;
  if (blockHash) {
    logs = await client.request({
      method: "eth_getLogs",
      params: [{ address, topics, blockHash }]
    });
  } else {
    logs = await client.request({
      method: "eth_getLogs",
      params: [
        {
          address,
          topics,
          fromBlock: typeof fromBlock === "bigint" ? numberToHex(fromBlock) : fromBlock,
          toBlock: typeof toBlock === "bigint" ? numberToHex(toBlock) : toBlock
        }
      ]
    });
  }
  return logs.map((log) => {
    const { eventName, args: args2 } = event ? decodeEventLog({
      abi: [event],
      data: log.data,
      topics: log.topics
    }) : { eventName: void 0, args: void 0 };
    return formatLog(log, { args: args2, eventName });
  });
}

// src/actions/public/getStorageAt.ts
async function getStorageAt(client, { address, blockNumber, blockTag = "latest", slot }) {
  const blockNumberHex = blockNumber !== void 0 ? numberToHex(blockNumber) : void 0;
  const data = await client.request({
    method: "eth_getStorageAt",
    params: [address, slot, blockNumberHex || blockTag]
  });
  return data;
}

// src/actions/public/getTransaction.ts
async function getTransaction(client, {
  blockHash,
  blockNumber,
  blockTag = "latest",
  hash: hash2,
  index
}) {
  const blockNumberHex = blockNumber !== void 0 ? numberToHex(blockNumber) : void 0;
  let transaction = null;
  if (hash2) {
    transaction = await client.request({
      method: "eth_getTransactionByHash",
      params: [hash2]
    });
  } else if (blockHash) {
    transaction = await client.request({
      method: "eth_getTransactionByBlockHashAndIndex",
      params: [blockHash, numberToHex(index)]
    });
  } else if (blockNumberHex || blockTag) {
    transaction = await client.request({
      method: "eth_getTransactionByBlockNumberAndIndex",
      params: [blockNumberHex || blockTag, numberToHex(index)]
    });
  }
  if (!transaction)
    throw new TransactionNotFoundError({
      blockHash,
      blockNumber,
      blockTag,
      hash: hash2,
      index
    });
  return format3(transaction, {
    formatter: client.chain?.formatters?.transaction || formatTransaction
  });
}

// src/actions/public/getTransactionConfirmations.ts
async function getTransactionConfirmations(client, { hash: hash2, transactionReceipt }) {
  const [blockNumber, transaction] = await Promise.all([
    getBlockNumber(client),
    hash2 ? getTransaction(client, { hash: hash2 }) : void 0
  ]);
  const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
  if (!transactionBlockNumber)
    return 0n;
  return blockNumber - transactionBlockNumber + 1n;
}

// src/actions/public/getTransactionCount.ts
async function getTransactionCount(client, { address, blockTag = "latest", blockNumber }) {
  const count = await client.request({
    method: "eth_getTransactionCount",
    params: [address, blockNumber ? numberToHex(blockNumber) : blockTag]
  });
  return chunk_JG6MI5ZV_hexToNumber(count);
}

// src/actions/public/getTransactionReceipt.ts
async function getTransactionReceipt(client, { hash: hash2 }) {
  const receipt = await client.request({
    method: "eth_getTransactionReceipt",
    params: [hash2]
  });
  if (!receipt)
    throw new TransactionReceiptNotFoundError({ hash: hash2 });
  return format3(receipt, {
    formatter: client.chain?.formatters?.transactionReceipt || formatTransactionReceipt
  });
}

// src/actions/public/readContract.ts
async function readContract(client, {
  abi,
  address,
  args,
  functionName,
  ...callRequest
}) {
  const calldata = encodeFunctionData({
    abi,
    args,
    functionName
  });
  try {
    const { data } = await call(client, {
      data: calldata,
      to: address,
      ...callRequest
    });
    return decodeFunctionResult({
      abi,
      args,
      functionName,
      data: data || "0x"
    });
  } catch (err) {
    throw getContractError(err, {
      abi,
      address,
      args,
      docsPath: "/docs/contract/readContract",
      functionName
    });
  }
}

// src/actions/public/multicall.ts
async function multicall(client, args) {
  const {
    allowFailure = true,
    blockNumber,
    blockTag,
    contracts: contracts_,
    multicallAddress: multicallAddress_
  } = args;
  const contracts = contracts_;
  let multicallAddress = multicallAddress_;
  if (!multicallAddress) {
    if (!client.chain)
      throw new Error(
        "client chain not configured. multicallAddress is required."
      );
    multicallAddress = getChainContractAddress({
      blockNumber,
      chain: client.chain,
      contract: "multicall3"
    });
  }
  const calls = contracts.map(({ abi, address, args: args2, functionName }) => {
    try {
      const callData = encodeFunctionData({
        abi,
        args: args2,
        functionName
      });
      return {
        allowFailure: true,
        callData,
        target: address
      };
    } catch (err) {
      const error = getContractError(err, {
        abi,
        address,
        args: args2,
        docsPath: "/docs/contract/multicall",
        functionName
      });
      if (!allowFailure)
        throw error;
      return {
        allowFailure: true,
        callData: "0x",
        target: address
      };
    }
  });
  const results = await readContract(client, {
    abi: multicall3Abi,
    address: multicallAddress,
    args: [calls],
    blockNumber,
    blockTag,
    functionName: "aggregate3"
  });
  return results.map(({ returnData, success }, i) => {
    const { callData } = calls[i];
    const { abi, address, functionName, args: args2 } = contracts[i];
    try {
      if (callData === "0x")
        throw new AbiDecodingZeroDataError();
      if (!success)
        throw new RawContractError({ data: returnData });
      const result = decodeFunctionResult({
        abi,
        data: returnData,
        functionName
      });
      return allowFailure ? { result, status: "success" } : result;
    } catch (err) {
      const error = getContractError(err, {
        abi,
        address,
        args: args2,
        docsPath: "/docs/contract/multicall",
        functionName
      });
      if (!allowFailure)
        throw error;
      return { error, result: void 0, status: "failure" };
    }
  });
}

// src/actions/public/uninstallFilter.ts
async function uninstallFilter(client, { filter }) {
  return client.request({
    method: "eth_uninstallFilter",
    params: [filter.id]
  });
}

// src/utils/observe.ts
var listenersCache = /* @__PURE__ */ new Map();
var cleanupCache = /* @__PURE__ */ new Map();
var callbackCount = 0;
function observe(observerId, callbacks, fn) {
  const callbackId = ++callbackCount;
  const getListeners = () => listenersCache.get(observerId) || [];
  const unsubscribe = () => {
    const listeners2 = getListeners();
    listenersCache.set(
      observerId,
      listeners2.filter((cb) => cb.id !== callbackId)
    );
  };
  const unwatch = () => {
    const cleanup2 = cleanupCache.get(observerId);
    if (getListeners().length === 1 && cleanup2)
      cleanup2();
    unsubscribe();
  };
  const listeners = getListeners();
  listenersCache.set(observerId, [
    ...listeners,
    { id: callbackId, fns: callbacks }
  ]);
  if (listeners && listeners.length > 0)
    return unwatch;
  let emit = {};
  for (const key in callbacks) {
    emit[key] = (...args) => {
      const listeners2 = getListeners();
      if (listeners2.length === 0)
        return;
      listeners2.forEach((listener) => listener.fns[key]?.(...args));
    };
  }
  const cleanup = fn(emit);
  if (typeof cleanup === "function")
    cleanupCache.set(observerId, cleanup);
  return unwatch;
}

// src/actions/public/waitForTransactionReceipt.ts
async function waitForTransactionReceipt(client, {
  confirmations = 1,
  hash: hash2,
  onReplaced,
  pollingInterval = client.pollingInterval,
  timeout
}) {
  const observerId = JSON.stringify([
    "waitForTransactionReceipt",
    client.uid,
    hash2
  ]);
  let transaction;
  let replacedTransaction;
  let receipt;
  return new Promise((resolve, reject) => {
    if (timeout)
      setTimeout(
        () => reject(new WaitForTransactionReceiptTimeoutError({ hash: hash2 })),
        timeout
      );
    const _unobserve = observe(
      observerId,
      { onReplaced, resolve, reject },
      (emit) => {
        const unwatch = watchBlockNumber(client, {
          emitMissed: true,
          emitOnBegin: true,
          pollingInterval,
          async onBlockNumber(blockNumber) {
            const done = async (fn) => {
              unwatch();
              fn();
              _unobserve();
            };
            try {
              if (receipt) {
                if (blockNumber - receipt.blockNumber + 1n < confirmations)
                  return;
                done(() => emit.resolve(receipt));
                return;
              }
              transaction = await getTransaction(client, { hash: hash2 });
              receipt = await getTransactionReceipt(client, { hash: hash2 });
              if (blockNumber - receipt.blockNumber + 1n < confirmations)
                return;
              done(() => emit.resolve(receipt));
            } catch (err) {
              if (transaction && (err instanceof TransactionNotFoundError || err instanceof TransactionReceiptNotFoundError)) {
                replacedTransaction = transaction;
                const block = await getBlock(client, {
                  blockNumber,
                  includeTransactions: true
                });
                const replacementTransaction = block.transactions.find(
                  ({ from, nonce }) => from === replacedTransaction.from && nonce === replacedTransaction.nonce
                );
                if (!replacementTransaction)
                  return;
                receipt = await getTransactionReceipt(client, {
                  hash: replacementTransaction.hash
                });
                if (blockNumber - receipt.blockNumber + 1n < confirmations)
                  return;
                let reason = "replaced";
                if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) {
                  reason = "repriced";
                } else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) {
                  reason = "cancelled";
                }
                done(() => {
                  emit.onReplaced?.({
                    reason,
                    replacedTransaction,
                    transaction: replacementTransaction,
                    transactionReceipt: receipt
                  });
                  emit.resolve(receipt);
                });
              } else {
                done(() => emit.reject(err));
              }
            }
          }
        });
        return unwatch;
      }
    );
  });
}

// src/utils/poll.ts
function poll(fn, { emitOnBegin, initialWaitTime, interval }) {
  let active = true;
  const unwatch = () => active = false;
  const watch = async () => {
    let data;
    if (emitOnBegin)
      data = await fn({ unpoll: unwatch });
    const initialWait = await initialWaitTime?.(data) ?? interval;
    await wait(initialWait);
    const poll2 = async () => {
      if (!active)
        return;
      await fn({ unpoll: unwatch });
      await wait(interval);
      poll2();
    };
    poll2();
  };
  watch();
  return unwatch;
}

// src/actions/public/watchBlockNumber.ts
function watchBlockNumber(client, {
  emitOnBegin = false,
  emitMissed = false,
  onBlockNumber,
  onError,
  pollingInterval = client.pollingInterval
}) {
  const observerId = JSON.stringify([
    "watchBlockNumber",
    client.uid,
    emitOnBegin,
    emitMissed,
    pollingInterval
  ]);
  let prevBlockNumber;
  return observe(
    observerId,
    { onBlockNumber, onError },
    (emit) => poll(
      async () => {
        try {
          const blockNumber = await getBlockNumber(client, { maxAge: 0 });
          if (prevBlockNumber) {
            if (blockNumber === prevBlockNumber)
              return;
            if (blockNumber - prevBlockNumber > 1 && emitMissed) {
              for (let i = prevBlockNumber + 1n; i < blockNumber; i++) {
                emit.onBlockNumber(i, prevBlockNumber);
                prevBlockNumber = i;
              }
            }
          }
          if (!prevBlockNumber || blockNumber > prevBlockNumber) {
            emit.onBlockNumber(blockNumber, prevBlockNumber);
            prevBlockNumber = blockNumber;
          }
        } catch (err) {
          emit.onError?.(err);
        }
      },
      {
        emitOnBegin,
        interval: pollingInterval
      }
    )
  );
}

// src/actions/public/watchBlocks.ts
function watchBlocks(client, {
  blockTag = "latest",
  emitMissed = false,
  emitOnBegin = false,
  onBlock,
  onError,
  includeTransactions = false,
  pollingInterval = client.pollingInterval
}) {
  const observerId = JSON.stringify([
    "watchBlocks",
    client.uid,
    emitMissed,
    emitOnBegin,
    includeTransactions,
    pollingInterval
  ]);
  let prevBlock;
  return observe(
    observerId,
    { onBlock, onError },
    (emit) => poll(
      async () => {
        try {
          const block = await getBlock(client, {
            blockTag,
            includeTransactions
          });
          if (block.number && prevBlock?.number) {
            if (block.number === prevBlock.number)
              return;
            if (block.number - prevBlock.number > 1 && emitMissed) {
              for (let i = prevBlock?.number + 1n; i < block.number; i++) {
                const block2 = await getBlock(client, {
                  blockNumber: i,
                  includeTransactions
                });
                emit.onBlock(block2, prevBlock);
                prevBlock = block2;
              }
            }
          }
          if (
            // If no previous block exists, emit.
            !prevBlock?.number || // If the block tag is "pending" with no block number, emit.
            blockTag === "pending" && !block?.number || // If the next block number is greater than the previous block number, emit.
            // We don't want to emit blocks in the past.
            block.number && block.number > prevBlock.number
          ) {
            emit.onBlock(block, prevBlock);
            prevBlock = block;
          }
        } catch (err) {
          emit.onError?.(err);
        }
      },
      {
        emitOnBegin,
        interval: pollingInterval
      }
    )
  );
}

// src/actions/public/watchContractEvent.ts
function watchContractEvent(client, {
  abi,
  address,
  args,
  batch = true,
  eventName,
  onError,
  onLogs,
  pollingInterval = client.pollingInterval
}) {
  const observerId = JSON.stringify([
    "watchContractEvent",
    address,
    args,
    batch,
    client.uid,
    eventName,
    pollingInterval
  ]);
  return observe(observerId, { onLogs, onError }, (emit) => {
    let previousBlockNumber;
    let filter;
    let initialized = false;
    const unwatch = poll(
      async () => {
        if (!initialized) {
          try {
            filter = await createContractEventFilter(client, {
              abi,
              address,
              args,
              eventName
            });
          } catch {
          }
          initialized = true;
          return;
        }
        try {
          let logs;
          if (filter) {
            logs = await getFilterChanges(client, { filter });
          } else {
            const blockNumber = await getBlockNumber(client);
            if (previousBlockNumber && previousBlockNumber !== blockNumber) {
              logs = await getLogs(client, {
                address,
                args,
                fromBlock: previousBlockNumber + 1n,
                toBlock: blockNumber,
                event: getAbiItem({
                  abi,
                  name: eventName
                })
              });
            } else {
              logs = [];
            }
            previousBlockNumber = blockNumber;
          }
          if (logs.length === 0)
            return;
          if (batch)
            emit.onLogs(logs);
          else
            logs.forEach((log) => emit.onLogs([log]));
        } catch (err) {
          emit.onError?.(err);
        }
      },
      {
        emitOnBegin: true,
        interval: pollingInterval
      }
    );
    return async () => {
      if (filter)
        await uninstallFilter(client, { filter });
      unwatch();
    };
  });
}

// src/actions/public/watchEvent.ts
function watchEvent(client, {
  address,
  args,
  batch = true,
  event,
  onError,
  onLogs,
  pollingInterval = client.pollingInterval
}) {
  const observerId = JSON.stringify([
    "watchEvent",
    address,
    args,
    batch,
    client.uid,
    event,
    pollingInterval
  ]);
  return observe(observerId, { onLogs, onError }, (emit) => {
    let previousBlockNumber;
    let filter;
    let initialized = false;
    const unwatch = poll(
      async () => {
        if (!initialized) {
          try {
            filter = await createEventFilter(client, {
              address,
              args,
              event
            });
          } catch {
          }
          initialized = true;
          return;
        }
        try {
          let logs;
          if (filter) {
            logs = await getFilterChanges(client, { filter });
          } else {
            const blockNumber = await getBlockNumber(client);
            if (previousBlockNumber && previousBlockNumber !== blockNumber) {
              logs = await getLogs(client, {
                address,
                args,
                fromBlock: previousBlockNumber + 1n,
                toBlock: blockNumber,
                event
              });
            } else {
              logs = [];
            }
            previousBlockNumber = blockNumber;
          }
          if (logs.length === 0)
            return;
          if (batch)
            emit.onLogs(logs);
          else
            logs.forEach((log) => emit.onLogs([log]));
        } catch (err) {
          emit.onError?.(err);
        }
      },
      {
        emitOnBegin: true,
        interval: pollingInterval
      }
    );
    return async () => {
      if (filter)
        await uninstallFilter(client, { filter });
      unwatch();
    };
  });
}

// src/actions/public/watchPendingTransactions.ts
function watchPendingTransactions(client, {
  batch = true,
  onError,
  onTransactions,
  pollingInterval = client.pollingInterval
}) {
  const observerId = JSON.stringify([
    "watchPendingTransactions",
    client.uid,
    batch,
    pollingInterval
  ]);
  return observe(observerId, { onTransactions, onError }, (emit) => {
    let filter;
    const unwatch = poll(
      async () => {
        try {
          if (!filter) {
            try {
              filter = await createPendingTransactionFilter(client);
              return;
            } catch (err) {
              unwatch();
              throw err;
            }
          }
          const hashes = await getFilterChanges(client, { filter });
          if (hashes.length === 0)
            return;
          if (batch)
            emit.onTransactions(hashes);
          else
            hashes.forEach((hash2) => emit.onTransactions([hash2]));
        } catch (err) {
          emit.onError?.(err);
        }
      },
      {
        emitOnBegin: true,
        interval: pollingInterval
      }
    );
    return async () => {
      if (filter)
        await uninstallFilter(client, { filter });
      unwatch();
    };
  });
}

// src/actions/test/dropTransaction.ts
async function dropTransaction(client, { hash: hash2 }) {
  return await client.request({
    method: `${client.mode}_dropTransaction`,
    params: [hash2]
  });
}

// src/actions/test/getAutomine.ts
async function getAutomine(client) {
  return await client.request({
    method: `${client.mode}_getAutomine`
  });
}

// src/actions/test/getTxpoolContent.ts
async function getTxpoolContent(client) {
  return await client.request({
    method: "txpool_content"
  });
}

// src/actions/test/getTxpoolStatus.ts
async function getTxpoolStatus(client) {
  const { pending, queued } = await client.request({
    method: "txpool_status"
  });
  return {
    pending: chunk_JG6MI5ZV_hexToNumber(pending),
    queued: chunk_JG6MI5ZV_hexToNumber(queued)
  };
}

// src/actions/test/impersonateAccount.ts
async function impersonateAccount(client, { address }) {
  return await client.request({
    method: `${client.mode}_impersonateAccount`,
    params: [address]
  });
}

// src/actions/test/increaseTime.ts
async function increaseTime(client, { seconds }) {
  return await client.request({
    method: "evm_increaseTime",
    params: [numberToHex(seconds)]
  });
}

// src/actions/test/inspectTxpool.ts
async function inspectTxpool(client) {
  return await client.request({
    method: "txpool_inspect"
  });
}

// src/actions/test/mine.ts
async function mine(client, { blocks, interval }) {
  return await client.request({
    method: `${client.mode}_mine`,
    params: [numberToHex(blocks), numberToHex(interval || 0)]
  });
}

// src/actions/test/removeBlockTimestampInterval.ts
async function removeBlockTimestampInterval(client) {
  return await client.request({
    method: `${client.mode}_removeBlockTimestampInterval`
  });
}

// src/actions/test/reset.ts
async function chunk_JG6MI5ZV_reset(client, { blockNumber, jsonRpcUrl } = {}) {
  return await client.request({
    method: `${client.mode}_reset`,
    params: [{ forking: { blockNumber: Number(blockNumber), jsonRpcUrl } }]
  });
}

// src/actions/test/revert.ts
async function revert(client, { id: id2 }) {
  return await client.request({
    method: "evm_revert",
    params: [id2]
  });
}

// src/actions/test/sendUnsignedTransaction.ts
async function sendUnsignedTransaction(client, request) {
  const request_ = formatTransactionRequest(request);
  const hash2 = await client.request({
    method: "eth_sendUnsignedTransaction",
    params: [request_]
  });
  return hash2;
}

// src/actions/test/setAutomine.ts
async function setAutomine(client, enabled) {
  return await client.request({
    method: "evm_setAutomine",
    params: [enabled]
  });
}

// src/actions/test/setBalance.ts
async function setBalance(client, { address, value }) {
  return await client.request({
    method: `${client.mode}_setBalance`,
    params: [address, numberToHex(value)]
  });
}

// src/actions/test/setBlockGasLimit.ts
async function setBlockGasLimit(client, { gasLimit }) {
  return await client.request({
    method: "evm_setBlockGasLimit",
    params: [numberToHex(gasLimit)]
  });
}

// src/actions/test/setBlockTimestampInterval.ts
async function setBlockTimestampInterval(client, { interval }) {
  return await client.request({
    method: `${client.mode}_setBlockTimestampInterval`,
    params: [interval]
  });
}

// src/actions/test/setCode.ts
async function setCode(client, { address, bytecode }) {
  return await client.request({
    method: `${client.mode}_setCode`,
    params: [address, bytecode]
  });
}

// src/actions/test/setCoinbase.ts
async function setCoinbase(client, { address }) {
  return await client.request({
    method: `${client.mode}_setCoinbase`,
    params: [address]
  });
}

// src/actions/test/setIntervalMining.ts
async function setIntervalMining(client, { interval }) {
  return await client.request({
    method: "evm_setIntervalMining",
    params: [interval]
  });
}

// src/actions/test/setLoggingEnabled.ts
async function setLoggingEnabled(client, enabled) {
  return await client.request({
    method: `${client.mode}_setLoggingEnabled`,
    params: [enabled]
  });
}

// src/actions/test/setMinGasPrice.ts
async function setMinGasPrice(client, { gasPrice }) {
  return await client.request({
    method: `${client.mode}_setMinGasPrice`,
    params: [numberToHex(gasPrice)]
  });
}

// src/actions/test/setNextBlockBaseFeePerGas.ts
async function setNextBlockBaseFeePerGas(client, { baseFeePerGas }) {
  return await client.request({
    method: `${client.mode}_setNextBlockBaseFeePerGas`,
    params: [numberToHex(baseFeePerGas)]
  });
}

// src/actions/test/setNextBlockTimestamp.ts
async function setNextBlockTimestamp(client, { timestamp }) {
  return await client.request({
    method: "evm_setNextBlockTimestamp",
    params: [numberToHex(timestamp)]
  });
}

// src/actions/test/setNonce.ts
async function setNonce(client, { address, nonce }) {
  return await client.request({
    method: `${client.mode}_setNonce`,
    params: [address, numberToHex(nonce)]
  });
}

// src/actions/test/setRpcUrl.ts
async function setRpcUrl(client, jsonRpcUrl) {
  return await client.request({
    method: `${client.mode}_setRpcUrl`,
    params: [jsonRpcUrl]
  });
}

// src/actions/test/setStorageAt.ts
async function setStorageAt(client, { address, index, value }) {
  return await client.request({
    method: `${client.mode}_setStorageAt`,
    params: [
      address,
      typeof index === "number" ? numberToHex(index) : index,
      value
    ]
  });
}

// src/actions/test/snapshot.ts
async function snapshot(client) {
  return await client.request({
    method: "evm_snapshot"
  });
}

// src/actions/test/stopImpersonatingAccount.ts
async function stopImpersonatingAccount(client, { address }) {
  return await client.request({
    method: `${client.mode}_stopImpersonatingAccount`,
    params: [address]
  });
}

// src/actions/wallet/addChain.ts
async function addChain(client, { chain }) {
  const { id: id2, name, nativeCurrency, rpcUrls, blockExplorers } = chain;
  await client.request({
    method: "wallet_addEthereumChain",
    params: [
      {
        chainId: numberToHex(id2),
        chainName: name,
        nativeCurrency,
        rpcUrls: rpcUrls.default.http,
        blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url }) => url) : void 0
      }
    ]
  });
}

// src/actions/wallet/deployContract.ts
function deployContract(walletClient, { abi, args, bytecode, ...request }) {
  const calldata = encodeDeployData({
    abi,
    args,
    bytecode
  });
  return sendTransaction(walletClient, {
    ...request,
    data: calldata
  });
}

// src/actions/wallet/getAddresses.ts
async function getAddresses(client) {
  const addresses = await client.request({ method: "eth_accounts" });
  return addresses.map((address) => checksumAddress(address));
}

// src/actions/wallet/getPermissions.ts
async function getPermissions(client) {
  const permissions = await client.request({ method: "wallet_getPermissions" });
  return permissions;
}

// src/actions/wallet/requestAddresses.ts
async function requestAddresses(client) {
  const addresses = await client.request({ method: "eth_requestAccounts" });
  return addresses.map((address) => getAddress(address));
}

// src/actions/wallet/requestPermissions.ts
async function requestPermissions(client, permissions) {
  return client.request({
    method: "wallet_requestPermissions",
    params: [permissions]
  });
}

// src/actions/wallet/sendTransaction.ts
async function sendTransaction(client, args) {
  const {
    account,
    chain = client.chain,
    accessList,
    assertChain = true,
    data,
    gas,
    gasPrice,
    maxFeePerGas,
    maxPriorityFeePerGas,
    nonce,
    to,
    value,
    ...rest
  } = args;
  try {
    assertRequest(args);
    const currentChainId = await getChainId(client);
    if (assertChain && chain && currentChainId !== chain?.id)
      throw new ChainMismatchError({ chain, currentChainId });
    if (account.type === "local") {
      const chainId = chain?.id ?? currentChainId;
      const request2 = await prepareRequest(client, {
        account,
        accessList,
        chain,
        data,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        nonce,
        to,
        value,
        ...rest
      });
      const signedRequest = await account.signTransaction({
        chainId,
        ...request2
      });
      return await client.request({
        method: "eth_sendRawTransaction",
        params: [signedRequest]
      });
    }
    const formatter = chain?.formatters?.transactionRequest;
    const request = format3(
      {
        accessList,
        data,
        from: account.address,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        nonce,
        to,
        value,
        // Pick out extra data that might exist on the chain's transaction request type.
        ...extract(rest, { formatter })
      },
      {
        formatter: formatter || formatTransactionRequest
      }
    );
    return await client.request({
      method: "eth_sendTransaction",
      params: [request]
    });
  } catch (err) {
    throw getTransactionError(err, args);
  }
}

// src/actions/wallet/signMessage.ts
async function signMessage(client, { account, data, message }) {
  const message_ = message || data;
  if (account.type === "local")
    return account.signMessage(message_);
  return client.request({
    method: "personal_sign",
    params: [toHex(message_), account.address]
  });
}

// src/actions/wallet/signTypedData.ts
async function signTypedData(client, {
  account,
  domain,
  message,
  primaryType,
  types: types_
}) {
  const types = {
    EIP712Domain: [
      domain?.name && { name: "name", type: "string" },
      domain?.version && { name: "version", type: "string" },
      domain?.chainId && { name: "chainId", type: "uint256" },
      domain?.verifyingContract && {
        name: "verifyingContract",
        type: "address"
      },
      domain?.salt && { name: "salt", type: "bytes32" }
    ].filter(Boolean),
    ...types_
  };
  validateTypedData({
    domain,
    message,
    primaryType,
    types
  });
  if (account.type === "local")
    return account.signTypedData({
      domain,
      primaryType,
      types,
      message
    });
  const typedData = stringify(
    { domain: domain ?? {}, primaryType, types, message },
    (_, value) => isHex(value) ? value.toLowerCase() : value
  );
  return client.request({
    method: "eth_signTypedData_v4",
    params: [account.address, typedData]
  });
}
function validateTypedData({
  domain,
  message,
  primaryType,
  types: types_
}) {
  const types = types_;
  const validateData = (struct, value_) => {
    for (const param of struct) {
      const { name, type: type_ } = param;
      const type2 = type_;
      const value = value_[name];
      const integerMatch = type2.match(integerRegex);
      if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
        const [_type, base, size_] = integerMatch;
        numberToHex(value, {
          signed: base === "int",
          size: parseInt(size_) / 8
        });
      }
      if (type2 === "address" && typeof value === "string" && !isAddress(value))
        throw new InvalidAddressError({ address: value });
      const bytesMatch = type2.match(bytesRegex);
      if (bytesMatch) {
        const [_type, size_] = bytesMatch;
        if (size_ && size(value) !== parseInt(size_))
          throw new BytesSizeMismatchError({
            expectedSize: parseInt(size_),
            givenSize: size(value)
          });
      }
      const struct2 = types[type2];
      if (struct2)
        validateData(struct2, value);
    }
  };
  if (types["EIP712Domain"] && domain)
    validateData(types["EIP712Domain"], domain);
  const type = types[primaryType];
  validateData(type, message);
}

// src/actions/wallet/switchChain.ts
async function switchChain(client, { id: id2 }) {
  await client.request({
    method: "wallet_switchEthereumChain",
    params: [
      {
        chainId: numberToHex(id2)
      }
    ]
  });
}

// src/actions/wallet/watchAsset.ts
async function watchAsset(client, params) {
  const added = await client.request({
    method: "wallet_watchAsset",
    params: [params]
  });
  return added;
}

// src/actions/wallet/writeContract.ts
async function writeContract(client, {
  abi,
  address,
  args,
  functionName,
  ...request
}) {
  const data = encodeFunctionData({
    abi,
    args,
    functionName
  });
  const hash2 = await sendTransaction(client, {
    data,
    to: address,
    ...request
  });
  return hash2;
}

// src/utils/unit/parseUnits.ts
function parseUnits(value, decimals) {
  let [integer, fraction = "0"] = value.split(".");
  const negative = integer.startsWith("-");
  if (negative)
    integer = integer.slice(1);
  fraction = fraction.replace(/(0+)$/, "");
  if (decimals === 0) {
    integer = `${Math.round(Number(`${integer}.${fraction}`))}`;
    fraction = "";
  } else if (fraction.length > decimals) {
    const [before, after] = [
      fraction.slice(0, decimals),
      fraction.slice(decimals)
    ];
    fraction = `${/^0+$/.test(before) ? before.slice(0, before.length - 1) : ""}${Math.round(Number(`${before}.${after}`))}`;
  } else {
    fraction = fraction.padEnd(decimals, "0");
  }
  return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}

// src/utils/unit/parseGwei.ts
function parseGwei(ether, unit = "wei") {
  return parseUnits(ether, gweiUnits[unit]);
}

// src/utils/transaction/prepareRequest.ts
var defaultTip = parseGwei("1.5");
async function prepareRequest(client, args) {
  const { account, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce } = args;
  const block = await getBlock(client, { blockTag: "latest" });
  const request = { ...args, from: account.address };
  if (typeof nonce === "undefined")
    request.nonce = await getTransactionCount(client, {
      address: account.address,
      blockTag: "pending"
    });
  if (block.baseFeePerGas) {
    if (typeof gasPrice !== "undefined")
      throw new BaseError("Chain does not support legacy `gasPrice`.");
    if (typeof maxFeePerGas === "undefined") {
      request.maxPriorityFeePerGas = maxPriorityFeePerGas ?? defaultTip;
      request.maxFeePerGas = block.baseFeePerGas * 120n / 100n + request.maxPriorityFeePerGas;
    } else {
      if (typeof maxPriorityFeePerGas === "undefined" && maxFeePerGas < defaultTip)
        throw new BaseError(
          "`maxFeePerGas` cannot be less than the default `maxPriorityFeePerGas` (1.5 gwei)."
        );
      request.maxFeePerGas = maxFeePerGas;
      request.maxPriorityFeePerGas = maxPriorityFeePerGas ?? defaultTip;
    }
  } else {
    if (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")
      throw new BaseError("Chain does not support EIP-1559 fees.");
    if (typeof gasPrice === "undefined")
      request.gasPrice = await getGasPrice(client) * 120n / 100n;
  }
  if (typeof gas === "undefined")
    request.gas = await estimateGas(client, {
      ...request,
      account: { address: account.address, type: "json-rpc" }
    });
  assertRequest(request);
  return request;
}

// src/utils/unit/formatUnits.ts
function formatUnits(value, decimals) {
  let display = value.toString();
  const negative = display.startsWith("-");
  if (negative)
    display = display.slice(1);
  display = display.padStart(decimals, "0");
  let [integer, fraction] = [
    display.slice(0, display.length - decimals),
    display.slice(display.length - decimals)
  ];
  fraction = fraction.replace(/(0+)$/, "");
  return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

// src/utils/unit/formatEther.ts
function formatEther(wei, unit = "wei") {
  return formatUnits(wei, etherUnits[unit]);
}

// src/utils/unit/formatGwei.ts
function formatGwei(wei, unit = "wei") {
  return formatUnits(wei, gweiUnits[unit]);
}

// src/utils/unit/parseEther.ts
function parseEther(ether, unit = "wei") {
  return parseUnits(ether, etherUnits[unit]);
}


//# sourceMappingURL=chunk-JG6MI5ZV.mjs.map
;// CONCATENATED MODULE: ./node_modules/@everipedia/web3-signer/node_modules/abitype/dist/chunk-WP7KDV47.mjs
// src/regex.ts
function execTyped(regex, string) {
  const match = regex.exec(string);
  return match?.groups;
}
var chunk_WP7KDV47_bytesRegex = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
var chunk_WP7KDV47_integerRegex = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
var isTupleRegex = /^\(.+?\).*?$/;



;// CONCATENATED MODULE: ./node_modules/@everipedia/web3-signer/node_modules/abitype/dist/chunk-NHABU752.mjs
var chunk_NHABU752_defProp = Object.defineProperty;
var chunk_NHABU752_defNormalProp = (obj, key, value) => key in obj ? chunk_NHABU752_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var chunk_NHABU752_publicField = (obj, key, value) => {
  chunk_NHABU752_defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};



;// CONCATENATED MODULE: ./node_modules/@everipedia/web3-signer/node_modules/abitype/dist/index.mjs



// package.json
var dist_name = "abitype";
var version = "0.7.1";

// src/errors.ts
var dist_BaseError = class extends Error {
  constructor(shortMessage, args = {}) {
    const details = args.cause instanceof dist_BaseError ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
    const docsPath = args.cause instanceof dist_BaseError ? args.cause.docsPath || args.docsPath : args.docsPath;
    const message = [
      shortMessage || "An error occurred.",
      "",
      ...args.metaMessages ? [...args.metaMessages, ""] : [],
      ...docsPath ? [`Docs: https://abitype.dev${docsPath}`] : [],
      ...details ? [`Details: ${details}`] : [],
      `Version: ${dist_name}@${version}`
    ].join("\n");
    super(message);
    chunk_NHABU752_publicField(this, "details");
    chunk_NHABU752_publicField(this, "docsPath");
    chunk_NHABU752_publicField(this, "metaMessages");
    chunk_NHABU752_publicField(this, "shortMessage");
    chunk_NHABU752_publicField(this, "name", "AbiTypeError");
    if (args.cause)
      this.cause = args.cause;
    this.details = details;
    this.docsPath = docsPath;
    this.metaMessages = args.metaMessages;
    this.shortMessage = shortMessage;
  }
};

// src/narrow.ts
function narrow(value) {
  return value;
}

// src/human-readable/runtime/signatures.ts
var errorSignatureRegex = /^error (?<name>[a-zA-Z0-9_]+)\((?<parameters>.*?)\)$/;
function isErrorSignature(signature) {
  return errorSignatureRegex.test(signature);
}
function execErrorSignature(signature) {
  return execTyped(
    errorSignatureRegex,
    signature
  );
}
var eventSignatureRegex = /^event (?<name>[a-zA-Z0-9_]+)\((?<parameters>.*?)\)$/;
function isEventSignature(signature) {
  return eventSignatureRegex.test(signature);
}
function execEventSignature(signature) {
  return execTyped(
    eventSignatureRegex,
    signature
  );
}
var functionSignatureRegex = /^function (?<name>[a-zA-Z0-9_]+)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns \((?<returns>.*?)\))?$/;
function isFunctionSignature(signature) {
  return functionSignatureRegex.test(signature);
}
function execFunctionSignature(signature) {
  return execTyped(functionSignatureRegex, signature);
}
var structSignatureRegex = /^struct (?<name>[a-zA-Z0-9_]+) \{(?<properties>.*?)\}$/;
function isStructSignature(signature) {
  return structSignatureRegex.test(signature);
}
function execStructSignature(signature) {
  return execTyped(
    structSignatureRegex,
    signature
  );
}
var constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function isConstructorSignature(signature) {
  return constructorSignatureRegex.test(signature);
}
function execConstructorSignature(signature) {
  return execTyped(constructorSignatureRegex, signature);
}
var fallbackSignatureRegex = /^fallback\(\)$/;
function isFallbackSignature(signature) {
  return fallbackSignatureRegex.test(signature);
}
var receiveSignatureRegex = /^receive\(\) external payable$/;
function isReceiveSignature(signature) {
  return receiveSignatureRegex.test(signature);
}
var modifiers = /* @__PURE__ */ new Set([
  "memory",
  "indexed",
  "storage",
  "calldata"
]);
var eventModifiers = /* @__PURE__ */ new Set(["indexed"]);
var functionModifiers = /* @__PURE__ */ new Set([
  "calldata",
  "memory",
  "storage"
]);

// src/human-readable/runtime/cache.ts
function getParameterCacheKey(param, type) {
  if (type)
    return `${type}:${param}`;
  return param;
}
var parameterCache = /* @__PURE__ */ new Map([
  // Unnamed
  ["address", { type: "address" }],
  ["bool", { type: "bool" }],
  ["bytes", { type: "bytes" }],
  ["bytes32", { type: "bytes32" }],
  ["int", { type: "int256" }],
  ["int256", { type: "int256" }],
  ["string", { type: "string" }],
  ["uint", { type: "uint256" }],
  ["uint8", { type: "uint8" }],
  ["uint16", { type: "uint16" }],
  ["uint24", { type: "uint24" }],
  ["uint32", { type: "uint32" }],
  ["uint64", { type: "uint64" }],
  ["uint96", { type: "uint96" }],
  ["uint112", { type: "uint112" }],
  ["uint160", { type: "uint160" }],
  ["uint192", { type: "uint192" }],
  ["uint256", { type: "uint256" }],
  // Named
  ["address owner", { type: "address", name: "owner" }],
  ["address to", { type: "address", name: "to" }],
  ["bool approved", { type: "bool", name: "approved" }],
  ["bytes _data", { type: "bytes", name: "_data" }],
  ["bytes data", { type: "bytes", name: "data" }],
  ["bytes signature", { type: "bytes", name: "signature" }],
  ["bytes32 hash", { type: "bytes32", name: "hash" }],
  ["bytes32 r", { type: "bytes32", name: "r" }],
  ["bytes32 root", { type: "bytes32", name: "root" }],
  ["bytes32 s", { type: "bytes32", name: "s" }],
  ["string name", { type: "string", name: "name" }],
  ["string symbol", { type: "string", name: "symbol" }],
  ["string tokenURI", { type: "string", name: "tokenURI" }],
  ["uint tokenId", { type: "uint256", name: "tokenId" }],
  ["uint8 v", { type: "uint8", name: "v" }],
  ["uint256 balance", { type: "uint256", name: "balance" }],
  ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
  ["uint256 value", { type: "uint256", name: "value" }],
  // Indexed
  [
    "event:address indexed from",
    { type: "address", name: "from", indexed: true }
  ],
  ["event:address indexed to", { type: "address", name: "to", indexed: true }],
  [
    "event:uint indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: true }
  ],
  [
    "event:uint256 indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: true }
  ]
]);

// src/human-readable/runtime/utils.ts
function parseSignature(signature, structs = {}) {
  if (isFunctionSignature(signature)) {
    const match = execFunctionSignature(signature);
    if (!match)
      throw new dist_BaseError("Invalid function signature.", {
        details: signature
      });
    const inputParams = splitParameters(match.parameters);
    const inputs = [];
    const inputLength = inputParams.length;
    for (let i = 0; i < inputLength; i++) {
      inputs.push(
        parseAbiParameter(inputParams[i], {
          modifiers: functionModifiers,
          structs,
          type: "function"
        })
      );
    }
    const outputs = [];
    if (match.returns) {
      const outputParams = splitParameters(match.returns);
      const outputLength = outputParams.length;
      for (let i = 0; i < outputLength; i++) {
        outputs.push(
          parseAbiParameter(outputParams[i], {
            modifiers: functionModifiers,
            structs,
            type: "function"
          })
        );
      }
    }
    return {
      name: match.name,
      type: "function",
      stateMutability: match.stateMutability ?? "nonpayable",
      inputs,
      outputs
    };
  }
  if (isEventSignature(signature)) {
    const match = execEventSignature(signature);
    if (!match)
      throw new dist_BaseError("Invalid event signature.", {
        details: signature
      });
    const params = splitParameters(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for (let i = 0; i < length; i++) {
      abiParameters.push(
        parseAbiParameter(params[i], {
          modifiers: eventModifiers,
          structs,
          type: "event"
        })
      );
    }
    return { name: match.name, type: "event", inputs: abiParameters };
  }
  if (isErrorSignature(signature)) {
    const match = execErrorSignature(signature);
    if (!match)
      throw new dist_BaseError("Invalid error signature.", {
        details: signature
      });
    const params = splitParameters(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for (let i = 0; i < length; i++) {
      abiParameters.push(
        parseAbiParameter(params[i], { structs, type: "error" })
      );
    }
    return { name: match.name, type: "error", inputs: abiParameters };
  }
  if (isConstructorSignature(signature)) {
    const match = execConstructorSignature(signature);
    if (!match)
      throw new dist_BaseError("Invalid constructor signature.", {
        details: signature
      });
    const params = splitParameters(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for (let i = 0; i < length; i++) {
      abiParameters.push(
        parseAbiParameter(params[i], { structs, type: "constructor" })
      );
    }
    return {
      type: "constructor",
      stateMutability: match.stateMutability ?? "nonpayable",
      inputs: abiParameters
    };
  }
  if (isFallbackSignature(signature))
    return { type: "fallback" };
  if (isReceiveSignature(signature))
    return {
      type: "receive",
      stateMutability: "payable"
    };
  throw new dist_BaseError("Unknown signature.", {
    details: signature
  });
}
var abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z0-9_]+?)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z0-9_]+))?$/;
var abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z0-9_]+))?$/;
var dynamicIntegerRegex = /^u?int$/;
function parseAbiParameter(param, options) {
  const parameterCacheKey = getParameterCacheKey(param, options?.type);
  if (parameterCache.has(parameterCacheKey))
    return parameterCache.get(parameterCacheKey);
  const isTuple = isTupleRegex.test(param);
  const match = execTyped(
    isTuple ? abiParameterWithTupleRegex : abiParameterWithoutTupleRegex,
    param
  );
  if (!match)
    throw new dist_BaseError("Invalid ABI parameter.", {
      details: param
    });
  if (match.name && isSolidityKeyword(match.name))
    throw new dist_BaseError("Invalid ABI parameter.", {
      details: param,
      metaMessages: [
        `"${match.name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
      ]
    });
  const name2 = match.name ? { name: match.name } : {};
  const indexed = match.modifier === "indexed" ? { indexed: true } : {};
  const structs = options?.structs ?? {};
  let type;
  let components = {};
  if (isTuple) {
    type = "tuple";
    const params = splitParameters(match.type);
    const components_ = [];
    const length = params.length;
    for (let i = 0; i < length; i++) {
      components_.push(parseAbiParameter(params[i], { structs }));
    }
    components = { components: components_ };
  } else if (match.type in structs) {
    type = "tuple";
    components = { components: structs[match.type] };
  } else if (dynamicIntegerRegex.test(match.type)) {
    type = `${match.type}256`;
  } else {
    type = match.type;
    if (!(options?.type === "struct") && !isSolidityType(type))
      throw new dist_BaseError("Unknown type.", {
        metaMessages: [`Type "${type}" is not a valid ABI type.`]
      });
  }
  if (match.modifier) {
    if (!options?.modifiers?.has?.(match.modifier))
      throw new dist_BaseError("Invalid ABI parameter.", {
        details: param,
        metaMessages: [
          `Modifier "${match.modifier}" not allowed${options?.type ? ` in "${options.type}" type` : ""}.`
        ]
      });
    if (functionModifiers.has(match.modifier) && !isValidDataLocation(type, !!match.array))
      throw new dist_BaseError("Invalid ABI parameter.", {
        details: param,
        metaMessages: [
          `Modifier "${match.modifier}" not allowed${options?.type ? ` in "${options.type}" type` : ""}.`,
          `Data location can only be specified for array, struct, or mapping types, but "${match.modifier}" was given.`
        ]
      });
  }
  const abiParameter = {
    type: `${type}${match.array ?? ""}`,
    ...name2,
    ...indexed,
    ...components
  };
  parameterCache.set(parameterCacheKey, abiParameter);
  return abiParameter;
}
function splitParameters(params, result = [], current = "", depth = 0) {
  if (params === "") {
    if (current === "")
      return result;
    if (depth !== 0)
      throw new dist_BaseError("Unbalanced parentheses.", {
        metaMessages: [
          `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
        ],
        details: `Depth "${depth}"`
      });
    return [...result, current.trim()];
  }
  const length = params.length;
  for (let i = 0; i < length; i++) {
    const char = params[i];
    const tail = params.slice(i + 1);
    switch (char) {
      case ",":
        return depth === 0 ? splitParameters(tail, [...result, current.trim()]) : splitParameters(tail, result, `${current}${char}`, depth);
      case "(":
        return splitParameters(tail, result, `${current}${char}`, depth + 1);
      case ")":
        return splitParameters(tail, result, `${current}${char}`, depth - 1);
      default:
        return splitParameters(tail, result, `${current}${char}`, depth);
    }
  }
  return [];
}
function isSolidityType(type) {
  return type === "address" || type === "bool" || type === "function" || type === "string" || chunk_WP7KDV47_bytesRegex.test(type) || chunk_WP7KDV47_integerRegex.test(type);
}
var protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function isSolidityKeyword(name2) {
  return name2 === "address" || name2 === "bool" || name2 === "function" || name2 === "string" || name2 === "tuple" || chunk_WP7KDV47_bytesRegex.test(name2) || chunk_WP7KDV47_integerRegex.test(name2) || protectedKeywordsRegex.test(name2);
}
function isValidDataLocation(type, isArray) {
  return isArray || type === "bytes" || type === "string" || type === "tuple";
}

// src/human-readable/runtime/structs.ts
function parseStructs(signatures) {
  const shallowStructs = {};
  const signaturesLength = signatures.length;
  for (let i = 0; i < signaturesLength; i++) {
    const signature = signatures[i];
    if (!isStructSignature(signature))
      continue;
    const match = execStructSignature(signature);
    if (!match)
      throw new dist_BaseError("Invalid struct signature.", {
        details: signature
      });
    const properties = match.properties.split(";");
    const components = [];
    const propertiesLength = properties.length;
    for (let k = 0; k < propertiesLength; k++) {
      const property = properties[k];
      const trimmed = property.trim();
      if (!trimmed)
        continue;
      const abiParameter = parseAbiParameter(trimmed, {
        type: "struct"
      });
      components.push(abiParameter);
    }
    if (!components.length)
      throw new dist_BaseError("Invalid struct signature.", {
        details: signature,
        metaMessages: ["No properties exist."]
      });
    shallowStructs[match.name] = components;
  }
  const resolvedStructs = {};
  const entries = Object.entries(shallowStructs);
  const entriesLength = entries.length;
  for (let i = 0; i < entriesLength; i++) {
    const [name2, parameters] = entries[i];
    resolvedStructs[name2] = resolveStructs(parameters, shallowStructs);
  }
  return resolvedStructs;
}
var typeWithoutTupleRegex = /^(?<type>[a-zA-Z0-9_]+?)(?<array>(?:\[\d*?\])+?)?$/;
function resolveStructs(abiParameters, structs, ancestors = /* @__PURE__ */ new Set()) {
  const components = [];
  const length = abiParameters.length;
  for (let i = 0; i < length; i++) {
    const abiParameter = abiParameters[i];
    const isTuple = isTupleRegex.test(abiParameter.type);
    if (isTuple)
      components.push(abiParameter);
    else {
      const match = execTyped(
        typeWithoutTupleRegex,
        abiParameter.type
      );
      if (!match?.type)
        throw new dist_BaseError("Invalid ABI parameter.", {
          details: JSON.stringify(abiParameter, null, 2),
          metaMessages: ["ABI parameter type is invalid."]
        });
      const { array, type } = match;
      if (type in structs) {
        if (ancestors.has(type))
          throw new dist_BaseError("Circular reference detected.", {
            metaMessages: [`Struct "${type}" is a circular reference.`]
          });
        components.push({
          ...abiParameter,
          type: `tuple${array ?? ""}`,
          components: resolveStructs(
            structs[type] ?? [],
            structs,
            /* @__PURE__ */ new Set([...ancestors, type])
          )
        });
      } else {
        if (isSolidityType(type))
          components.push(abiParameter);
        else
          throw new dist_BaseError("Unknown type.", {
            metaMessages: [
              `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
          });
      }
    }
  }
  return components;
}

// src/human-readable/parseAbi.ts
function parseAbi(signatures) {
  const structs = parseStructs(signatures);
  const abi = [];
  const length = signatures.length;
  for (let i = 0; i < length; i++) {
    const signature = signatures[i];
    if (isStructSignature(signature))
      continue;
    abi.push(parseSignature(signature, structs));
  }
  return abi;
}

// src/human-readable/parseAbiItem.ts
function parseAbiItem(signature) {
  let abiItem;
  if (typeof signature === "string")
    abiItem = parseSignature(signature);
  else {
    const structs = parseStructs(signature);
    const length = signature.length;
    for (let i = 0; i < length; i++) {
      const signature_ = signature[i];
      if (isStructSignature(signature_))
        continue;
      abiItem = parseSignature(signature_, structs);
      break;
    }
  }
  if (!abiItem)
    throw new dist_BaseError("Failed to parse ABI item.", {
      details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
      docsPath: "/api/human.html#parseabiitem-1"
    });
  return abiItem;
}

// src/human-readable/parseAbiParameter.ts
function parseAbiParameter2(param) {
  let abiParameter;
  if (typeof param === "string")
    abiParameter = parseAbiParameter(param, {
      modifiers
    });
  else {
    const structs = parseStructs(param);
    const length = param.length;
    for (let i = 0; i < length; i++) {
      const signature = param[i];
      if (isStructSignature(signature))
        continue;
      abiParameter = parseAbiParameter(signature, { modifiers, structs });
      break;
    }
  }
  if (!abiParameter)
    throw new dist_BaseError("Failed to parse ABI parameter.", {
      details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
      docsPath: "/api/human.html#parseabiparameter-1"
    });
  return abiParameter;
}

// src/human-readable/parseAbiParameters.ts
function parseAbiParameters(params) {
  const abiParameters = [];
  if (typeof params === "string") {
    const parameters = splitParameters(params);
    const length = parameters.length;
    for (let i = 0; i < length; i++) {
      abiParameters.push(parseAbiParameter(parameters[i], { modifiers }));
    }
  } else {
    const structs = parseStructs(params);
    const length = params.length;
    for (let i = 0; i < length; i++) {
      const signature = params[i];
      if (isStructSignature(signature))
        continue;
      const parameters = splitParameters(signature);
      const length2 = parameters.length;
      for (let k = 0; k < length2; k++) {
        abiParameters.push(
          parseAbiParameter(parameters[k], { modifiers, structs })
        );
      }
    }
  }
  if (abiParameters.length === 0)
    throw new dist_BaseError("Failed to parse ABI parameters.", {
      details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
      docsPath: "/api/human.html#parseabiparameters-1"
    });
  return abiParameters;
}


;// CONCATENATED MODULE: ./node_modules/@everipedia/web3-signer/node_modules/viem/dist/utils/index.mjs


//# sourceMappingURL=index.mjs.map

/***/ })

}]);